import Link from '../utility/CustomLink'
import {
  Link as MuiLink,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from '@material-ui/core'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const getFaqLocal = (lang) => {
  const trans = (contentTh, contentEn) => {
    if (lang === 'en') return contentEn
    return contentTh
  }

  const courierLogoStyle = {
    width: '100%',
    maxWidth: 150,
    maxHeight: 50,
    objectFit: 'contain',
    minWidth: 100,
    margin: 0,
  }
  const bankIconStyle = { width: 30, height: 30, margin: 5 }

  return {
    [trans('ข้อมูลทั่วไป', 'General Information')]: {
      subtitle: trans(
        'ข้อมูลพื้นฐานสำหรับเว็บไซต์',
        'Basic information about the website'
      ),
      [trans('บริการของเราคืออะไร?', 'What is our service?')]: trans(
        <>
          <p>
            คือ ชิปป๊อป เราเป็นระบบบริการจองขนส่งออนไลน์
            เพื่อให้ท่านสามารถใช้บริการขนส่งได้อย่างสะดวกและรวดเร็ว
            สามารถเลือกจองขนส่งได้ตามที่คุณต้องการ
          </p>
          <p>
            สามารถเปรียบเทียบราคาค่าจัดส่งสินค้า ชำระเงินออนไลน์ได้ง่ายๆ
            ผ่านบัตรเครดิตและบัตรเดบิต สามารถออกหมายเลขพัสดุ
            และพิมพ์ใบปะหน้าพัสดุได้จากระบบทันที
            รวมถึงการติดตามสถานะพัสดุได้ผ่านระบบอีกด้วย
            ทำให้ท่านสามารถควบคุมค่าใช้จ่ายและวางแผนค่าขนส่งล่วงหน้าได้อย่างง่ายดาย
          </p>
          <p>
            นอกจากนี้ยังมีบริการรับของถึงบ้าน หรือไม่ต้องรับคิวเข้าแถว
            ส่งผลดีในการบริหารจัดการเวลาและช่วยลดต้นทุนในการเดินทาง
          </p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/WAwegM00OgM"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen=""
          />
        </>,
        <>
          <p>
            This is SHIPPOP. We are an online shipping booking service system
            that allows you to use shipping services conveniently and quickly.
            You can choose the courier you want.
          </p>
          <p>
            You can compare shipping prices, pay online easily via credit card
            and debit card, issue parcel numbers and print parcel labels from
            the system immediately, including tracking the parcel status through
            the system. This allows you to control your expenses and plan your
            shipping costs in advance easily.
          </p>
          <p>
            There is also a home pickup service, so you do not have to wait in
            line, which is good for time management and helps reduce travel
            costs.
          </p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/WAwegM00OgM"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen=""
          />
        </>
      ),
      [trans('สมัครใช้บริการอย่างไร?', 'How do I sign up for the service?')]: trans(
        <>
          <p>
            การลงทะเบียนใช้งานผ่านหน้าเว็บไชต์ www.shippop.com
            สามารถเข้าสู่ระบบได้{' '}
            <Link href="/login">
              <MuiLink>ที่นี่</MuiLink>
            </Link>{' '}
            โดยสามารถลงทะเบียนได้ 2 วิธี
          </p>
          <ol>
            <li>
              คลิกที่ปุ่ม Facebook ยืนยันการขอใช้งาน
              และเริ่มใช้งานกับเราได้เลย
            </li>
            <li>
              เข้าสู่ระบบโดยการสร้างบัญชีผู้ใช้ใหม่ง่ายๆด้วย E-mail ของคุณ{' '}
              <Link href="/register">
                <MuiLink>ที่นี่</MuiLink>
              </Link>
            </li>
            <ol>
              <li>
                กรอกข้อมูล
                <img
                  src="/static/img/faq/register-1.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
              <li>
                ยืนยันตัวตน ผ่านทางอีเมล
                <img
                  src="/static/img/faq/register-2.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
              <li>
                ยืนยันตัวตนเรียบร้อย และเริ่มต้นใช้งานที่ปุ่ม
                "เริ่มต้นการใช้งาน" ด้านขวามือ
                <img
                  src="/static/img/faq/register-3.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
              <li>
                เข้าสู่ระบบชิปป๊อปเรียบร้อย
                <img
                  src="/static/img/faq/register-4.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
            </ol>
          </ol>
        </>,
        <>
          <p>
            Registration is done through the website www.shippop.com. You can
            log in{' '}
            <Link href="/login">
              <MuiLink>here</MuiLink>
            </Link>{' '}
            and there are 2 ways to register.
          </p>
          <ol>
            <li>
              Click the Facebook button to confirm your request and start using
              our service right away.
            </li>
            <li>
              Log in by easily creating a new user account with your E-mail{' '}
              <Link href="/register">
                <MuiLink>here</MuiLink>
              </Link>
            </li>
            <ol>
              <li>
                Fill in the information
                <img
                  src="/static/img/faq/register-1.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
              <li>
                Verify your identity via email
                <img
                  src="/static/img/faq/register-2.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
              <li>
                Once your identity is verified, start using the service by
                clicking the "Get Started" button on the right
                <img
                  src="/static/img/faq/register-3.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
              <li>
                You have successfully logged into SHIPPOP
                <img
                  src="/static/img/faq/register-4.png"
                  alt="ขั้นตอนการสมัคร SHIPPOP"
                />
              </li>
            </ol>
          </ol>
        </>
      ),
      [trans('ลูกค้ารายเดือนคืออะไร', 'What is a monthly customer?')]: trans(
        <>
          <p>
            คือ ลูกค้าที่มียอดขั้นต่ำในการจัดส่งไม่ต่ำกว่า 1,000 ชิ้นต่อเดือน
            และมีการใช้งานอย่างต่อเนื่องตลอดทุกเดือน
            ไม่ต้องกรอกน้ำหนักและขนาดของพัสดุ
            ค่าขนส่งชำระตามที่ใช้งานจริงเท่านั้น หรือหากมีเว็บไซต์
            สามารถใช้งานผ่านการเชื่อมต่อระบบ API ได้ทันที
          </p>
          <p>
            การสมัครใช้งานเป็นลูกค้ารายเดือน
            ลูกค้าจะต้องทำการสมัครสมาชิกผ่านพนักงานฝ่ายขายของบริษัทชิปป๊อปเท่านั้น
            โดยต้องเตรียมเอกสารประกอบการสมัครดังนี้
          </p>
          <br />
          <p>
            <strong># นิติบุคคล</strong>
          </p>
          <ul>
            <li>หนังสือรับรองบริษัท</li>
            <li>สำเนาบัตรประชาชนของผู้มีอำนาจในหนังสือรับรอง</li>
            <li>ภพ.20 (ถ้ามี)</li>
            <li>สำเนาสมุดบัญชีธนาคารย้อนหลังอย่างน้อย 3 เดือน</li>
            <li>
              สำเนาหน้าบัญชีธนาคารโดยมีชื่อบัญชีตรงกันกับชื่อบริษัท เท่านั้น
            </li>
          </ul>
          <br />
          <p>
            <strong># บุคคลธรรมดา</strong>
          </p>
          <ul>
            <li>สำเนาบัตรประชาชน</li>
            <li>สำเนาทะเบียนบ้าน</li>
            <li>สำเนาสมุดบัญชีธนาคารย้อนหลังอย่างน้อย 3 เดือน</li>
            <li>
              สำเนาหน้าบัญชีธนาคารโดยมีชื่อบัญชีตรงกันกับสำเนาบัตรประชาชน
              (กรณีต้องการใช้บริการเก็บเงินปลายทาง COD)
            </li>
          </ul>
          <p style={{ color: 'red' }}>
            * เอกสารทุกฉบับ รบกวนเซ็นสำเนาถูกต้องและประทับตราบริษัท
          </p>
        </>,
        <>
          <p>
            A monthly customer is a customer with a minimum shipping volume of
            no less than 1,000 pieces per month and continuous usage every
            month. You do not need to fill in the weight and size of the parcel;
            shipping fees are charged based on actual usage only. Or if you have
            a website, you can use it through the API connection immediately.
          </p>
          <p>
            To sign up as a monthly customer, the customer must register through
            a SHIPPOP sales representative only, and must prepare the following
            documents for the application.
          </p>
          <br />
          <p>
            <strong># Juristic person</strong>
          </p>
          <ul>
            <li>Company certificate</li>
            <li>Copy of the ID card of the authorized person in the certificate</li>
            <li>Por Por 20 (if any)</li>
            <li>Copy of bank account book for at least the past 3 months</li>
            <li>
              Copy of the bank account front page with the account name matching
              the company name only
            </li>
          </ul>
          <br />
          <p>
            <strong># Individual</strong>
          </p>
          <ul>
            <li>Copy of ID card</li>
            <li>Copy of house registration</li>
            <li>Copy of bank account book for at least the past 3 months</li>
            <li>
              Copy of the bank account front page with the account name matching
              the copy of the ID card (in case you want to use the Cash on
              Delivery COD service)
            </li>
          </ul>
          <p style={{ color: 'red' }}>
            * For all documents, please sign a certified true copy and stamp the
            company seal.
          </p>
        </>
      ),
      [trans('พันธมิตรที่จัดส่งกับทางชิปป๊อป', 'Delivery partners with SHIPPOP')]: trans(
        <>
          <p>ขนส่งที่ร่วมจัดส่งกับทางชิปป๊อป มีดังนี้</p>
          <div style={{ overflowX: 'scroll' }}>
            <table
              style={{
                width: '100%',
                overflowX: 'scroll',
                border: '1px solid grey',
              }}
            >
              <tr>
                <th>CODE</th>
                <th>Logo</th>
                <th>ชื่อภาษาไทย</th>
                <th>ชื่อภาษาอังกฤษ</th>
              </tr>
              <tr>
                <td>THP</td>
                <td>
                  <img
                    src="/static/img/couriers/thailandpost_ems.png"
                    alt="ไปรษณีย์ไทย EMS"
                    style={courierLogoStyle}
                  />
                </td>
                <td>ไปรษณีย์ไทย EMS</td>
                <td>Thailand Post (EMS)</td>
              </tr>
              <tr>
                <td>TP2</td>
                <td>
                  <img
                    src="/static/img/couriers/thipost.png"
                    alt="ไปรษณีย์ไทย ลงทะเบียน"
                    style={courierLogoStyle}
                  />
                </td>
                <td>ไปรษณีย์ไทย ลงทะเบียน</td>
                <td>Thailand Post (Register)</td>
              </tr>
              <tr>
                <td>NJV</td>
                <td>
                  <img
                    src="/static/img/couriers/ninjavan.svg"
                    alt="นินจาแวน"
                    style={courierLogoStyle}
                  />
                </td>
                <td>นินจาแวน</td>
                <td>Ninjavan</td>
              </tr>
              <tr>
                <td>SCG</td>
                <td>
                  <img
                    src="/static/img/couriers/scg.png"
                    alt="เอสซีจี ยามาโตะ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เอสซีจี ยามาโตะ เอ็กซ์เพรส</td>
                <td>SCG Yamato Express</td>
              </tr>
              <tr>
                <td>SCGC</td>
                <td>
                  <img
                    src="/static/img/couriers/scg-cool.png"
                    alt="เอสซีจี เอ็กซ์เพรส ชิล (สินค้าแช่เย็น อุณหภูมิประมาณ 0 °c ถึง 8 °c)"
                    style={courierLogoStyle}
                  />
                </td>
                <td>
                  เอสซีจี เอ็กซ์เพรส ชิล (สินค้าแช่เย็น อุณหภูมิประมาณ 0 °c
                  ถึง 8 °c)
                </td>
                <td>
                  SCG Express Chilled (The temperature is about 0 °c to 8 °c)
                </td>
              </tr>
              <tr>
                <td>SCGF</td>
                <td>
                  <img
                    src="/static/img/couriers/scg-frozen.png"
                    alt="เอสซีจี เอ็กซ์เพรส โฟรเซิน (สินค้าแช่แข็ง อุณหภูมิประมาณ 0 °c ถึง -15 °c)"
                    style={courierLogoStyle}
                  />
                </td>
                <td>
                  เอสซีจี เอ็กซ์เพรส โฟรเซิน (สินค้าแช่แข็ง อุณหภูมิประมาณ 0
                  °c ถึง -15 °c)
                </td>
                <td>
                  SCG Express Frozen (The temperature is about 0 °c to -15 °c)
                </td>
              </tr>
              <tr>
                <td>KRY</td>
                <td>
                  <img
                    src="/static/img/couriers/kerry2.png"
                    alt="เคอรี่ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เคอรี่ เอ็กซ์เพรส</td>
                <td>Kerry Express</td>
              </tr>
              <tr>
                <td>SKT</td>
                <td>
                  <img
                    src="/static/img/couriers/skootar.png"
                    alt="สกู๊ตตาร์"
                    style={courierLogoStyle}
                  />
                </td>
                <td>สกู๊ตตาร์</td>
                <td>Skootar</td>
              </tr>
              <tr>
                <td>LLM</td>
                <td>
                  <img
                    src="/static/img/couriers/lalamove2.png"
                    alt="ลาล่ามูฟ"
                    style={courierLogoStyle}
                  />
                </td>
                <td>ลาล่ามูฟ</td>
                <td>Lalamove</td>
              </tr>
              <tr>
                <td>FLE</td>
                <td>
                  <img
                    src="/static/img/couriers/flash.png"
                    alt="แฟลช เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>แฟลช เอ็กซ์เพรส</td>
                <td>Flash Express</td>
              </tr>
              <tr>
                <td>FLEB</td>
                <td>
                  <img
                    src="/static/img/couriers/flash_express_bulky.png"
                    alt="แฟลช เอ็กซ์เพรส (ขนส่งชิ้นใหญ่)"
                    style={courierLogoStyle}
                  />
                </td>
                <td>แฟลช เอ็กซ์เพรส (ขนส่งชิ้นใหญ่)</td>
                <td>Flash Bulky</td>
              </tr>
              <tr>
                <td>JWDC</td>
                <td>
                  <img
                    src="/static/img/couriers/JWDC.png"
                    alt="แฟลช เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เจดับเบิ้ลยูดี ชิลล์ เอ็กซ์เพรส</td>
                <td>JWD Chilled Express</td>
              </tr>
              <tr>
                <td>JWDF</td>
                <td>
                  <img
                    src="/static/img/couriers/JWDF.png"
                    alt="เจดับเบิ้ลยูดี โฟรเซ่น เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เจดับเบิ้ลยูดี โฟรเซ่น เอ็กซ์เพรส</td>
                <td>JWD Frozen Express</td>
              </tr>
              <tr>
                <td>BEST</td>
                <td>
                  <img
                    src="/static/img/couriers/best2.png"
                    alt="เบสท์ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เบสท์ เอ็กซ์เพรส</td>
                <td>Best Express</td>
              </tr>
              <tr>
                <td>MAKESEND</td>
                <td>
                  <img
                    src="/static/img/couriers/MSE.png"
                    alt="เบสท์ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เมคเซ็นด์</td>
                <td>Makesend</td>
              </tr>
              <tr>
                <td>ARM</td>
                <td>
                  <img
                    src="/static/img/couriers/aramex.png"
                    alt="เบสท์ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>อาราเม็ก</td>
                <td>Aramex</td>
              </tr>
            </table>
          </div>
        </>,
        <>
          <p>The couriers partnering with SHIPPOP are as follows</p>
          <div style={{ overflowX: 'scroll' }}>
            <table
              style={{
                width: '100%',
                overflowX: 'scroll',
                border: '1px solid grey',
              }}
            >
              <tr>
                <th>CODE</th>
                <th>Logo</th>
                <th>Thai Name</th>
                <th>English Name</th>
              </tr>
              <tr>
                <td>THP</td>
                <td>
                  <img
                    src="/static/img/couriers/thailandpost_ems.png"
                    alt="ไปรษณีย์ไทย EMS"
                    style={courierLogoStyle}
                  />
                </td>
                <td>ไปรษณีย์ไทย EMS</td>
                <td>Thailand Post (EMS)</td>
              </tr>
              <tr>
                <td>TP2</td>
                <td>
                  <img
                    src="/static/img/couriers/thipost.png"
                    alt="ไปรษณีย์ไทย ลงทะเบียน"
                    style={courierLogoStyle}
                  />
                </td>
                <td>ไปรษณีย์ไทย ลงทะเบียน</td>
                <td>Thailand Post (Register)</td>
              </tr>
              <tr>
                <td>NJV</td>
                <td>
                  <img
                    src="/static/img/couriers/ninjavan.svg"
                    alt="นินจาแวน"
                    style={courierLogoStyle}
                  />
                </td>
                <td>นินจาแวน</td>
                <td>Ninjavan</td>
              </tr>
              <tr>
                <td>SCG</td>
                <td>
                  <img
                    src="/static/img/couriers/scg.png"
                    alt="เอสซีจี ยามาโตะ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เอสซีจี ยามาโตะ เอ็กซ์เพรส</td>
                <td>SCG Yamato Express</td>
              </tr>
              <tr>
                <td>SCGC</td>
                <td>
                  <img
                    src="/static/img/couriers/scg-cool.png"
                    alt="เอสซีจี เอ็กซ์เพรส ชิล (สินค้าแช่เย็น อุณหภูมิประมาณ 0 °c ถึง 8 °c)"
                    style={courierLogoStyle}
                  />
                </td>
                <td>
                  เอสซีจี เอ็กซ์เพรส ชิล (สินค้าแช่เย็น อุณหภูมิประมาณ 0 °c
                  ถึง 8 °c)
                </td>
                <td>
                  SCG Express Chilled (The temperature is about 0 °c to 8 °c)
                </td>
              </tr>
              <tr>
                <td>SCGF</td>
                <td>
                  <img
                    src="/static/img/couriers/scg-frozen.png"
                    alt="เอสซีจี เอ็กซ์เพรส โฟรเซิน (สินค้าแช่แข็ง อุณหภูมิประมาณ 0 °c ถึง -15 °c)"
                    style={courierLogoStyle}
                  />
                </td>
                <td>
                  เอสซีจี เอ็กซ์เพรส โฟรเซิน (สินค้าแช่แข็ง อุณหภูมิประมาณ 0
                  °c ถึง -15 °c)
                </td>
                <td>
                  SCG Express Frozen (The temperature is about 0 °c to -15 °c)
                </td>
              </tr>
              <tr>
                <td>KRY</td>
                <td>
                  <img
                    src="/static/img/couriers/kerry2.png"
                    alt="เคอรี่ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เคอรี่ เอ็กซ์เพรส</td>
                <td>Kerry Express</td>
              </tr>
              <tr>
                <td>SKT</td>
                <td>
                  <img
                    src="/static/img/couriers/skootar.png"
                    alt="สกู๊ตตาร์"
                    style={courierLogoStyle}
                  />
                </td>
                <td>สกู๊ตตาร์</td>
                <td>Skootar</td>
              </tr>
              <tr>
                <td>LLM</td>
                <td>
                  <img
                    src="/static/img/couriers/lalamove2.png"
                    alt="ลาล่ามูฟ"
                    style={courierLogoStyle}
                  />
                </td>
                <td>ลาล่ามูฟ</td>
                <td>Lalamove</td>
              </tr>
              <tr>
                <td>FLE</td>
                <td>
                  <img
                    src="/static/img/couriers/flash.png"
                    alt="แฟลช เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>แฟลช เอ็กซ์เพรส</td>
                <td>Flash Express</td>
              </tr>
              <tr>
                <td>FLEB</td>
                <td>
                  <img
                    src="/static/img/couriers/flash_express_bulky.png"
                    alt="แฟลช เอ็กซ์เพรส (ขนส่งชิ้นใหญ่)"
                    style={courierLogoStyle}
                  />
                </td>
                <td>แฟลช เอ็กซ์เพรส (ขนส่งชิ้นใหญ่)</td>
                <td>Flash Bulky</td>
              </tr>
              <tr>
                <td>JWDC</td>
                <td>
                  <img
                    src="/static/img/couriers/JWDC.png"
                    alt="แฟลช เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เจดับเบิ้ลยูดี ชิลล์ เอ็กซ์เพรส</td>
                <td>JWD Chilled Express</td>
              </tr>
              <tr>
                <td>JWDF</td>
                <td>
                  <img
                    src="/static/img/couriers/JWDF.png"
                    alt="เจดับเบิ้ลยูดี โฟรเซ่น เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เจดับเบิ้ลยูดี โฟรเซ่น เอ็กซ์เพรส</td>
                <td>JWD Frozen Express</td>
              </tr>
              <tr>
                <td>BEST</td>
                <td>
                  <img
                    src="/static/img/couriers/best2.png"
                    alt="เบสท์ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เบสท์ เอ็กซ์เพรส</td>
                <td>Best Express</td>
              </tr>
              <tr>
                <td>MAKESEND</td>
                <td>
                  <img
                    src="/static/img/couriers/MSE.png"
                    alt="เบสท์ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>เมคเซ็นด์</td>
                <td>Makesend</td>
              </tr>
              <tr>
                <td>ARM</td>
                <td>
                  <img
                    src="/static/img/couriers/aramex.png"
                    alt="เบสท์ เอ็กซ์เพรส"
                    style={courierLogoStyle}
                  />
                </td>
                <td>อาราเม็ก</td>
                <td>Aramex</td>
              </tr>
            </table>
          </div>
        </>
      ),
      [trans(
        'ดาวน์โหลดโลโก้ CI Logo และ Key Visual ชิปป๊อป',
        'Download SHIPPOP Logo, CI Logo and Key Visual'
      )]: trans(
        <>
          <p>
            เว็บไซต์ SHIPPOP อนุญาตให้ผู้เข้าชมเว็บไซต์ ดาวน์โหลด Logo และ CI
            Logo ของเว็บไซต์ เพื่อนำไปใช้อ้างอิงทางสื่อสิ่งพิมพ์ สื่อเว็บไซต์
            การจัดกิจกรรมนอกสถานที่ได้อย่างอิสระ
          </p>
          <p>
            ไม่อนุญาตให้นำไปใช้แสวงหาประโยชน์ เพื่อเชิงการค้า หากต้องการ Logo
            ในรูปแบบพิเศษอื่นๆ โปรดติดต่อ cs@shippop.com
          </p>
          <br />
          <p>
            <strong>ภาพตัวอย่างโลโก้</strong>
          </p>
          <img
            src="/static/img/sp-logo.svg"
            alt="SHIPPOP"
            style={{ maxWidth: 250 }}
          />
          <p>
            คลิกดาวน์โหลดโลโก้ เป็น{' '}
            <MuiLink href="/static/img/sp-logo.svg" target="_blank">
              ไฟล์ svg
            </MuiLink>{' '}
            |{' '}
            <MuiLink href="/static/files/faq/logo.ai" target="_blank">
              ไฟล์ ai
            </MuiLink>
          </p>{' '}
          <br />
          <p>
            <strong>ภาพตัวอย่าง CI Logo</strong>
          </p>
          <img
            src="/static/img/faq/ci-logo.jpg"
            alt="CI Logo"
            style={{ maxWidth: 550 }}
          />
          <p>
            คลิกดาวน์โหลด CI Logo เป็น{' '}
            <MuiLink href="/static/img/faq/ci-logo.jpg" target="_blank">
              ไฟล์ jpg
            </MuiLink>{' '}
            |{' '}
            <MuiLink href="/static/img/faq/CI-Logo.ai" target="_blank">
              ไฟล์ ai
            </MuiLink>
          </p>
          <br />
          <p>
            <strong>ภาพตัวอย่าง Key Visual</strong>
          </p>
          <img
            src="/static/img/faq/KV_preview.jpg"
            alt="Key Visual"
            style={{ maxWidth: 700 }}
          />
          <p>
            คลิกดาวน์โหลด Key Visual เป็น{' '}
            <MuiLink href="/static/img/faq/KV_preview.jpg" target="_blank">
              ไฟล์ jpg
            </MuiLink>{' '}
            |{' '}
            <MuiLink
              href="/static/files/faq/Shippop_key_visual.ai"
              target="_blank"
            >
              ไฟล์ ai
            </MuiLink>
          </p>
          <p>
            คลิกดาวน์โหลด Fonts เป็น{' '}
            <MuiLink
              href="/static/files/faq/Shippop_fonts.zip"
              target="_blank"
            >
              ไฟล์ zip
            </MuiLink>
          </p>
        </>,
        <>
          <p>
            The SHIPPOP website allows website visitors to download the Logo and
            CI Logo of the website for reference in print media, website media,
            and off-site event organizing freely.
          </p>
          <p>
            It is not permitted to use it for commercial exploitation. If you
            want the Logo in other special formats, please contact
            cs@shippop.com
          </p>
          <br />
          <p>
            <strong>Logo sample</strong>
          </p>
          <img
            src="/static/img/sp-logo.svg"
            alt="SHIPPOP"
            style={{ maxWidth: 250 }}
          />
          <p>
            Click to download the logo as{' '}
            <MuiLink href="/static/img/sp-logo.svg" target="_blank">
              svg file
            </MuiLink>{' '}
            |{' '}
            <MuiLink href="/static/files/faq/logo.ai" target="_blank">
              ai file
            </MuiLink>
          </p>{' '}
          <br />
          <p>
            <strong>CI Logo sample</strong>
          </p>
          <img
            src="/static/img/faq/ci-logo.jpg"
            alt="CI Logo"
            style={{ maxWidth: 550 }}
          />
          <p>
            Click to download the CI Logo as{' '}
            <MuiLink href="/static/img/faq/ci-logo.jpg" target="_blank">
              jpg file
            </MuiLink>{' '}
            |{' '}
            <MuiLink href="/static/img/faq/CI-Logo.ai" target="_blank">
              ai file
            </MuiLink>
          </p>
          <br />
          <p>
            <strong>Key Visual sample</strong>
          </p>
          <img
            src="/static/img/faq/KV_preview.jpg"
            alt="Key Visual"
            style={{ maxWidth: 700 }}
          />
          <p>
            Click to download the Key Visual as{' '}
            <MuiLink href="/static/img/faq/KV_preview.jpg" target="_blank">
              jpg file
            </MuiLink>{' '}
            |{' '}
            <MuiLink
              href="/static/files/faq/Shippop_key_visual.ai"
              target="_blank"
            >
              ai file
            </MuiLink>
          </p>
          <p>
            Click to download Fonts as{' '}
            <MuiLink
              href="/static/files/faq/Shippop_fonts.zip"
              target="_blank"
            >
              zip file
            </MuiLink>
          </p>
        </>
      ),
      [trans(
        'ดาวน์โหลดรูปผู้ก่อตั้งบริษัทชิปป๊อป',
        'Download SHIPPOP founders photos'
      )]: trans(
        <>
          <p>
            เว็บไซต์ SHIPPOP อนุญาตผู้เข้าชมเว็บไซต์
            ดาวน์โหลดภาพผู้ก่อตั้งชิปป๊อป เพื่อนำไปใช้อ้างอิงทางสื่อสิ่งพิมพ์
            สื่อเว็บไซต์ หรือการจัดกิจกรรมนอกสถานที่ได้อย่างอิสระ
          </p>
          <p>
            ไม่อนุญาตให้นำไปใช้แสวงหาประโยชน์ เพื่อเชิงการค้า
            หากต้องการภาพในรูปแบบพิเศษอื่นๆ โปรดติดต่อ cs@shippop.com
          </p>
          <br />
          <p>
            <strong>
              รูปตัวอย่างผู้ก่อตั้งบริษัทชิปป๊อป คุณภาวุฒิ และคุณโมชิ
            </strong>
          </p>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <img
              src="/static/img/faq/founder-pawoot.jpeg"
              alt="คุณภาวุฒิ"
              style={{ maxWidth: 350 }}
            />
            <img
              src="/static/img/faq/founder-moshi.jpeg"
              alt="คุณโมชิ"
              style={{ maxWidth: 350 }}
            />
          </div>
          <p>
            ดาวน์โหลดรูปผู้ก่อตั้งบริษัทชิปป๊อป{' '}
            <MuiLink
              href="/static/img/faq/founder-pawoot.jpeg"
              target="_blank"
            >
              รูปคุณภาวุฒิ
            </MuiLink>{' '}
            |{' '}
            <MuiLink
              href="/static/img/faq/founder-moshi.jpeg"
              target="_blank"
            >
              รูปคุณโมชิ
            </MuiLink>
          </p>
        </>,
        <>
          <p>
            The SHIPPOP website allows website visitors to download photos of
            the SHIPPOP founders for reference in print media, website media, or
            off-site event organizing freely.
          </p>
          <p>
            It is not permitted to use it for commercial exploitation. If you
            want the photos in other special formats, please contact
            cs@shippop.com
          </p>
          <br />
          <p>
            <strong>
              Sample photos of the SHIPPOP founders, Mr. Pawoot and Mr. Moshi
            </strong>
          </p>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <img
              src="/static/img/faq/founder-pawoot.jpeg"
              alt="คุณภาวุฒิ"
              style={{ maxWidth: 350 }}
            />
            <img
              src="/static/img/faq/founder-moshi.jpeg"
              alt="คุณโมชิ"
              style={{ maxWidth: 350 }}
            />
          </div>
          <p>
            Download photos of the SHIPPOP founders{' '}
            <MuiLink
              href="/static/img/faq/founder-pawoot.jpeg"
              target="_blank"
            >
              Mr. Pawoot photo
            </MuiLink>{' '}
            |{' '}
            <MuiLink
              href="/static/img/faq/founder-moshi.jpeg"
              target="_blank"
            >
              Mr. Moshi photo
            </MuiLink>
          </p>
        </>
      ),
    },
    [trans('การใช้งานระบบ', 'System Usage')]: {
      subtitle: trans(
        'รวมปัญหาและข้อมูลของการใช้งานทั่วไป',
        'A collection of common issues and general usage information'
      ),
      [trans('วิธีการใช้งาน', 'How to use')]: trans(
        <>
          <p>วีดีโอสอนการใช้งาน</p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/qVmvwcisDb4"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen=""
          />
        </>,
        <>
          <p>Usage tutorial video</p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/qVmvwcisDb4"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen=""
          />
        </>
      ),
      [trans('สร้างรายการอย่างไร ?', 'How do I create a shipment?')]: trans(
        <>
          <p>
            1. กรอกรายละเอียดทั้งหมด
            <ul>
              <li>น้ำหนัก</li>
              <li>ขนาดกล่อง</li>
              <li>ชื่อผู้ส่ง</li>
              <li>เบอร์โทร</li>
              <li>ที่อยู่</li>
              <li>รหัสไปรษณีย์</li>
              <li>หมายเหตุ (คำอธิบายของพัสดุ)</li>
            </ul>
          </p>
          <img
            src="/static/img/faq/create-1.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>2. กด "เลือกขนส่ง" เพื่อดูข้อมูลและเรทราคาแต่ละขนส่ง</p>
          <img
            src="/static/img/faq/create-2.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>3. เลือกขนส่ง และเรทราคาที่ต้องการ</p>
          <img
            src="/static/img/faq/create-3.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>4. ยืนยันตัวตน ด้วย OTP</p>
          <img
            src="/static/img/faq/create-4.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>5. ยืนยันหมายเลขโทรศัพท์ และโค๊ดจะส่งไปยังหมายเลขโทรศัพท์</p>
          <img
            src="/static/img/faq/create-5.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            6. เงื่อนไขการให้บริการของขนส่งที่เราเลือกใช้ จะปรากฎขึ้น
            กดยอมรับเงื่อนไข หลังจากนั้นกด "ยืนยันและชำระเงิน"
          </p>
          <img
            src="/static/img/faq/create-6.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>7. ช่องทางการชำระเงินออนไลน์</p>
          <img
            src="/static/img/faq/create-7.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            8. เมื่อชำระเงินเรียบร้อยแล้ว จะมีป๊อปอัพแสดงว่า "ชำระเงินสำเร็จ"
          </p>
          <img
            src="/static/img/faq/create-8.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            9. กดที่หมายเลขติดตามพัสดุ เพื่อดูรายละเอียดการจัดส่ง และกดปุ่ม
            พิมพ์ใบปะหน้า
          </p>
          <img
            src="/static/img/faq/create-9.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            10. แสดงรายละเอียดของใบปะหน้า และสามารถพิมพ์ใบปะหน้า
            เพื่อแปะบนพัสดุ และดำเนินการจัดส่ง
          </p>
          <img
            src="/static/img/faq/create-10.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
        </>,
        <>
          <p>
            1. Fill in all the details
            <ul>
              <li>Weight</li>
              <li>Box size</li>
              <li>Sender name</li>
              <li>Phone number</li>
              <li>Address</li>
              <li>Postal code</li>
              <li>Note (description of the parcel)</li>
            </ul>
          </p>
          <img
            src="/static/img/faq/create-1.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>2. Click "Select Courier" to view the information and price rate of each courier</p>
          <img
            src="/static/img/faq/create-2.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>3. Select the courier and the price rate you want</p>
          <img
            src="/static/img/faq/create-3.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>4. Verify your identity with OTP</p>
          <img
            src="/static/img/faq/create-4.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>5. Confirm the phone number and the code will be sent to that phone number</p>
          <img
            src="/static/img/faq/create-5.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            6. The terms of service of the courier we have chosen will appear.
            Click to accept the terms, then click "Confirm and Pay"
          </p>
          <img
            src="/static/img/faq/create-6.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>7. Online payment channels</p>
          <img
            src="/static/img/faq/create-7.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            8. Once the payment is complete, a pop-up will appear showing "Payment Successful"
          </p>
          <img
            src="/static/img/faq/create-8.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            9. Click on the parcel tracking number to view the delivery details
            and click the Print Label button
          </p>
          <img
            src="/static/img/faq/create-9.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
          <p>
            10. Display the label details, and you can print the label to attach
            to the parcel and proceed with the delivery
          </p>
          <img
            src="/static/img/faq/create-10.png"
            alt="การสร้างรายการ SHIPPOP"
            style={{ maxWidth: 750 }}
          />
        </>
      ),
      [trans(
        'ขั้นตอนการใช้บริการเก็บเงินปลายทาง',
        'Steps for using the Cash on Delivery service'
      )]: trans(
        <>
          <p>วีดีโอสอนการใช้งาน</p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/GMUHL8fFui0"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen=""
          ></iframe>
          <p>วิธีการตรวจสอบยอดโอนเงินคืน ของบริการเก็บเงินปลายทาง (COD)</p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/o4kSDlIGBes"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen=""
          ></iframe>
        </>,
        <>
          <p>Usage tutorial video</p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/GMUHL8fFui0"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen=""
          ></iframe>
          <p>How to check the refund transfer amount of the Cash on Delivery (COD) service</p>
          <iframe
            width="100%"
            height="450"
            src="https://www.youtube.com/embed/o4kSDlIGBes"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen=""
          ></iframe>
        </>
      ),
      [trans(
        'ตรวจสอบใบเสร็จรับเงินได้ที่ไหน',
        'Where can I check the receipt?'
      )]: trans(
        <>
          <p>ใบเสร็จรับเงิน เราจะออกให้ภายใน 5 วันทำการของเดือนถัดไป</p>
          <p>
            โดยสามารถตรวจสอบได้ผ่านเมนู “รายงานทางบัญชี {'>'}{' '}
            รายงานใบเสร็จรับเงิน”
          </p>
          <img
            src="/static/img/faq/register-6.png"
            alt="รายงานใบเสร็จ"
            style={{ maxWidth: 350 }}
          />
        </>,
        <>
          <p>We will issue the receipt within 5 business days of the following month.</p>
          <p>
            You can check it through the menu “Accounting Report {'>'}{' '}
            Receipt Report”
          </p>
          <img
            src="/static/img/faq/register-6.png"
            alt="รายงานใบเสร็จ"
            style={{ maxWidth: 350 }}
          />
        </>
      ),
      [trans(
        'แก้ไขใบเสร็จรับเงินได้อย่างไร ?',
        'How do I edit a receipt?'
      )]: trans(
        <>
          <p>
            โดยปกติจะไม่สามารถแก้ไขใบเสร็จรับเงินย้อนหลังได้
            แต่จะสามารถแก้ไขข้อมูลใบเสร็จรับเงินใบถัดไปได้
            โดยท่านจะต้องเข้าสู่ระบบ และเปลี่ยนแปลงข้อมูลใบเสร็จรับเงินที่เมนู
            “ตั้งค่า {'>'} แก้ไขข้อมูลส่วนตัว”
          </p>
        </>,
        <>
          <p>
            Normally, you cannot edit a past receipt, but you can edit the
            information on the next receipt. You must log in and change the
            receipt information at the menu “Settings {'>'} Edit Personal
            Information”
          </p>
        </>
      ),
      [trans(
        'เปลี่ยนแปลงรหัสผ่านอย่างไร ?',
        'How do I change my password?'
      )]: trans(
        <>
          <p>
            การเปลี่ยนแปลงรหัสผ่าน สามารถทำได้ผ่านระบบ โดยเข้าสู่ระบบ
            และเปลี่ยนแปลงได้ที่เมนู “ตั้งค่า {'>'} แก้ไขข้อมูลส่วนตัว”
          </p>
        </>,
        <>
          <p>
            Changing the password can be done through the system by logging in
            and changing it at the menu “Settings {'>'} Edit Personal
            Information”
          </p>
        </>
      ),
      [trans(
        'ตรวจสอบรายการค้างชำระได้อย่างไร ?',
        'How do I check outstanding items?'
      )]: trans(
        <>
          <p>
            หากพบว่ามีรายการที่ระบุข้อมูลพัสดุผิดพลาด
            ระบบจะมีการเรียกเก็บเพิ่มเติมย้อนหลัง
            โดยสามารถตรวจสอบรายการได้ที่เมนู “รายงาน {'>'} รายการค้างชำระ”
          </p>
          <img
            src="/static/img/faq/register-6.png"
            alt="รายการค้างชำระ"
            style={{ maxWidth: 350 }}
          />
        </>,
        <>
          <p>
            If there are items with incorrect parcel information, the system
            will charge additional fees retroactively. You can check the items
            at the menu “Report {'>'} Outstanding Items”
          </p>
          <img
            src="/static/img/faq/register-6.png"
            alt="รายการค้างชำระ"
            style={{ maxWidth: 350 }}
          />
        </>
      ),
      [trans(
        'แก้ไขข้อมูลส่วนตัวได้อย่างไร ?',
        'How do I edit my personal information?'
      )]: trans(
        <>
          <p>
            ท่านสามารถแก้ไขข้อมูลส่วนตัวได้ที่เมนู “ตั้งค่า {'>'}{' '}
            แก้ไขข้อมูลส่วนตัว”
          </p>
          <img
            src="/static/img/faq/register-5.png"
            alt="รายการค้างชำระ"
            style={{ maxWidth: 750 }}
          />
        </>,
        <>
          <p>
            You can edit your personal information at the menu “Settings {'>'}{' '}
            Edit Personal Information”
          </p>
          <img
            src="/static/img/faq/register-5.png"
            alt="รายการค้างชำระ"
            style={{ maxWidth: 750 }}
          />
        </>
      ),
      [trans(
        'วิธีการชำระเงินช่องทางต่างๆ',
        'Payment methods through various channels'
      )]: trans(
        <>
          <p>
            <strong>ชำระผ่าน QR Payment</strong>
          </p>
          <ol>
            <li>
              เปิดแอปพลิเคชั่นธนาคารบนมือถือ
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {[
                  'scb_circle.png',
                  'bay_circle.png',
                  'bbl_circle.png',
                  'ktb_circle.png',
                  'kbank_circle.png',
                  'tbank_circle.png',
                  'tmb_circle.png',
                ].map((fileName) => (
                  <img
                    src={`/static/img/icons/bank/${fileName}`}
                    alt={`ธนาคาร ${fileName.slice(0, 3)}`}
                    style={bankIconStyle}
                    key={fileName}
                  />
                ))}
              </div>
            </li>
            <li>
              เลือกเมนู "Scan เพื่อชำระเงิน" ตัวอย่าง
              แต่ละแอพพลิเคชันธนาคารดังนี้
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                {[
                  'scb-scan.jpeg',
                  'bay-scan.jpeg',
                  'kbank-scan.jpeg',
                  'bbl-scan.jpeg',
                ].map((fileName) => (
                  <img
                    src={`/static/img/faq/${fileName}`}
                    alt={`วิธีการจ่าย`}
                    style={{ maxWidth: 200, margin: 10 }}
                  />
                ))}
              </div>
            </li>
            <li>
              หลังจากชำระเงินเรียบร้อยแล้ว ระบบจะทำการอัปเดตอัตโนมัติ
              แต่หากไม่อัพเดตให้คลิกที่ "คลิกที่นี่ หากสถานะไม่อัพเดต"
              (ดังภาพ)
              <br />
              <img
                src="/static/img/faq/qr-click-update.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>
              เมื่อระบบอัปเดตเรียบร้อยแล้ว
              สามารถพิมพ์ใบปะหน้าเพื่อจัดส่งพัสดุได้ทันที
              <br />
              <img
                src="/static/img/faq/payment-success.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
          </ol>
          <br />
          <p>
            <strong>ชำระผ่าน QR Payment</strong>
          </p>
          <ol>
            <li>
              เลือกช่องทาง บัตรเครดิต / บัตรเดบิต (ดังภาพ)
              <br />
              <img
                src="/static/img/faq/credit-pay.jpeg"
                alt="จ่ายด้วยบัตรเครดิต"
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>กรอกข้อมูลบัตรเครดิต / บัตรเดบิตของท่านให้เรียบร้อย</li>
            <li>
              หลังจากชำระเงินเรียบร้อย ระบบจะทำการอัปเดตอัตโนมัติ
              และสามารถพิมพ์ใบปะหน้าเพื่อจัดส่งพัสดุได้ทันที
              <br />
              <img
                src="/static/img/faq/payment-success.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
          </ol>
          <br />
          <p>
            <strong>อินเตอร์เน็ต แบ๊งกิ้ง</strong>
          </p>
          <ol>
            <li>
              เลือกช่องทาง อินเตอร์เน็ต แบ๊งกิ้ง (ดังภาพ)
              <br />
              <img
                src="/static/img/faq/internet-banking-pay.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>
              เลือกธนาคารที่่ต้องการเลือกใช้ ดังนี้
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {[
                  'scb_circle.png',
                  'bay_circle.png',
                  'bbl_circle.png',
                  'ktb_circle.png',
                ].map((fileName) => (
                  <img
                    src={`/static/img/icons/bank/${fileName}`}
                    alt={`ธนาคาร ${fileName.slice(0, 3)}`}
                    style={bankIconStyle}
                  />
                ))}
              </div>
            </li>
            <li>
              หลังจากชำระเงินเรียบร้อย ระบบจะทำการอัปเดตอัตโนมัติ
              และสามารถพิมพ์ใบปะหน้าเพื่อจัดส่งพัสดุได้ทันที
              <br />
              <img
                src="/static/img/faq/payment-success.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
          </ol>
        </>,
        <>
          <p>
            <strong>Pay via QR Payment</strong>
          </p>
          <ol>
            <li>
              Open your mobile banking application
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {[
                  'scb_circle.png',
                  'bay_circle.png',
                  'bbl_circle.png',
                  'ktb_circle.png',
                  'kbank_circle.png',
                  'tbank_circle.png',
                  'tmb_circle.png',
                ].map((fileName) => (
                  <img
                    src={`/static/img/icons/bank/${fileName}`}
                    alt={`ธนาคาร ${fileName.slice(0, 3)}`}
                    style={bankIconStyle}
                    key={fileName}
                  />
                ))}
              </div>
            </li>
            <li>
              Select the "Scan to Pay" menu. Examples for each banking
              application are as follows
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                {[
                  'scb-scan.jpeg',
                  'bay-scan.jpeg',
                  'kbank-scan.jpeg',
                  'bbl-scan.jpeg',
                ].map((fileName) => (
                  <img
                    src={`/static/img/faq/${fileName}`}
                    alt={`วิธีการจ่าย`}
                    style={{ maxWidth: 200, margin: 10 }}
                  />
                ))}
              </div>
            </li>
            <li>
              After the payment is complete, the system will update
              automatically. But if it does not update, click "Click here if
              the status does not update" (as shown)
              <br />
              <img
                src="/static/img/faq/qr-click-update.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>
              Once the system has updated, you can print the label to ship the
              parcel immediately
              <br />
              <img
                src="/static/img/faq/payment-success.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
          </ol>
          <br />
          <p>
            <strong>Pay via QR Payment</strong>
          </p>
          <ol>
            <li>
              Select the Credit Card / Debit Card channel (as shown)
              <br />
              <img
                src="/static/img/faq/credit-pay.jpeg"
                alt="จ่ายด้วยบัตรเครดิต"
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>Fill in your credit card / debit card information completely</li>
            <li>
              After the payment is complete, the system will update
              automatically and you can print the label to ship the parcel
              immediately
              <br />
              <img
                src="/static/img/faq/payment-success.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
          </ol>
          <br />
          <p>
            <strong>Internet Banking</strong>
          </p>
          <ol>
            <li>
              Select the Internet Banking channel (as shown)
              <br />
              <img
                src="/static/img/faq/internet-banking-pay.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>
              Select the bank you want to use, as follows
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {[
                  'scb_circle.png',
                  'bay_circle.png',
                  'bbl_circle.png',
                  'ktb_circle.png',
                ].map((fileName) => (
                  <img
                    src={`/static/img/icons/bank/${fileName}`}
                    alt={`ธนาคาร ${fileName.slice(0, 3)}`}
                    style={bankIconStyle}
                  />
                ))}
              </div>
            </li>
            <li>
              After the payment is complete, the system will update
              automatically and you can print the label to ship the parcel
              immediately
              <br />
              <img
                src="/static/img/faq/payment-success.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
          </ol>
        </>
      ),
      [trans(
        'ต้องการลบรายการออกจากระบบ ต้องทำอย่างไร ?',
        'How do I delete an item from the system?'
      )]: trans(
        <>
          <p>หากรายการนั้นยังไม่ได้ชำระเงิน สามารถลบรายการได้ที่</p>
          <ol>
            <li>เมนู “รายการส่งของ {'>'} รายการรอชำระเงิน”</li>
            <li>เลือกรายการที่ต้องการลบ {'>'} ปุ่มลบรายการ</li>
          </ol>
          <p style={{ color: 'red' }}>
            * ถ้าชำระเงินเรียบร้อยแล้ว จะไม่สามารถลบรายการนั้นได้
          </p>
        </>,
        <>
          <p>If the item has not been paid yet, you can delete it at</p>
          <ol>
            <li>Menu “Shipment List {'>'} Pending Payment List”</li>
            <li>Select the item you want to delete {'>'} Delete button</li>
          </ol>
          <p style={{ color: 'red' }}>
            * If the payment has already been made, you cannot delete that item.
          </p>
        </>
      ),
      [trans(
        'สมัครเป็นลูกค้ารายเดือนอย่างไร',
        'How do I sign up as a monthly customer?'
      )]: trans(
        <>
          <p>
            คือ ลูกค้าที่มียอดขั้นต่ำในการจัดส่งไม่ต่ำกว่า 1,000 ชิ้นต่อเดือน
            และมีการใช้งานอย่างต่อเนื่องตลอดทุกเดือน
            ไม่ต้องกรอกน้ำหนักและขนาดของพัสดุ
            ค่าขนส่งชำระตามที่ใช้งานจริงเท่านั้น หรือหากมีเว็บไซต์
            สามารถใช้งานผ่านการเชื่อมต่อระบบ API ได้ทันที
          </p>
          <p>
            การสมัครใช้งานเป็นลูกค้ารายเดือน
            ลูกค้าจะต้องทำการสมัครสมาชิกผ่านพนักงานฝ่ายขายของบริษัทชิปป๊อปเท่านั้น
            โดยต้องเตรียมเอกสารประกอบการสมัครดังนี้
          </p>
          <br />
          <p>
            <strong># นิติบุคคล</strong>
          </p>
          <ul>
            <li>หนังสือรับรองบริษัท</li>
            <li>สำเนาบัตรประชาชนของผู้มีอำนาจในหนังสือรับรอง</li>
            <li>ภพ.20 (ถ้ามี)</li>
            <li>สำเนาสมุดบัญชีธนาคารย้อนหลังอย่างน้อย 3 เดือน</li>
            <li>
              สำเนาหน้าบัญชีธนาคารโดยมีชื่อบัญชีตรงกันกับชื่อบริษัท เท่านั้น
            </li>
          </ul>
          <br />
          <p>
            <strong># บุคคลธรรมดา</strong>
          </p>
          <ul>
            <li>สำเนาบัตรประชาชน</li>
            <li>สำเนาทะเบียนบ้าน</li>
            <li>สำเนาสมุดบัญชีธนาคารย้อนหลังอย่างน้อย 3 เดือน</li>
            <li>
              สำเนาหน้าบัญชีธนาคารโดยมีชื่อบัญชีตรงกันกับสำเนาบัตรประชาชน
              (กรณีต้องการใช้บริการเก็บเงินปลายทาง COD)
            </li>
          </ul>
          <p style={{ color: 'red' }}>
            * เอกสารทุกฉบับ รบกวนเซ็นสำเนาถูกต้องและประทับตราบริษัท
          </p>
        </>,
        <>
          <p>
            A monthly customer is a customer with a minimum shipping volume of
            no less than 1,000 pieces per month and continuous usage every
            month. You do not need to fill in the weight and size of the parcel;
            shipping fees are charged based on actual usage only. Or if you have
            a website, you can use it through the API connection immediately.
          </p>
          <p>
            To sign up as a monthly customer, the customer must register through
            a SHIPPOP sales representative only, and must prepare the following
            documents for the application.
          </p>
          <br />
          <p>
            <strong># Juristic person</strong>
          </p>
          <ul>
            <li>Company certificate</li>
            <li>Copy of the ID card of the authorized person in the certificate</li>
            <li>Por Por 20 (if any)</li>
            <li>Copy of bank account book for at least the past 3 months</li>
            <li>
              Copy of the bank account front page with the account name matching
              the company name only
            </li>
          </ul>
          <br />
          <p>
            <strong># Individual</strong>
          </p>
          <ul>
            <li>Copy of ID card</li>
            <li>Copy of house registration</li>
            <li>Copy of bank account book for at least the past 3 months</li>
            <li>
              Copy of the bank account front page with the account name matching
              the copy of the ID card (in case you want to use the Cash on
              Delivery COD service)
            </li>
          </ul>
          <p style={{ color: 'red' }}>
            * For all documents, please sign a certified true copy and stamp the
            company seal.
          </p>
        </>
      ),
      [trans(
        'ตรวจสอบใบแจ้งหนี้ได้อย่างไร ?',
        'How do I check my invoice?'
      )]: trans(
        <>
          <p>
            ลูกค้าสามารถตรวจสอบใบแจ้งหนี้ได้ภายในวันที่ 15 ของเดือนถัดไป
            ตรวจสอบได้ทาง
          </p>
          <ol>
            <li>เมนู “รายงานทางบัญชี {'>'} รายการค้างชำระ“</li>
            <li>อีเมลที่ใช้ในการเข้าสู่ระบบ</li>
          </ol>
          <p>โดยท่านจะได้รับเครดิต 7 วันหลังจากที่ระบบได้ออกใบแจ้งหนี้</p>
          <p style={{ color: 'red' }}>
            * ในกรณีที่ลูกค้าผิดนัดชำระ
            ทางบริษัทจะคิดเบี้ยปรับผิดนัดชำระร้อยละ 12 ต่อปี
          </p>
        </>,
        <>
          <p>
            Customers can check the invoice by the 15th of the following month.
            You can check it via
          </p>
          <ol>
            <li>Menu “Accounting Report {'>'} Outstanding Items“</li>
            <li>The email used to log in</li>
          </ol>
          <p>You will receive 7 days credit after the system issues the invoice.</p>
          <p style={{ color: 'red' }}>
            * In the event that the customer defaults on payment, the company
            will charge a late payment penalty of 12 percent per year.
          </p>
        </>
      ),
      [trans('ชำระเงินอย่างไร ?', 'How do I make a payment?')]: trans(
        <>
          <ol>
            <li>
              ชำระเงินโดยการโอนเงินเท่านั้น
              <br />
              ชำระเงินมาที่
              <br />
              บริษัท ชิปป๊อป จำกัด ธนาคาร กสิกรไทย สาขา เอ็มไพร์ ทาวเวอร์
              <br />
              เลขที่บัญชี 007-8-24466-6
              <br />
            </li>
            <li>
              ท่านจะได้รับเครดิต 7 วันหลังจากที่ระบบออกใบแจ้งหนี้
              โดยท่านสามารถตรวจสอบใบแจ้งหนี้ได้ภายในวันที่ 15 ของเดือนถัดไป
              ผ่านทางเมนู “รายงานทางบัญชี {'>'} รายการค้างชำระ“
              และอีเมลที่ใช้ในการเข้าสู่ระบบ
            </li>
          </ol>
          <p style={{ color: 'red' }}>
            * ในกรณีที่ลูกค้าผิดนัดชำระ
            ทางบริษัทจะคิดเบี้ยปรับผิดนัดชำระร้อยละ 12 ต่อปี
          </p>
        </>,
        <>
          <ol>
            <li>
              Payment by bank transfer only.
              <br />
              Pay to
              <br />
              Chippop Company Limited, Kasikorn Bank, Empire Tower Branch
              <br />
              Account number 007-8-24466-6
              <br />
            </li>
            <li>
              You will receive 7 days credit after the system issues the
              invoice. You can check the invoice by the 15th of the following
              month via the menu “Accounting Report {'>'} Outstanding Items“
              and the email used to log in.
            </li>
          </ol>
          <p style={{ color: 'red' }}>
            * In the event that the customer defaults on payment, the company
            will charge a late payment penalty of 12 percent per year.
          </p>
        </>
      ),
      [trans('แจ้งชำระเงินอย่างไร ?', 'How do I notify a payment?')]: trans(
        <>
          <p>
            แจ้งการชำระเงินผ่านทาง อีเมลล์ bill@shippop.com
            โดยมีขอรายละเอียดดังนี้
          </p>
          <ol>
            <li>หมายเลขใบแจ้งหนี้ (Invoice No)</li>
            <li>ยอดเงินและวันที่โอน</li>
            <li>หลักฐานการชำระเงิน</li>
          </ol>
          <p>
            หลังจากที่มีการแจ้งชำระเงินเรียบร้อยแล้ว
            จะดำเนินการออกใบเสร็จรับเงินให้ภายในวันทำการวันถัดไป
            โดยสามารถตรวจสอบใบเสร็จรับเงินได้ที่เมนู “รายงาน {'>'}{' '}
            ใบเสร็จรับเงิน”
            <br />
            กรณีลูกค้านิติบุคคล หักภาษี ณ ที่จ่าย
            จะต้องทำการส่งเอกสารฉบับจริงมาตามที่อยู่บริษัท
            เพื่อดำเนินการออกใบเสร็จรับเงินให้ต่อไป
            <br />
            ที่อยู่
            <br />
            บริษัท ชิปป๊อป จำกัด (สำนักงานใหญ่)
            <br />
            เลขที่ 34 อาคารซี.พี.ทาวเวอร์ 3 ห้องเลขที่ A04-402 ชั้นที่ 4
            <br />
            ถนนพญาไท แขวงทุ่งพญาไท
            <br />
            เขตราชเทวี กรุงเทพมหานคร 10400
          </p>
        </>,
        <>
          <p>
            Notify the payment via email bill@shippop.com with the following
            details
          </p>
          <ol>
            <li>Invoice No</li>
            <li>Amount and transfer date</li>
            <li>Proof of payment</li>
          </ol>
          <p>
            After the payment notification has been completed, a receipt will be
            issued within the next business day. You can check the receipt at
            the menu “Report {'>'} Receipts”
            <br />
            In the case of corporate customers deducting withholding tax, the
            original documents must be sent to the company address to continue
            issuing the receipt.
            <br />
            Address
            <br />
            Shippop Company Limited (Head Office)
            <br />
            No. 34 C.P. Tower 3 Building, Room No. A04-402, 4th Floor
            <br />
            Phayathai Road, Thung Phayathai Sub-district
            <br />
            Ratchathewi District, Bangkok 10400
          </p>
        </>
      ),
      [trans(
        'ชำระเงินแล้ว สามารถรับใบเสร็จได้ที่ไหน ?',
        'After payment, where can I get the receipt?'
      )]: trans(
        <>
          <p>
            เราจะออกใบเสร็จให้ในวันทำการวันถัดไปหลังจากได้รับการแจ้งชำระเงินและหลักฐานการชำระเงินครบถ้วน
            โดยสามารถตรวจสอบได้ผ่านเมนู “รายงานทางบัญชี {'>'}{' '}
            รายงานใบเสร็จรับเงิน”
          </p>
        </>,
        <>
          <p>
            We will issue the receipt on the next business day after receiving
            the payment notification and complete proof of payment. You can
            check it through the menu “Accounting Report {'>'} Receipt Report”
          </p>
        </>
      ),
      [trans(
        'ทำอย่างไรถึงจะได้รับใบเสร็จฉบับจริง ?',
        'How do I get the original receipt?'
      )]: trans(
        <>
          <p>
            หลังจากที่มีการแจ้งชำระเงินเรียบร้อยแล้ว
            จะดำเนินการออกใบเสร็จรับเงินให้ภายในวันทำการวันถัดไป
            โดยสามารถตรวจสอบใบเสร็จรับเงินได้ที่เมนู “รายงานทางบัญชี {'>'}{' '}
            รายงานใบเสร็จรับเงิน”
          </p>
          <p>
            เอกสารใบเสร็จรับเงินฉบับจริง
            จะดำเนินการส่งให้ตามที่อยู่จัดส่งเอกสารที่มีในระบบ
            ภายในวันพฤหัสบดี หลังจากที่ดำเนินการออกใบเสร็จรับเงิน
          </p>
          <p>
            * กรณีลูกค้านิติบุคคล หักภาษี ณ ที่จ่าย
            จะต้องทำการส่งเอกสารฉบับจริงมาตามที่อยู่บริษัทดังนี้
            เพื่อดำเนินการออกใบเสร็จรับเงินให้ต่อไป
            <br />
            ที่อยู่
            <br />
            บริษัท ชิปป๊อป จำกัด (สำนักงานใหญ่)
            <br />
            เลขที่ 34 อาคารซี.พี.ทาวเวอร์ 3 ห้องเลขที่ A04-402 ชั้นที่ 4
            <br />
            ถนนพญาไท แขวงทุ่งพญาไท
            <br />
            เขตราชเทวี กรุงเทพมหานคร 10400
          </p>
        </>,
        <>
          <p>
            After the payment notification has been completed, a receipt will be
            issued within the next business day. You can check the receipt at
            the menu “Accounting Report {'>'} Receipt Report”
          </p>
          <p>
            The original receipt document will be sent to the document delivery
            address available in the system, within Thursday after the receipt
            has been issued.
          </p>
          <p>
            * In the case of corporate customers deducting withholding tax, the
            original documents must be sent to the company address as follows to
            continue issuing the receipt.
            <br />
            Address
            <br />
            Shippop Company Limited (Head Office)
            <br />
            No. 34 C.P. Tower 3 Building, Room No. A04-402, 4th Floor
            <br />
            Phayathai Road, Thung Phayathai Sub-district
            <br />
            Ratchathewi District, Bangkok 10400
          </p>
        </>
      ),
      [trans(
        'ต้องการเพิ่ม logo ของตัวเองที่ใบปะหน้าทำได้หรือไม่ ?',
        'Can I add my own logo to the label?'
      )]: trans(
        <>
          <p>
            หากต้องการมี logo ร้านของท่านบนใบปะหน้า
            สามารถเลือกภาพโลโก้ที่ต้องการแสดง ส่งมาที่ cs@shippop.com
            หรือ Line : @SHIPPOP เราจะใช้เวลาดำเนินการประมาณ 1
            วันทำการหลังจากได้รับข้อมูลครบถ้วน
          </p>
          <p>รายละเอียด</p>
          <ol>
            <li>ภาพโลโก้สามารถมีได้เพียงภาพเดียวเท่านั้น</li>
            <li>
              โลโก้จะแสดงอยู่ที่มุมบนซ้ายมือของใบปะหน้าของท่าน ดังนี้
              <img
                src="/static/img/faq/label-example.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>3. ภาพโลโก้จะต้องมีขนาดไม่เกิน 250 x 75 (กว้าง x สูง)</li>
          </ol>
        </>,
        <>
          <p>
            If you want your shop logo on the label, you can select the logo
            image you want to display and send it to cs@shippop.com or Line :
            @SHIPPOP. It will take about 1 business day to process after we
            receive the complete information.
          </p>
          <p>Details</p>
          <ol>
            <li>Only one logo image is allowed.</li>
            <li>
              The logo will be displayed at the top left corner of your label,
              as follows
              <img
                src="/static/img/faq/label-example.jpeg"
                alt=""
                style={{ maxWidth: 550 }}
              />
            </li>
            <li>3. The logo image must not exceed 250 x 75 (width x height)</li>
          </ol>
        </>
      ),
      [trans(
        'เปลี่ยนแปลงข้อมูลลงทะเบียนได้หรือไม่ ?',
        'Can I change my registration information?'
      )]: trans(
        <>
          <p>
            หากต้องการเปลี่ยนแปลงข้อมูล
            จะต้องแนบเอกสารรายละเอียดการเปลี่ยนแปลง และส่งหลักฐาน
            และข้อมูลการเปลี่ยนแปลงมาทางอีเมล cs@shippop.com หรือ Line :
            @SHIPPOP
          </p>
        </>,
        <>
          <p>
            If you want to change the information, you must attach documents
            detailing the changes and send the evidence and change information
            via email cs@shippop.com or Line : @SHIPPOP
          </p>
        </>
      ),
      [trans(
        'เปลี่ยนแปลงรหัสผ่านอย่างไร ?',
        'How do I change my password?'
      )]: trans(
        <>
          <p>
            หากต้องการเปลี่ยนแปลงรหัสผ่าน กรุณาแจ้งหลักฐาน
            และข้อมูลการเปลี่ยนแปลงมาทางอีเมล cs@shippop.com หรือ Line :
            @SHIPPOP
          </p>
          <p>
            <strong>ขั้นตอนการเปลี่ยนแปลงรหัสผ่าน</strong>
          </p>
          <ol>
            <li>ส่งรายละเอียด</li>
            <li>รอดำเนินการภายในวันที่รับเรื่อง ไม่เกิน 18.00 น.</li>
          </ol>
        </>,
        <>
          <p>
            To change the password, please provide the evidence and change
            information via email cs@shippop.com or Line : @SHIPPOP
          </p>
          <p>
            <strong>Password change procedure</strong>
          </p>
          <ol>
            <li>Submit details</li>
            <li>Wait for processing within the receiving date, no later than 6:00 p.m.</li>
          </ol>
        </>
      ),
      [trans(
        'ไม่มีเครื่องปริ๊น สามารถใช้งานได้ไหม ?',
        'Can I use the service without a printer?'
      )]: trans(
        <>
          <p>
            ปกติการใช้งาน จะต้องมีเครื่องปริ๊นเพื่อใช้ในการพิมพ์ใบปะหน้า
            แต่สามารถเรียกบางขนส่งได้เช่น lalamove และ skootar
          </p>
        </>,
        <>
          <p>
            Normally, you need a printer to print the label, but you can use
            some couriers such as lalamove and skootar.
          </p>
        </>
      ),
      [trans('ติดตามพัสดุได้อย่างไร ?', 'How do I track a parcel?')]: trans(
        <>
          <p>
            สามารถติดตามพัสดุได้ง่ายๆ{' '}
            <Link href="/tracking">
              <MuiLink>ที่นี่</MuiLink>
            </Link>
          </p>
        </>,
        <>
          <p>
            You can easily track your parcel{' '}
            <Link href="/tracking">
              <MuiLink>here</MuiLink>
            </Link>
          </p>
        </>
      ),
      [trans(
        'ขนาดและพัสดุในการจัดส่งของแต่ละขนส่ง ต้องมีขนาดและน้ำหนักเท่าไร ?',
        'What size and weight must a parcel be for each courier?'
      )]: trans(
        <>
          <TableContainer
            component="div"
            style={{ border: '1px solid grey' }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ขนส่ง</TableCell>
                  <TableCell>ขนาดกล่อง ( กว้าง + ยาว + สูง )</TableCell>
                  <TableCell>น้ำหนัก</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  [
                    'ไปรษณีย์ไทยแบบ EMS',
                    'ไม่เกิน 120 เซนติเมตร',
                    'ไม่เกิน 20 กก.',
                  ],
                  [
                    'Flash Express',
                    'ไม่เกิน 280 เซนติเมตร และด้านใดด้านหนึ่งต้อง ไม่เกิน 150 เซนติเมตร',
                    'ไม่เกิน 50 กก.',
                  ],
                  [
                    'Flash Express (Bulky)',
                    'ไม่เกิน 400 เซนติเมตร และด้านใดด้านหนึ่งต้อง ไม่เกิน 160 เซนติเมตร',
                    'ไม่เกิน 100 กก.',
                  ],
                  [
                    'ไปรษณีย์ไทยแบบลงทะเบียน',
                    'ไม่เกิน 120 เซนติเมตร',
                    'ไม่เกิน 2 กก.',
                  ],
                  ['SCG Express', 'ไม่เกิน 200 เซนติเมตร', 'ไม่เกิน 25 กก.'],
                  [
                    'Ninjavan',
                    'ขนาดกว้าง + ยาว + สูง ไม่เกิน 180 เซนติเมตร แต่ละด้านไม่เกิน 100 เซนติเมตร',
                    'ไม่เกิน 20 กก. ',
                  ],
                  ['ALPHAFAST', 'ไม่เกิน 81 เซนติเมตร', 'ไม่เกิน 3 กก.'],
                  [
                    'Best Express',
                    'ขนาด กว้าง+ยาว+สูง ไม่เกิน 600 เซนติเมตร (ด้านใดด้านหนึ่งต้องไม่เกิน 200 เซนติเมตร)',
                    'น้ำหนักพัสดุ ไม่เกิน 100 กก.',
                  ],
                  ['SENDIT', 'ไม่เกิน 200 เซนติเมตร', 'ไม่เกิน 30 กก.'],
                  [
                    'ARAMEX',
                    'ขนาด กว้าง + ยาว + สูง ไม่เกิน 180 เซนติเมตร แต่ละด้านไม่เกิน 100 เซนติเมตร',
                    ,
                    'ไม่เกิน 30 กก.',
                  ],
                  ['LALAMOVE', 'ขนาดไม่เกิน 50x50x50', 'ไม่เกิน 20 กก.'],
                  // [
                  //   'True E-Logistic',
                  //   'ขนาด กว้าง + ยาว + สูง ไม่เกิน 200 เซนติเมตร แต่ละด้านไม่เกิน 150 เซนติเมตร ',
                  //   'ไม่เกิน 30 กก.',
                  // ],
                  ['Skootar', 'ไม่เกิน 50 x 50 x 50', 'ไม่เกิน 20 กก.'],
                ].map((row) => (
                  <TableRow key={row[0]}>
                    <TableCell>{row[0]}</TableCell>
                    <TableCell>{row[1]}</TableCell>
                    <TableCell>{row[2]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <p>สอบถามเพิ่มเติมได้ที่เมล cs@shippop.com หรือ Line : @SHIPPOP</p>
          <p style={{ color: 'red' }}>
            * หากไม่เป็นไปตามเงื่อนไขที่กำหนดของขนาดกล่องและน้ำหนัก
            ทางบริษัทขอสงวนสิทธิ์ในการรับผิดชอบทุกกรณี
          </p>
          <p style={{ color: 'red' }}>
            * หากขนาดกล่องและน้ำหนักของพัสดุ
            ไม่เป็นไปตามเงื่อนไขที่กำหนดของทางขนส่ง
            ทางบริษัทขอสงวนสิทธิ์ในการรับผิดชอบทุกกรณี
          </p>
        </>,
        <>
          <TableContainer
            component="div"
            style={{ border: '1px solid grey' }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Courier</TableCell>
                  <TableCell>Box size ( Width + Length + Height )</TableCell>
                  <TableCell>Weight</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  [
                    'Thailand Post (EMS)',
                    'Not exceeding 120 cm',
                    'Not exceeding 20 kg.',
                  ],
                  [
                    'Flash Express',
                    'Not exceeding 280 cm and each side must not exceed 150 cm',
                    'Not exceeding 50 kg.',
                  ],
                  [
                    'Flash Express (Bulky)',
                    'Not exceeding 400 cm and each side must not exceed 160 cm',
                    'Not exceeding 100 kg.',
                  ],
                  [
                    'Thailand Post (Register)',
                    'Not exceeding 120 cm',
                    'Not exceeding 2 kg.',
                  ],
                  ['SCG Express', 'Not exceeding 200 cm', 'Not exceeding 25 kg.'],
                  [
                    'Ninjavan',
                    'Width + Length + Height not exceeding 180 cm, each side not exceeding 100 cm',
                    'Not exceeding 20 kg. ',
                  ],
                  ['ALPHAFAST', 'Not exceeding 81 cm', 'Not exceeding 3 kg.'],
                  [
                    'Best Express',
                    'Width + Length + Height not exceeding 600 cm (each side must not exceed 200 cm)',
                    'Parcel weight not exceeding 100 kg.',
                  ],
                  ['SENDIT', 'Not exceeding 200 cm', 'Not exceeding 30 kg.'],
                  [
                    'ARAMEX',
                    'Width + Length + Height not exceeding 180 cm, each side not exceeding 100 cm',
                    ,
                    'Not exceeding 30 kg.',
                  ],
                  ['LALAMOVE', 'Size not exceeding 50x50x50', 'Not exceeding 20 kg.'],
                  // [
                  //   'True E-Logistic',
                  //   'ขนาด กว้าง + ยาว + สูง ไม่เกิน 200 เซนติเมตร แต่ละด้านไม่เกิน 150 เซนติเมตร ',
                  //   'ไม่เกิน 30 กก.',
                  // ],
                  ['Skootar', 'Not exceeding 50 x 50 x 50', 'Not exceeding 20 kg.'],
                ].map((row) => (
                  <TableRow key={row[0]}>
                    <TableCell>{row[0]}</TableCell>
                    <TableCell>{row[1]}</TableCell>
                    <TableCell>{row[2]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <p>For more inquiries, contact email cs@shippop.com or Line : @SHIPPOP</p>
          <p style={{ color: 'red' }}>
            * If the box size and weight do not comply with the specified
            conditions, the company reserves the right of responsibility in all
            cases.
          </p>
          <p style={{ color: 'red' }}>
            * If the box size and weight of the parcel do not comply with the
            conditions specified by the courier, the company reserves the right
            of responsibility in all cases.
          </p>
        </>
      ),
      [trans(
        'คำนวนน้ำหนักพัสดุได้อย่างไร ?',
        'How do I calculate the parcel weight?'
      )]: trans(
        <>
          <p>คุณสามารถคำนวนน้ำหนักพัสดุของคุณได้จากสูตรด้านล่างนี้</p>
          <p>
            น้ำหนัก (กรัม) = [ความกว้างเป็น ซม. * ความยาวเป็น ซม. *
            ความสูงเป็น ซม.] / 5
          </p>
          <p>โดยน้ำหนักที่ใช้งานผ่านระบบจะเป็นหน่วย “กรัม” เท่านั้น</p>
          <p>
            <strong>ปล. สูตรคำนวณน้ำหนักสินค้าโดยประมาณจากกล่องพัสดุ</strong>
          </p>
        </>,
        <>
          <p>You can calculate your parcel weight using the formula below</p>
          <p>
            Weight (grams) = [Width in cm. * Length in cm. * Height in cm.] / 5
          </p>
          <p>The weight used in the system is in “grams” unit only.</p>
          <p>
            <strong>Note. Formula to estimate the product weight from the parcel box</strong>
          </p>
        </>
      ),
      [trans(
        'กรอกน้ำหนักหรือขนาดกล่องผิด ต้องทำอย่างไร ?',
        'What if I enter the wrong weight or box size?'
      )]: trans(
        <>
          <p>
            หากน้ำหนักพัสดุหรือขนาดกล่องไม่ตรงกับที่ระบุในระบบ
            จะมีการเรียกเก็บเงินเพิ่มย้อนหลังในเดือนถัดไป
          </p>
          <p>
            และเหตุการณ์ที่อาจเกิดขึ้นคือ ขนส่งอาจไม่สามารถรับพัสดุของคุณได้
            หรืออาจจะทำให้เกิดความล่าช้าในการจัดส่งค่ะ
          </p>
        </>,
        <>
          <p>
            If the parcel weight or box size does not match what is specified in
            the system, additional fees will be charged retroactively in the
            following month.
          </p>
          <p>
            And a possible event is that the courier may not be able to pick up
            your parcel, or it may cause delays in delivery.
          </p>
        </>
      ),
      [trans(
        'ต้องทำอย่างไร หากเข้าสู่ระบบไม่ได้ ?',
        'What should I do if I cannot log in?'
      )]: trans(
        <>
          <p>
            โปรดตรวจสอบให้แน่ใจว่าท่านได้กรอกภาษาหรือ ตัวอักษรพิมพ์เล็ก - ใหญ่
            ในรหัสผ่านของท่านอย่างถูกต้อง
          </p>
          <p>
            หากไม่สามารถเข้าสู่ระบบได้ ท่านสามารถตั้งรหัสผ่านใหม่ได้{' '}
            <MuiLink
              href={`${publicRuntimeConfig.memberService}/forget-password`}
              target="_blank"
            >
              ที่นี่
            </MuiLink>
          </p>{' '}
        </>,
        <>
          <p>
            Please make sure that you have entered the language or the
            lowercase - uppercase letters in your password correctly.
          </p>
          <p>
            If you cannot log in, you can reset your password{' '}
            <MuiLink
              href={`${publicRuntimeConfig.memberService}/forget-password`}
              target="_blank"
            >
              here
            </MuiLink>
          </p>{' '}
        </>
      ),
      [trans(
        'ทำรายการแล้ว สถานะขึ้น "รายการผิดพลาด" ต้องทำยังไง ?',
        'After creating a shipment, the status shows "Error". What should I do?'
      )]: trans(
        <>
          <p>
            โดยปกติแล้ว หากลูกค้าทำรายการแล้วขึ้นสถานะ “รายการผิดพลาด”
            ระบบจะทำการอัพเดตสถานะอัตโนมัติ ภายใน 10-15 นาที
            แต่หากระบบไม่อัพเดตให้อัตโนมัติ
            กรุณาติดต่อเจ้าหน้าที่ฝ่ายบริการลูกค้า อีเมล cs@shippop.com หรือ
            Line : @SHIPPOP
          </p>
        </>,
        <>
          <p>
            Normally, if a customer creates a shipment and the status shows
            “Error”, the system will update the status automatically within
            10-15 minutes. But if the system does not update automatically,
            please contact customer service staff via email cs@shippop.com or
            Line : @SHIPPOP
          </p>
        </>
      ),
      [trans(
        'ต้องการให้เข้ารับสินค้าหน้าบ้าน มีค่าใช้จ่ายเพิ่มเติมหรือไม่ ?',
        'Is there an additional fee for home pickup?'
      )]: trans(
        <>
          <p>
            การใช้งานผ่านชิปป๊อป
            สามารถเลือกขนส่งที่ให้บริการเข้ารับสินค้าหน้าบ้านได้
            โดยไม่มีค่าใช้จ่ายใดใดเพิ่มเติม ขนส่งที่เข้ารับถึงหน้าบ้านมีดังนี้
          </p>
          <ol>
            <li>Flash Express</li>
            <li>Flash Express (Bulky)</li>
            <li>CJ Logistic</li>
            <li>SCG Express</li>
            <li>Ninjavan</li>
            <li>Best Express</li>
            <li>Aramex</li>
            {/* <li>True E-Logistic</li> */}
            <li>Lalamove</li>
            <li>Skootar (สำหรับลูกค้าที่เชื่อมผ่าน API)</li>
          </ol>
        </>,
        <>
          <p>
            When using SHIPPOP, you can select couriers that provide home pickup
            service at no additional cost. The couriers that pick up at your home
            are as follows
          </p>
          <ol>
            <li>Flash Express</li>
            <li>Flash Express (Bulky)</li>
            <li>CJ Logistic</li>
            <li>SCG Express</li>
            <li>Ninjavan</li>
            <li>Best Express</li>
            <li>Aramex</li>
            {/* <li>True E-Logistic</li> */}
            <li>Lalamove</li>
            <li>Skootar (for customers connected via API)</li>
          </ol>
        </>
      ),
      [trans(
        'ที่อยู่ต้นทาง เป็นคนละที่กับที่อยู่ในการเข้ารับสินค้าได้หรือไม่ ?',
        'Can the origin address be different from the pickup address?'
      )]: trans(
        <>
          <p>
            ไม่ได้ เนื่องจากขนส่งเข้ารับสินค้าไม่ได้
            หากที่อยู่ต้นทางกับที่อยู่เข้ารับเป็นคนละที่ ให้ติดต่อที่ Line :
            @SHIPPOP
          </p>
        </>,
        <>
          <p>
            No, because the courier cannot pick up the item if the origin
            address and the pickup address are different. Please contact Line :
            @SHIPPOP
          </p>
        </>
      ),
      [trans(
        'สร้างรายการ 1 รายการ สามารถส่งพัสดุได้กี่กล่อง ?',
        'How many boxes can I ship in one shipment?'
      )]: trans(
        <>
          <p>การทำรายการ 1 รายการส่งพัสดุได้ 1 กล่อง</p>
        </>,
        <>
          <p>One shipment can send 1 box.</p>
        </>
      ),
      [trans(
        'ต้องทำอย่างไร หากไม่สามารถชำระเงินได้ หรือระบบชำระเงินขัดข้อง ?',
        'What should I do if I cannot pay or the payment system malfunctions?'
      )]: trans(
        <>
          <p>แคปภาพหน้าจอที่ชำระเงินไม่ได้ ส่งมาที่ Line : @SHIPPOP</p>
        </>,
        <>
          <p>Take a screenshot of the failed payment and send it to Line : @SHIPPOP</p>
        </>
      ),
      [trans(
        'ต้องทำอย่างไร หากขนส่งไม่เข้ามารับสินค้า ?',
        'What should I do if the courier does not pick up the item?'
      )]: trans(
        <>
          <p>แจ้งเลข tracking มาทาง Line : @SHIPPOP</p>
          <p>
            (เงื่อนไขการใช้งานขนส่ง และการเข้ารับที่แสดงบนหน้าเว็บ
            เป็นการประมาณการณ์ในสถานการณ์ปกติ
            หากเกิดเหตุการณ์นอกเหนือการควบคุม สามารถประสานเพิ่มเติม ได้ที่
            line : @SHIPPOP)
          </p>
        </>,
        <>
          <p>Notify the tracking number via Line : @SHIPPOP</p>
          <p>
            (The courier usage conditions and pickup shown on the website are
            estimates under normal circumstances. If an event beyond control
            occurs, you can coordinate further at line : @SHIPPOP)
          </p>
        </>
      ),
      [trans(
        'ชำระเงินแล้ว แก้ไขข้อมูลได้ไหม ?',
        'After payment, can I edit the information?'
      )]: trans(
        <>
          <p>
            โดยปกติทาง SHIPPOP
            จะไม่อนุญาติให้แก้ไขหรือเปลี่ยนแปลงขนส่งที่เลือกได้
            แต่การแก้ไขข้อมูลที่อยู่ปลายทาง หรือเบอร์โทรปลายทาง
            สามารถแก้ไขได้ในบางกรณี
            โดยมีรายละเอียดการแก้ไขข้อมูลขึ้นอยู่กับขนส่งที่เลือก ดังนี้
          </p>
          <TableContainer component="div">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ขนส่ง</TableCell>
                  <TableCell>แก้ไขที่อยู่ปลายทาง</TableCell>
                  <TableCell>แก้ไขเบอร์โทรศัพท์</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  ['ไปรษณีย์ไทยแบบ EMS', 'ภายใน 14 วัน*', 'ภายใน 14 วัน*'],
                  [
                    'ไปรษณีย์ไทยแบบ ลงทะเบียน',
                    'ภายใน 14 วัน*',
                    'ภายใน 14 วัน*',
                  ],
                  ['SCG Express', 'ไม่สามารถแก้ไขได้', null],
                  [
                    'Ninjavan',
                    'สามารถแก้ไขได้ในบางกรณี ซึ่งจะทำให้ระยะเวลาในการจัดส่งเพิ่มขึ้นอีก 4-5 วัน โดยติดต่อผ่านทางชิปป๊อปเท่านั้น***',
                    null,
                  ],
                  ['Alphafast', 'ไม่สามารถแก้ไขได', null],
                  ['Lalamove', 'ไม่สามารถแก้ไขได', null],
                ].map((row) => (
                  <TableRow>
                    <TableCell>{row[0]}</TableCell>
                    <TableCell>{row[1]}</TableCell>
                    {row[2] && (
                      <TableCell
                        rowSpan={
                          row[2] ===
                            'สามารถแก้ไขได้ โดยติดต่อผ่านชิปป๊อปเท่านั้น**'
                            ? 5
                            : 1
                        }
                      >
                        {row[2]}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <p>
            * หากเป็นขนส่งไปรษณีย์ไทย การแก้ไขข้อมูลปลายทางได้ทำได้ภายใน 14
            วัน หลังจากชำระเงินเรียบร้อยแล้ว แต่หากเกิน 14 วันไปแล้ว
            ระบบจะยกเลิกรายการอัตโนมัติ
            และไม่สามารถนำหมายเลขพัสดุกลับมาใช้ได้อีก
            โดยทางเราขอสงวนสิทธิ์ในการคืนเงินค่ะ
          </p>
          <p>
            **
            การแก้ไขข้อมูลจะต้องติดต่อผ่านฝ่ายบริการลูกค้าของชิปป๊อปเท่านั้น
          </p>
          <p>
            *** การติดต่อเพื่อขอแก้ไขข้อมูลได้ทางฝ่ายบริการลูกค้า อีเมล :
            cs@shippop.com หรือ Line : @SHIPPOP
          </p>
        </>,
        <>
          <p>
            Normally, SHIPPOP does not allow editing or changing the selected
            courier, but editing the destination address information or
            destination phone number can be done in some cases. The details of
            editing the information depend on the selected courier, as follows
          </p>
          <TableContainer component="div">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Courier</TableCell>
                  <TableCell>Edit destination address</TableCell>
                  <TableCell>Edit phone number</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  ['Thailand Post (EMS)', 'Within 14 days*', 'Within 14 days*'],
                  [
                    'Thailand Post (Register)',
                    'Within 14 days*',
                    'Within 14 days*',
                  ],
                  ['SCG Express', 'Cannot be edited', null],
                  [
                    'Ninjavan',
                    'Can be edited in some cases, which will increase the delivery time by another 4-5 days, by contacting via SHIPPOP only***',
                    null,
                  ],
                  ['Alphafast', 'Cannot be edited', null],
                  ['Lalamove', 'Cannot be edited', null],
                ].map((row) => (
                  <TableRow>
                    <TableCell>{row[0]}</TableCell>
                    <TableCell>{row[1]}</TableCell>
                    {row[2] && (
                      <TableCell
                        rowSpan={
                          row[2] ===
                            'Can be edited by contacting via SHIPPOP only**'
                            ? 5
                            : 1
                        }
                      >
                        {row[2]}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <p>
            * For Thailand Post couriers, editing the destination information
            can be done within 14 days after the payment is complete. But if it
            exceeds 14 days, the system will cancel the shipment automatically
            and the parcel number cannot be reused. We reserve the right to
            refund.
          </p>
          <p>
            ** Editing the information must be done by contacting SHIPPOP
            customer service only.
          </p>
          <p>
            *** To contact for editing the information, contact customer service
            via email : cs@shippop.com or Line : @SHIPPOP
          </p>
        </>
      ),
      [trans(
        'ชำระเงินแล้ว ยกเลิกรายการได้หรือไม่ ?',
        'After payment, can I cancel the shipment?'
      )]: trans(
        <>
          <p>
            หากเป็นขนส่งไปรษณีย์ไทย จะไม่สามารถยกเลิกรายการหรือขอคืนเงินได้
            หากมีการชำระเงินเรียบร้อยแล้ว แต่ไม่นำสินค้าไปส่งภายใน 14 วัน
            ระบบจะทำการยกเลิกรายการให้อัตโนมัติ
          </p>
          <p>
            หากเป็นขนส่งเอกชนอื่นๆ สามารถแจ้งยกเลิกการเข้ารับได้
            โดยติดต่อผ่านฝ่ายบริการลูกค้าของชิปป๊อปเท่านั้น อีเมล :
            cs@shippop.com หรือ Line : @SHIPPOP
          </p>
        </>,
        <>
          <p>
            For Thailand Post couriers, you cannot cancel the shipment or
            request a refund. If the payment has already been made but the item
            is not sent within 14 days, the system will cancel the shipment
            automatically.
          </p>
          <p>
            For other private couriers, you can notify a cancellation of the
            pickup by contacting SHIPPOP customer service only, via email :
            cs@shippop.com or Line : @SHIPPOP
          </p>
        </>
      ),
      [trans('การขอคืนเงิน ทำได้หรือไม่ ?', 'Can I request a refund?')]: trans(
        <>
          <p>
            ตามปกติแล้ว
            การชำระเงินแล้วจะไม่สามารถขอคืนเงินได้เราแนะนำให้ท่านตรวจสอบข้อมูลเบื้องต้นของท่านให้ถูกต้องก่อนทำการชำระเงิน
            เพื่อหลีกเลี่ยงการทำรายการที่ข้อมูลผิดพลาด
            เป็นผลให้ไม่สามารถจัดส่งสินค้าได้อย่างถูกต้องค่ะ
          </p>
          <p>
            หากเป็นการการขอคืนเงินเนื่องจากข้อผิดพลาดของทางระบบจะพิจารณาแล้วแต่กรณีค่ะ
            หรือหากเป็นข้อผิดพลาดที่เกิดจากขนส่ง
            ทางเราจะต้องทำเรื่องกลับไปให้ขนส่งโดยใช้ระยะเวลาดำเนินการประมาณ 1
            เดือนขึ้นอยู่กับแต่ละขนส่งค่ะ
          </p>
          <p>
            <strong>
              เงื่อนไขที่ลูกค้าไม่สามารถขอคืนเงินได้ไม่ว่ากรณีใดๆ
            </strong>
          </p>
          <p>
            1. ขอยกเลิกการจัดส่งด้วยเหตุผลต่างๆ (เช่น ปลายทางขอยกเลิกรายการ,
            ปลายทางเดินทางมารับของด้วยตนเอง)
          </p>
          <p>2. ข้อมูลผิดพลาดที่เกิดจากผู้ใช้งาน เช่น</p>
          <ol>
            <li>
              ข้อมูลที่อยู่ปลายทาง หรือเบอร์โทรปลายทางผิดพลาด
              เป็นเหตุให้ขนส่งไม่สามารถติดต่อปลายทางได้ หรือทำการตีคืนสินค้า
            </li>
            <li>
              ข้อมูลต้นทางผิดพลาด เป็นเหตุให้ขนส่งไม่สามารถเข้ารับสินค้าได้
              หรือเข้ารับสินค้าล่าช้า
            </li>
            <li>การทำรายการซ้ำจากผู้ใช้งาน</li>
            <li>การเลือกขนส่งผิดพลาดจากผู้ใช้งาน</li>
            <li>ข้อผิดพลาดอื่นๆ ที่ไม่ได้เกิดจากข้อผิดพลาดของระบบ</li>
          </ol>
          <p>3. การแก้ไขข้อมูล เช่น</p>
          <ol>
            <li>
              การติดต่อกับขนส่งโดยตรง เพื่อแก้ไขข้อมูลต้นทางหรือปลายทาง
              โดยไม่ได้แจ้งผ่านทางชิปป๊อป
            </li>
            <li>
              การแก้ไขข้อมูลที่อยู่ต้นทางหรือปลายทาง ด้วยวิธีต่างๆ
              เป็นเหตุให้ข้อมูลในระบบไม่ตรงกับใบปะหน้าบนพัสดุ
            </li>
          </ol>
          <p>4. พัสดุมีขนาดเกิน หรือน้ำหนักเกินจากที่ขนส่งกำหนด</p>
          <p>
            5. ชำระเงินแล้ว แต่ไม่สามารถพิมพ์ใบปะหน้าได้
            เนื่องจากไม่มีเครื่องปริ้น
          </p>
          <p>
            <strong>
              หากต้องการขอคืนเงินและเงื่อนไขไม่เป็นไปตามที่ระบุข้างต้น
              กรุณาติดต่อฝ่ายบริการลูกค้า เพื่อดำเนินการพิจารณาให้เป็นกรณี
            </strong>
          </p>
        </>,
        <>
          <p>
            Normally, once payment is made, you cannot request a refund. We
            recommend that you verify your basic information correctly before
            making the payment, to avoid transactions with incorrect information
            that would result in the item not being delivered correctly.
          </p>
          <p>
            If the refund request is due to a system error, it will be
            considered on a case-by-case basis. Or if it is an error caused by
            the courier, we will have to file the matter back to the courier,
            which takes about 1 month depending on each courier.
          </p>
          <p>
            <strong>
              Conditions under which the customer cannot request a refund in any
              case
            </strong>
          </p>
          <p>
            1. Requesting a cancellation of delivery for various reasons (such as
            the recipient requesting cancellation, the recipient traveling to
            pick up the item themselves)
          </p>
          <p>2. Errors caused by the user, such as</p>
          <ol>
            <li>
              Incorrect destination address information or destination phone
              number, causing the courier to be unable to contact the recipient
              or resulting in the item being returned.
            </li>
            <li>
              Incorrect origin information, causing the courier to be unable to
              pick up the item or to pick up the item late.
            </li>
            <li>Duplicate transactions by the user.</li>
            <li>Incorrect courier selection by the user.</li>
            <li>Other errors not caused by a system error.</li>
          </ol>
          <p>3. Editing the information, such as</p>
          <ol>
            <li>
              Contacting the courier directly to edit the origin or destination
              information without notifying through SHIPPOP.
            </li>
            <li>
              Editing the origin or destination address information by various
              methods, causing the information in the system to not match the
              label on the parcel.
            </li>
          </ol>
          <p>4. The parcel exceeds the size or weight specified by the courier.</p>
          <p>
            5. Payment is made but the label cannot be printed because there is
            no printer.
          </p>
          <p>
            <strong>
              If you want to request a refund and the conditions do not comply
              with the above, please contact customer service for
              case-by-case consideration.
            </strong>
          </p>
        </>
      ),
      [trans(
        'ต้องการใช้บริการ “เก็บเงินปลายทาง” ต้องทำอย่างไร ?',
        'How do I use the "Cash on Delivery" service?'
      )]: trans(
        <>
          <p>ปัจจุบันเปิดแล้ว บริการเก็บเงินปลายทาง (COD) จาก SHIPPOP</p>
          <p>
            สำหรับลูกค้าหน้าเว็บไซต์และรายเดือน ขั้นตอนการสมัคร{' '}
            <MuiLink
              href="https://blog.shippop.com/%E0%B9%80%E0%B8%81%E0%B9%87%E0%B8%9A%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B8%A2%E0%B8%97%E0%B8%B2%E0%B8%87/"
              target="_blank"
            >
              ที่นี่
            </MuiLink>
          </p>
        </>,
        <>
          <p>Currently, the Cash on Delivery (COD) service from SHIPPOP is available.</p>
          <p>
            For website and monthly customers, the application steps are{' '}
            <MuiLink
              href="https://blog.shippop.com/%E0%B9%80%E0%B8%81%E0%B9%87%E0%B8%9A%E0%B9%80%E0%B8%87%E0%B8%B4%E0%B8%99%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B8%A2%E0%B8%97%E0%B8%B2%E0%B8%87/"
              target="_blank"
            >
              here
            </MuiLink>
          </p>
        </>
      ),
      [trans(
        'มีบริการจัดส่งต่างประเทศหรือไม่ ?',
        'Is there an international shipping service?'
      )]: trans(
        <>
          <p>
            ปัจจุบันทางชิปป๊อปได้เปิดให้บริการขนส่งต่างประเทศซึ่งสามารถดูข้อมูลได้จาก
            หน้า{' '}
            <MuiLink href="/inter/faq" target="_blank">
              FAQ SHIPPOP INTER
            </MuiLink>{' '}
            และตรวจสอบราคาได้
            <MuiLink href="/checkprice" target="_blank">
              ที่นี่
            </MuiLink>{' '}
            หรือสอบถามข้อมูลที่ฝ่ายบริการลูกค้า cs@shippop.com
          </p>{' '}
        </>,
        <>
          <p>
            Currently, SHIPPOP provides international shipping services, which
            you can view information from the{' '}
            <MuiLink href="/inter/faq" target="_blank">
              FAQ SHIPPOP INTER
            </MuiLink>{' '}
            page and check the price
            <MuiLink href="/checkprice" target="_blank">
              here
            </MuiLink>{' '}
            or inquire at customer service cs@shippop.com
          </p>{' '}
        </>
      ),
      [trans(
        'สินค้าต้องห้าม รายการวัตถุที่ไม่สามารถจัดส่งได้',
        'Prohibited items, list of objects that cannot be shipped'
      )]: trans(
        <p>
          <strong>สินค้าที่ไม่สามารถจัดส่งได้</strong>
          <ul>
            <li>การบรรจุสินค้าที่ไม่สามารถประกันความเสียหายได้</li>
            <li>สินค้าที่ไม่อยู่ในเงื่อนไขการเรียกร้องประกันค่าเสียหาย</li>
            <li>แนะนำการบรรจุหีบห่อสำหรับสินค้าบางประเภทที่มีความเสี่ยง</li>
            <li>แนะนำการบรรจุหีบห่อที่เหมาะสมสำหรับสินค้าทั่วไป</li>
          </ul>
          โดยสามารถดูรายละเอียดได้{' '}
          <MuiLink
            href="/static/files/faq/prohibit_item_2021.pdf"
            target="_blank"
          >
            ที่นี่
          </MuiLink>
        </p>,
        <p>
          <strong>Items that cannot be shipped</strong>
          <ul>
            <li>Packaging of items that cannot be insured against damage</li>
            <li>Items that are not within the conditions for damage insurance claims</li>
            <li>Packaging recommendations for certain risky product types</li>
            <li>Appropriate packaging recommendations for general items</li>
          </ul>
          You can view the details{' '}
          <MuiLink
            href="/static/files/faq/prohibit_item_2021.pdf"
            target="_blank"
          >
            here
          </MuiLink>
        </p>
      ),
    },
    [trans('เกี่ยวกับขนส่ง', 'About Couriers')]: {
      subtitle: trans(
        'รายละเอียดเกี่ยวกับขนส่ง เช่น เงื่อนไขของแต่ละขนส่ง',
        'Details about couriers, such as the conditions of each courier'
      ),
      [trans(
        'รายละเอียดขนส่ง ไปรษณีย์ไทย EMS',
        'Courier details: Thailand Post EMS'
      )]: trans(
        <>
          <p>
            ไปรษณีย์ด่วนพิเศษในประเทศ (EMS - Express Mail Service)
            เป็นการจัดส่งพัสดุแบบด่วนพิเศษ ครอบคลุมพื้นที่ทั่วประเทศไทย
            โดยใช้ระยะเวลาจัดส่งเพียง 1-4 วัน สามารถติดตามพัสดุได้ทันที{' '}
            <Link href="/tracking">
              <MuiLink>ที่นี่</MuiLink>
            </Link>
          </p>
        </>,
        <>
          <p>
            Domestic Express Mail Service (EMS - Express Mail Service) is an
            express parcel delivery covering all areas throughout Thailand, with
            a delivery time of only 1-4 days. You can track the parcel
            immediately{' '}
            <Link href="/tracking">
              <MuiLink>here</MuiLink>
            </Link>
          </p>
        </>
      ),
      [trans(
        'เงื่อนไขการใช้บริการ ไปรษณีย์ไทย EMS',
        'Terms of service: Thailand Post EMS'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้าพัสดุที่ได้จากระบบ และแปะลงบนหน้ากล่องพัสดุ</li>
            <li>
              นำกล่องพัสดุไปส่งที่ไปรษณีย์ไทย สามารถตรวจสอบสาขาที่มี SHIPPOP
              DROP-OFF{' '}
              <Link href="/nearby-dropoff">
                <MuiLink>ที่นี่</MuiLink>
              </Link>{' '}
            </li>
            <li>
              หลังจากชำระค่าขนส่งเรียบร้อยแล้ว จะต้องจัดส่ง
              <strong>ภายใน 12 วัน</strong>
            </li>
            <li>น้ำหนักของพัสดุจะต้องไม่เกิน 20 กิโลกรัม</li>
            <li>
              ขนาดของพัสดุ (กว้าง + ยาว + สูง) จะต้อง
              <strong>ไม่เกิน 120 เซนติเมตร</strong>
            </li>
            <li>
              รายการที่ชำระค่าขนส่งแล้ว จะไม่สามารถยกเลิก แก้ไข
              หรือขอคืนเงินได้ ไม่ว่าจะกรณีใดๆ
            </li>
            <li>
              หากจัดส่งพัสดุแล้ว
              ให้ดำเนินการตีกลับจะไม่สามารถนำหมายเลขติดตามพัสดุ (Tracking
              Number) กลับมาใช้ได้อีก
            </li>
            <li>
              การเลือกน้ำหนักพัสดุที่ไม่ตรงกับความเป็นจริง ทางบริษัทฯ
              จะดำเนินการเรียกเก็บค่าขนส่งเพิ่มเติม
            </li>
            <li>หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง</li>
            <li>
              <u>
                ผู้ใช้บริการจะต้องนำสินค้าไปส่ง ณ ที่ทำการไปรษณีย์
                ตามที่กำหนดไว้เท่านั้น
              </u>{' '}
              ในช่วงเวลาทำการ
              <ul>
                <li>
                  วันจันทร์ ถึง วันศุกร์ เวลา 8.00 - 16.00 น.
                  หรือตามเวลาทำการที่สาขากำหนด
                </li>
                <li>
                  วันเสาร์ ถึง วันอาทิตย์ เวลา 8.00 - 12.00 น.
                  หรือตามเวลาทำการที่สาขากำหนด
                </li>
              </ul>
            </li>
            <li>
              มาตรฐานการนำส่ง เป็นไปตามเงื่อนไขของบริษัท ไปรษณีย์ไทย จำกัด
              <ul>
                <li>
                  ปลายทางกรุงเทพและปริมณฑล ภายใน 1-2
                  วันทำการนับจากวันที่ฝากส่ง
                </li>
                <li>
                  ปลายทางภูมิภาคอื่นๆ ภายใน 2-5 วันทำการนับจากวันที่ฝากส่ง
                  ยกเว้นปลายทางทุกอำเภอในจังหวัดแม่ฮ่องสอน, อำเภอเวียงแหง
                  จังหวัดเชียงใหม่, อำเภอเวียงแก่น จังหวัดเชียงราย
                  ,พื้นที่พิเศษ และพื้นที่เกาะต่างๆ
                  จะจัดส่งล่าช้ากว่าที่กำหนดไว้
                </li>
              </ul>
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the parcel label obtained from the system and attach it to the front of the parcel box</li>
            <li>
              Bring the parcel box to Thailand Post. You can check the branches
              that have SHIPPOP DROP-OFF{' '}
              <Link href="/nearby-dropoff">
                <MuiLink>here</MuiLink>
              </Link>{' '}
            </li>
            <li>
              After paying the shipping fee, you must send it
              <strong>within 12 days</strong>
            </li>
            <li>The parcel weight must not exceed 20 kilograms</li>
            <li>
              The parcel size (Width + Length + Height) must
              <strong>not exceed 120 centimeters</strong>
            </li>
            <li>
              Items for which the shipping fee has been paid cannot be canceled,
              edited, or refunded in any case.
            </li>
            <li>
              If the parcel has been shipped and needs to be returned, the
              tracking number cannot be reused.
            </li>
            <li>
              Selecting a parcel weight that does not match reality, the company
              will charge additional shipping fees.
            </li>
            <li>If the item is returned, fees will be charged afterward.</li>
            <li>
              <u>
                The user must bring the item to the post office as specified
                only
              </u>{' '}
              during business hours
              <ul>
                <li>
                  Monday to Friday, 8:00 - 16:00, or according to the business
                  hours specified by the branch
                </li>
                <li>
                  Saturday to Sunday, 8:00 - 12:00, or according to the business
                  hours specified by the branch
                </li>
              </ul>
            </li>
            <li>
              Delivery standards are in accordance with the conditions of
              Thailand Post Company Limited.
              <ul>
                <li>
                  Bangkok and metropolitan destinations, within 1-2 business
                  days from the drop-off date
                </li>
                <li>
                  Other regional destinations, within 2-5 business days from the
                  drop-off date, except for all districts in Mae Hong Son
                  province, Wiang Haeng district in Chiang Mai province, Wiang
                  Kaen district in Chiang Rai province, special areas, and
                  various island areas, which will be delivered later than
                  specified.
                </li>
              </ul>
            </li>
          </ul>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง ไปรษณีย์ไทยลงทะเบียน',
        'Courier details: Thailand Post Register'
      )]: trans(
        <>
          <p>
            ไปรษณีย์ลงทะเบียนในประเทศ (ลงทะเบียน) เป็นการจัดส่งพัสดุแบบธรรมดา
            ครอบคลุมพื้นที่ทั่วประเทศไทย โดยระยะเวลาและมาตรฐานการนำส่ง
            เป็นไปตามเงื่อนไขของบริษัท ไปรษณีย์ไทย จำกัด
          </p>
          <ul>
            <li>
              ปลายทางกรุงเทพและปริมณฑล ภายใน 3 - 7 วันทำการนับจากวันที่ฝากส่ง
            </li>
            <li>
              ปลายทางภูมิภาคอื่นๆ ภายใน 4 - 8 วันทำการนับจากวันที่ฝากส่ง
              ยกเว้น ปลายทางทุกอำเภอในจังหวัดแม่ฮ่องสอน, อำเภอเวียงแหง
              จังหวัดเชียงใหม่, อำเภอเวียงแก่น จังหวัดเชียงราย ,พื้นที่พิเศษ
              และพื้นที่เกาะ
            </li>
          </ul>
        </>,
        <>
          <p>
            Domestic registered mail (Register) is a normal parcel delivery
            covering all areas throughout Thailand. The delivery time and
            standards are in accordance with the conditions of Thailand Post
            Company Limited.
          </p>
          <ul>
            <li>
              Bangkok and metropolitan destinations, within 3 - 7 business days
              from the drop-off date
            </li>
            <li>
              Other regional destinations, within 4 - 8 business days from the
              drop-off date, except for all districts in Mae Hong Son province,
              Wiang Haeng district in Chiang Mai province, Wiang Kaen district in
              Chiang Rai province, special areas, and island areas.
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ ไปรษณีย์ไทยลงทะเบียน',
        'Terms of service: Thailand Post Register'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้าพัสดุที่ได้จากระบบ และแปะลงบนหน้ากล่องพัสดุ</li>
            <li>
              หลังจากชำระค่าขนส่งเรียบร้อยแล้ว จะต้องจัดส่ง
              <strong>ภายใน 12 วัน</strong>
            </li>
            <li>น้ำหนักของพัสดุจะต้องไม่เกิน 2 กิโลกรัม</li>
            <li>
              ขนาดของพัสดุ (กว้าง + ยาว + สูง) จะต้องไม่เกิน 120 เซนติเมตร
            </li>
            <li>
              รายการที่ชำระค่าขนส่งแล้ว จะไม่สามารถยกเลิก แก้ไข
              หรือขอคืนเงินได้ ไม่ว่าจะกรณีใดๆ
            </li>
            <li>
              หากจัดส่งพัสดุแล้ว
              ให้ดำเนินการตีกลับจะไม่สามารถนำหมายเลขติดตามพัสดุ(Tracking
              Number) กลับมาใช้ได้อีก
            </li>
            <li>
              การเลือกน้ำหนักพัสดุที่ไม่ตรงกับความเป็นจริง ทางบริษัทฯ
              จะดำเนินการเรียกเก็บค่าขนส่งเพิ่มเติม
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the parcel label obtained from the system and attach it to the front of the parcel box</li>
            <li>
              After paying the shipping fee, you must send it
              <strong>within 12 days</strong>
            </li>
            <li>The parcel weight must not exceed 2 kilograms</li>
            <li>
              The parcel size (Width + Length + Height) must not exceed 120
              centimeters
            </li>
            <li>
              Items for which the shipping fee has been paid cannot be canceled,
              edited, or refunded in any case.
            </li>
            <li>
              If the parcel has been shipped and needs to be returned, the
              tracking number cannot be reused.
            </li>
            <li>
              Selecting a parcel weight that does not match reality, the company
              will charge additional shipping fees.
            </li>
          </ul>
        </>
      ),
      [trans(
        'จุดให้บริการ Drop Off หรือสาขาของไปรษณีย์ไทย',
        'Drop Off service points or Thailand Post branches'
      )]: trans(
        <>
          <p>
            จุดให้บริการ Drop Off ของไปรษณีย์ไทย ดูรายละเอียดเพิ่มเติม
            <MuiLink href="/nearby-dropoff" target="_blank">
              ที่นี่
            </MuiLink>
          </p>
        </>,
        <>
          <p>
            Thailand Post Drop Off service points. See more details
            <MuiLink href="/nearby-dropoff" target="_blank">
              here
            </MuiLink>
          </p>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง SCG Yamato Express',
        'Courier details: SCG Yamato Express'
      )]: trans(
        <>
          <p>
            บริการขนส่งพัสดุย่อยแบบเร่งด่วนถึงบ้าน (Door to Door Parcel
            Delivery)
            มีบริการรับพัสดุถึงบ้านลูกค้าและจัดส่งถึงปลายทางในวันถัดไป
          </p>
          <ul>
            <li>ใช้ง่ายเพียง “ปริ้น แปะ ส่ง”</li>
            <li>“Deliver Your Happiness”</li>
            <li>การส่งพัสดุตรงตามเวลา</li>
            <li>พัสดุไม่เสียหายระหว่างจัดส่ง</li>
            <li>ราคาเริมต้นเพียง 40 บาทเท่านั้น</li>
          </ul>
        </>,
        <>
          <p>
            Express small parcel delivery service to your home (Door to Door
            Parcel Delivery). There is a service to pick up the parcel at the
            customer's home and deliver it to the destination the next day.
          </p>
          <ul>
            <li>Easy to use, just “Print, Attach, Send”</li>
            <li>“Deliver Your Happiness”</li>
            <li>On-time parcel delivery</li>
            <li>No parcel damage during delivery</li>
            <li>Starting price of only 40 baht</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ SCG Yamato Express',
        'Terms of service: SCG Yamato Express'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้า และแปะลงบนกล่องพัสดุ</li>
            <li>
              เข้ารับสินค้าตั้งแต่ 1 ชิ้นขึ้นไป ในพื้นที่ กทม.และปริมณฑล
              พื้นที่เข้ารับกับจัดส่งของ SCG
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              ชำระค่าบริการก่อน 12.00 น. รับสินค้าวันเดียวกัน หลัง 12.01 น.
              เข้ารับสินค้าวันถัดไป
            </li>
            <li>
              สามารถรับพัสดุที่มีขนาด กว้าง+ยาว+สูง เกิน 250 ซม.
              หรือน้ำหนักมากกว่า 25 กก.
            </li>
            <li>
              หากขนาดพัสดุมีขนาดเกินกำหนด หรือระบุมาไม่ถูกต้อง
              ขนส่งอาจปฏิเสธการรับพัสดุชิ้นนั้น และ
              หากมีการรับพัสดุแต่ขนาดพัสดุมีขนาดเกินกำหนด
              จะมีการเรียกเก็บเงินค่าขนส่งเพิ่มเติมภายหลัง
            </li>
            <li>
              กรณีพัสดุมีการตีคืน จะมีการคิดค่าบริการเท่ากับราคาค่าขนส่ง
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the label and attach it to the parcel box</li>
            <li>
              Pick up from 1 piece or more in the Bangkok and metropolitan area.
              SCG pickup and delivery area
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                click here
              </MuiLink>
            </li>
            <li>
              Pay the service fee before 12:00, and the item is picked up the
              same day. After 12:01, the item is picked up the next day.
            </li>
            <li>
              Can pick up parcels with Width + Length + Height exceeding 250 cm
              or weight more than 25 kg.
            </li>
            <li>
              If the parcel size exceeds the limit or is incorrectly specified,
              the courier may refuse to pick up that parcel, and if the parcel
              is picked up but the size exceeds the limit, additional shipping
              fees will be charged afterward.
            </li>
            <li>
              In the case of a parcel being returned, a fee equal to the
              shipping cost will be charged.
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการใช้บริการเก็บเงินปลายทาง SCG Express',
        'Cash on Delivery terms of service: SCG Express'
      )]: trans(
        <>
          <ol>
            <li>
              ยืนยันตัวตนด้วยบัตรประชาชนและบัญชีธนาคาร ที่
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=ConfirmAccount`}
                target="_blank"
              >
                ยืนยันตัวตน
              </MuiLink>
            </li>
            <li>
              สร้างรายการเก็บของโดยกรอกข้อมูลที่ช่องเก็บเงินปลายทาง
              ซึ่งจะปรากฏขึ้นหลังจากที่ได้ยืนยันตัวตน ตามข้อที่ 1
            </li>
            <li>พิมพ์ใบปะหน้า และแปะลงบนหน้ากล่อง</li>
            <li>เข้ารับสินค้าตั้งแต่ 1 ชิ้นขึ้นไป</li>
            <li>
              สามารถเข้ารับสินค้าขนาดกล่อง ( กว้าง + ยาว + สูง ) ไม่เกิน 250
              เซนติเมตร หรือน้ำหนักมากกว่า 25 กิโลกรัม
            </li>
            <li>
              ชำระค่าบริการก่อน 12.00 น. รับสินค้าวันเดียวกัน หลัง 12.01 น.
              เข้ารับสินค้าวันถัดไป
            </li>
            <li>
              SCG Express จะคิดค่าธรรมเนียมเก็บเงินปลายทาง คิดจากยอดเรียกเก็บ
              COD 3 % ไม่มีขั้นต่ำ
            </li>
            <li>
              บริษัทจะทําการโอนเงินที่รับชําระมาแล้ว ทุกวันศุกร์
              หากเป็นวันหยุดจะทําการโอนคืนในวันทําการถัดไป
            </li>
            <li>
              ยอดโอนคืนขั้นตํ่า 500 บาท หลังหักค่าธรรมเนียม COD (3%) แล้ว
              ส่วนค่าธรรมเนียมในการโอนขึ้นอยู่กับธนาคารของผู้ใช้งาน
            </li>
            <li>
              กำหนดการใช้บริการ COD ยอดขั้นตํ่าของสินค้า คือ 100 บาท
              สูงสุดไม่เกิน 50,000 บาท
            </li>
            <li>
              หากระบุข้อมูลปลายทางผิดพลาด ทางบริษัทขอสงวนสิทธิ์ ในการแก้ไข
              ยกเลิกและคืนเงิน
            </li>
            <li>หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง</li>
          </ol>
        </>,
        <>
          <ol>
            <li>
              Verify your identity with an ID card and bank account at
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=ConfirmAccount`}
                target="_blank"
              >
                Verify Identity
              </MuiLink>
            </li>
            <li>
              Create a shipment by filling in the information in the Cash on
              Delivery field, which will appear after you have verified your
              identity as in item 1.
            </li>
            <li>Print the label and attach it to the front of the box</li>
            <li>Pick up from 1 piece or more</li>
            <li>
              Can pick up items with box size ( Width + Length + Height ) not
              exceeding 250 centimeters or weight more than 25 kilograms
            </li>
            <li>
              Pay the service fee before 12:00, and the item is picked up the
              same day. After 12:01, the item is picked up the next day.
            </li>
            <li>
              SCG Express charges a Cash on Delivery fee of 3% of the COD
              collection amount, with no minimum.
            </li>
            <li>
              The company will transfer the collected payment every Friday. If
              it is a holiday, the transfer will be made on the next business
              day.
            </li>
            <li>
              The minimum refund transfer amount is 500 baht after deducting the
              COD fee (3%). The transfer fee depends on the user's bank.
            </li>
            <li>
              The COD service requires a minimum item amount of 100 baht, up to
              a maximum of 50,000 baht.
            </li>
            <li>
              If the destination information is incorrect, the company reserves
              the right to edit, cancel, and refund.
            </li>
            <li>If the item is returned, fees will be charged afterward.</li>
          </ol>
        </>
      ),
      [trans(
        'พื้นที่จัดส่งสินค้าและพื้นที่พิเศษ SCG Express',
        'Delivery areas and special areas: SCG Express'
      )]: trans(
        <>
          <p>
            พื้นที่จัดส่งสินค้า สำหรับขนส่ง SCG Express
            ได้ขยายพื้นที่ให้บริการได้ครอบคลุมยิ่งขึ้น
            ซึ่งสามารถจัดส่งได้ทุกพื้นที่ทั่วประเทศไทยแล้ว โดยแบ่งเป็น 6
            ภูมิภาคดังนี้
          </p>
          <img
            src="static/img/faq/SCG_region.png"
            alt="พื้นที่จัดส่งสินค้าและพื้นที่พิเศษ SCG Express"
            style={{ maxWidth: 550 }}
          />
          <ul>
            <li>พื้นที่จัดส่งสินค้าและพื้นที่พิเศษ SCG Express</li>
            <li>
              พื้นที่ห่างไกล Remote Area ระยะเวลาในการจัดส่งภายใน 2-4 วัน
              คิดค่าบริการเพิ่ม 50 บาท
            </li>
            <li>พื้นที่ห่างไกลและเกาะ ที่คิดค่าบริการเพิ่ม 50 บาท</li>
            <li>
              ตรวจสอบพื้นที่พิเศษ{' '}
              <MuiLink
                href="https://drive.google.com/file/d/1gnUZFXsjQrpJGITh4G3Xj_yTXE0nvvlK/view"
                target="_blank"
              >
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              ดาวน์โหลดไฟล์พื้นที่ให้บริการ{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                อัพเดท คลิกที่นี่
              </MuiLink>
            </li>
          </ul>
        </>,
        <>
          <p>
            The delivery area for SCG Express has expanded its service area to
            be more comprehensive, and can now deliver to all areas throughout
            Thailand, divided into 6 regions as follows
          </p>
          <img
            src="static/img/faq/SCG_region.png"
            alt="พื้นที่จัดส่งสินค้าและพื้นที่พิเศษ SCG Express"
            style={{ maxWidth: 550 }}
          />
          <ul>
            <li>Delivery areas and special areas of SCG Express</li>
            <li>
              Remote Area, delivery time within 2-4 days, additional fee of 50
              baht
            </li>
            <li>Remote areas and islands with an additional fee of 50 baht</li>
            <li>
              Check special areas{' '}
              <MuiLink
                href="https://drive.google.com/file/d/1gnUZFXsjQrpJGITh4G3Xj_yTXE0nvvlK/view"
                target="_blank"
              >
                click here
              </MuiLink>
            </li>
            <li>
              Download the service area file{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                Update, click here
              </MuiLink>
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ SCG Express Chilled (สินค้าแช่เย็น อุณหภูมิประมาณ 0 °c ถึง 8 °c)',
        'Terms of service: SCG Express Chilled (chilled products, temperature about 0 °c to 8 °c)'
      )]: trans(
        <>
          <ul>
            <li>
              บริการรับ-ส่งสินค้าถึงบ้านหน้า (Door to Door) เป็นแบบ Next Day
              Delivery ราคาเริ่มต้นเพียง 140 บาทเท่านั้น
            </li>
            <li>
              ใช้ง่ายเพียง “ปริ้น แปะ ส่ง” โดยพิมพ์ใบปะหน้า
              และแปะลงบนกล่องพัสดุ
            </li>
            <li>
              “Deliver Your Happiness” ส่งพัสดุตรงตามเวลา ขนส่งรวดเร็ว
              และแม่นยำในการบริการ
            </li>
            <li>
              ครบครันด้วยเทคโนโลยี Cool TA-Q-BIN (Cool Parcel Delivery)
              Chilled <strong>ณ อุณหภูมิประมาณ 0 °c ถึง 8 °c</strong>
            </li>
            <li>พัสดุไม่เสียหายระหว่างจัดส่ง</li>
            <li>
              เข้ารับสินค้าตั้งแต่ 1 ชิ้นขึ้นไป ในพื้นที่ กทม.และปริมณฑล{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                พื้นที่เข้ารับและจัดส่ง
              </MuiLink>
            </li>
            <li>
              สามารถเข้ารับสินค้าขนาดกล่อง ( กว้าง + ยาว + สูง ) ไม่เกิน 120
              เซนติเมตร
            </li>
            <li>
              น้ำหนักเกิน 25 กิโลกรัม หากขนาดพัสดุมีขนาดเกินกำหนด
              หรือระบุมาไม่ถูกต้อง จะมีการเรียกเก็บเงินค่าขนส่งเพิ่มเติม
            </li>
            <li>
              สินค้าที่อยู่ภายใน ต้องถูกแช่อยู่ในความเย็นที่ต่ำกว่า 8
              องศาเซลเซียส อย่างน้อยไม่ต่ำกว่า 6 ชั่วโมง ก่อนการจัดส่ง
            </li>
            <li>
              จะต้องทำรายการล่วงหน้า 1 วัน ก่อนเวลา 15.00 น.
              {/* <strong>จองล่วงหน้า 1 วัน (วันจันทร์-วันศุกร์)</strong> */}
            </li>
            <li>หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง</li>
            <li>รับประกันสูงสุด 3,000 บาท</li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              Door to Door delivery service, Next Day Delivery, starting price
              of only 140 baht.
            </li>
            <li>
              Easy to use, just “Print, Attach, Send” by printing the label and
              attaching it to the parcel box.
            </li>
            <li>
              “Deliver Your Happiness” delivering the parcel on time, fast and
              accurate service.
            </li>
            <li>
              Fully equipped with Cool TA-Q-BIN (Cool Parcel Delivery) Chilled
              technology <strong>at a temperature of about 0 °c to 8 °c</strong>
            </li>
            <li>No parcel damage during delivery</li>
            <li>
              Pick up from 1 piece or more in the Bangkok and metropolitan area{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                Pickup and delivery area
              </MuiLink>
            </li>
            <li>
              Can pick up items with box size ( Width + Length + Height ) not
              exceeding 120 centimeters
            </li>
            <li>
              Weight over 25 kilograms; if the parcel size exceeds the limit or
              is incorrectly specified, additional shipping fees will be charged.
            </li>
            <li>
              The items inside must be chilled at a temperature below 8 degrees
              Celsius for at least 6 hours before delivery.
            </li>
            <li>
              A shipment must be created 1 day in advance before 15:00.
              {/* <strong>จองล่วงหน้า 1 วัน (วันจันทร์-วันศุกร์)</strong> */}
            </li>
            <li>If the item is returned, fees will be charged afterward.</li>
            <li>Insured up to 3,000 baht</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ SCG Express Frozen (สินค้าแช่แข็ง อุณหภูมิประมาณ 0 °c ถึง -15 °c)',
        'Terms of service: SCG Express Frozen (frozen products, temperature about 0 °c to -15 °c)'
      )]: trans(
        <>
          <ul>
            <li>
              บริการรับ-ส่งสินค้าถึงบ้านหน้า (Door to Door) เป็นแบบ Next Day
              Delivery ราคาเริ่มต้นเพียง 140 บาทเท่านั้น
            </li>
            <li>
              ใช้ง่ายเพียง “ปริ้น แปะ ส่ง” โดยพิมพ์ใบปะหน้า
              และแปะลงบนกล่องพัสดุ
            </li>
            <li>
              “Deliver Your Happiness” ส่งพัสดุตรงตามเวลา ขนส่งรวดเร็ว
              และแม่นยำในการบริการ
            </li>
            <li>
              ครบครันด้วยเทคโนโลยี Cool TA-Q-BIN (Cool Parcel Delivery)
              Frozen อุณหภูมิประมาณ 0 °c ถึง -15 °c
            </li>
            <li>พัสดุไม่เสียหายระหว่างจัดส่ง</li>
            <li>
              เข้ารับสินค้าตั้งแต่ 1 ชิ้นขึ้นไป ในพื้นที่ กทม.และปริมณฑล{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                พื้นที่เข้ารับและจัดส่ง
              </MuiLink>
            </li>
            <li>
              สามารถเข้ารับสินค้าขนาดกล่อง ( กว้าง + ยาว + สูง ) ไม่เกิน 120
              เซนติเมตร
            </li>
            <li>
              น้ำหนักเกิน 25 กิโลกรัม หากขนาดพัสดุมีขนาดเกินกำหนด
              หรือระบุมาไม่ถูกต้อง จะมีการเรียกเก็บเงินค่าขนส่งเพิ่มเติม
            </li>
            <li>
              สินค้าที่อยู่ภายใน ต้องถูกแช่อยู่ในความเย็นที่ต่ำกว่า -15
              องศาเซลเซียส อย่างน้อยไม่ต่ำกว่า 12 ชั่วโมง ก่อนการจัดส่ง
            </li>
            <li>
              {/* (วันจันทร์-วันศุกร์)
              <strong>จองล่วงหน้า 1 วัน (วันจันทร์-วันศุกร์)</strong> */}
              จะต้องทำรายการล่วงหน้า 1 วัน ก่อนเวลา 15.00 น.
              (วันจันทร์-วันศุกร์)
            </li>
            <li>
              ทางขนส่ง จะดำเนินการจัดเก็บพัสดุของเย็น ไม่เกิน 3
              วันทำการนับแต่วันที่เข้ารับพัสดุ
            </li>
            <li>หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง</li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              Door to Door delivery service, Next Day Delivery, starting price
              of only 140 baht.
            </li>
            <li>
              Easy to use, just “Print, Attach, Send” by printing the label and
              attaching it to the parcel box.
            </li>
            <li>
              “Deliver Your Happiness” delivering the parcel on time, fast and
              accurate service.
            </li>
            <li>
              Fully equipped with Cool TA-Q-BIN (Cool Parcel Delivery) Frozen
              technology, temperature about 0 °c to -15 °c
            </li>
            <li>No parcel damage during delivery</li>
            <li>
              Pick up from 1 piece or more in the Bangkok and metropolitan area{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1K69fT3j2jErxtSWGsIBRZmOGixAsPHT-GYEBESXB3qg/edit?usp=sharing"
                target="_blank"
              >
                Pickup and delivery area
              </MuiLink>
            </li>
            <li>
              Can pick up items with box size ( Width + Length + Height ) not
              exceeding 120 centimeters
            </li>
            <li>
              Weight over 25 kilograms; if the parcel size exceeds the limit or
              is incorrectly specified, additional shipping fees will be charged.
            </li>
            <li>
              The items inside must be frozen at a temperature below -15 degrees
              Celsius for at least 12 hours before delivery.
            </li>
            <li>
              {/* (วันจันทร์-วันศุกร์)
              <strong>จองล่วงหน้า 1 วัน (วันจันทร์-วันศุกร์)</strong> */}
              A shipment must be created 1 day in advance before 15:00.
              (Monday-Friday)
            </li>
            <li>
              The courier will store the frozen parcel for no more than 3
              business days from the date the parcel is picked up.
            </li>
            <li>If the item is returned, fees will be charged afterward.</li>
          </ul>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง Ninjavan',
        'Courier details: Ninjavan'
      )]: trans(
        <>
          <p>บริการรับ-ส่งสินค้าถึงบ้านหน้า (Door to Door)</p>
          <ul>
            <li>ใช้ง่ายเพียง “ปริ้น แปะ ส่ง”</li>
            <li>
              รับสินค้าถึงหน้าบ้าน (Door to Door) พื้นที่กรุงเทพและปริมลฑล /
              จัดส่งทั่วไทย
            </li>
            <li>ราคาเริ่มต้นเพียง 24 บาทเท่านั้น</li>
          </ul>
        </>,
        <>
          <p>Door to Door delivery service</p>
          <ul>
            <li>Easy to use, just “Print, Attach, Send”</li>
            <li>
              Door to Door pickup in the Bangkok and metropolitan area /
              delivery throughout Thailand
            </li>
            <li>Starting price of only 24 baht</li>
          </ul>
        </>
      ),
      [trans(
        'พื้นที่เข้ารับและพื้นที่จัดส่ง Ninja Van',
        'Pickup and delivery areas: Ninja Van'
      )]: trans(
        <>
          <ol>
            <li>
              กรุงเทพฯ และปริมณฑล = กรุงเทพ สมุทรปราการ นนทบุรี และปทุมธานี
            </li>
            <li>
              ต่างจังหวัด = พื้นที่จังหวัดอื่นที่ไม่ได้อยู่ในกรุงเทพฯ
              และปริมณฑล โดยสามารถตรวจสอบพื้นที่เข้ารับ
              <MuiLink
                href="https://drive.google.com/file/d/1oNiE24I-8zRH6ts9bYlHTl3Tm5FzWp7K/view"
                target="_blank"
              >
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              พื้นที่ห่างไกลโดยจะส่งผ่านพาร์ทเนอร์ คิดค่าบริการ 50 บาท/กล่อง
            </li>
            <li>
              ตรวจสอบพื้นที่ห่างไกล{' '}
              <MuiLink
                href="https://drive.google.com/file/d/1y4tl7zUU8kaDm6_L_VH8Z2apkvW4Fz3Y/view?usp=sharing"
                target="_blank"
              >
                คลิกที่นี่
              </MuiLink>
            </li>
          </ol>
        </>,
        <>
          <ol>
            <li>
              Bangkok and metropolitan area = Bangkok, Samut Prakan, Nonthaburi,
              and Pathum Thani
            </li>
            <li>
              Provinces = other provincial areas not in Bangkok and the
              metropolitan area. You can check the pickup area
              <MuiLink
                href="https://drive.google.com/file/d/1oNiE24I-8zRH6ts9bYlHTl3Tm5FzWp7K/view"
                target="_blank"
              >
                click here
              </MuiLink>
            </li>
            <li>
              Remote areas will be sent through partners, with a fee of 50
              baht/box
            </li>
            <li>
              Check remote areas{' '}
              <MuiLink
                href="https://drive.google.com/file/d/1y4tl7zUU8kaDm6_L_VH8Z2apkvW4Fz3Y/view?usp=sharing"
                target="_blank"
              >
                click here
              </MuiLink>
            </li>
          </ol>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Ninja Van',
        'Terms of service: Ninja Van'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้า และแปะลงบนกล่องพัสดุ</li>
            <li>
              ชำระเงินก่อน 11.59 น. รับสินค้าวันเดียวกัน หากชำระหลัง 12.00 น.
              เข้ารับสินค้าวันถัดไป
            </li>
            <li>
              เข้ารับและจัดส่งพัสดุทุกวันจันทร์ - เสาร์
              (ยกเว้นวันอาทิตย์และวันหยุด)
            </li>
            <li>
              เข้ารับพัสดุถึงบ้านเฉพาะพื้นที่กรุงเทพฯ และปริมณฑลเท่านั้น
            </li>
            <li>ต้องมีขั้นต่ำ 1 ชิ้น</li>
            <li>
              <strong>ปลายทางกรุงเทพฯ ปริมณฑล และต่างจังหวัด</strong>
              <ol>
                <li>
                  ขนาดพัสดุ (กว้าง + ยาว + สูง) ไม่เกิน 180 เซนติเมตร และ
                  ด้านใดด้านหนึ่งต้องไม่เกิน 100 เซนติเมตร
                </li>
                <li>
                  น้ำหนักไม่เกิน 20 กิโลกรัม กรณีน้ำหนักเกิน 20 กก.
                  ขนส่งจะปฏิเสธการรับพัสดุชิ้นนั้น ระยะเวลาในการจัดส่งพัสดุ
                </li>
              </ol>
            </li>
            <li>
              <strong>ระยะเวลาในการจัดส่งพัสดุ</strong>
              <ol>
                <li>
                  พื้นที่กรุงเทพฯ และปริมณฑล ใช้เวลาการจัดส่งประมาณ 1-2
                  วันทำการ
                </li>
                <li>
                  พื้นที่ต่างจังหวัด ใช้เวลาการจัดส่งประมาณ 2-3 วันทำการ
                </li>
                <li>
                  พื้นที่ห่างไกล ใช้เวลาประมาณ 3-6 วันทำการ
                  ไม่รวมวันที่รับของและวันหยุดนักขัตฤกษ์
                  (ยกเว้นกรณีที่เกิดปัญหาต่างๆ เช่น ไม่สามารถติดต่อปลายทางได้,
                  - ภัยธรรมชาติ, อุบัติเหตุต่างๆ เป็นต้น
                  อาจทำให้เกิดความล่าช้า)
                </li>
              </ol>
            </li>
            <li>
              หากพัสดุมีขนาดหรือน้ำหนักเกินกำหนด
              อาจจะทำให้เกิดความล่าช้าในการจัดส่ง
              และจะมีการเรียกเก็บเงินค่าขนส่งเพิ่มเติมภายหลัง
              โดยคำนวณตามค่าน้ำหนักที่แท้จริงจากขนส่ง
            </li>
            <li>มหากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง</li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the label and attach it to the parcel box</li>
            <li>
              Pay before 11:59, and the item is picked up the same day. If paid
              after 12:00, the item is picked up the next day.
            </li>
            <li>
              Pickup and delivery every Monday - Saturday (except Sunday and
              holidays)
            </li>
            <li>
              Home pickup only in the Bangkok and metropolitan area
            </li>
            <li>Minimum of 1 piece required</li>
            <li>
              <strong>Bangkok, metropolitan, and provincial destinations</strong>
              <ol>
                <li>
                  Parcel size (Width + Length + Height) not exceeding 180
                  centimeters and each side must not exceed 100 centimeters
                </li>
                <li>
                  Weight not exceeding 20 kilograms. If the weight exceeds 20
                  kg, the courier will refuse to pick up that parcel. Parcel
                  delivery time
                </li>
              </ol>
            </li>
            <li>
              <strong>Parcel delivery time</strong>
              <ol>
                <li>
                  Bangkok and metropolitan area, delivery takes about 1-2
                  business days
                </li>
                <li>
                  Provincial areas, delivery takes about 2-3 business days
                </li>
                <li>
                  Remote areas, takes about 3-6 business days, excluding the
                  pickup date and public holidays (except in cases of various
                  problems such as being unable to contact the destination, -
                  natural disasters, various accidents, etc., which may cause
                  delays)
                </li>
              </ol>
            </li>
            <li>
              If the parcel exceeds the size or weight limit, it may cause
              delays in delivery, and additional shipping fees will be charged
              afterward, calculated based on the actual weight from the courier.
            </li>
            <li>If the item is returned, fees will be charged afterward.</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการตีคืนสินค้า Ninja Van',
        'Return conditions: Ninja Van'
      )]: trans(
        <>
          <ol>
            <li>
              ติดต่อผู้รับปลายทางไม่ได้ หรือไปจัดส่งแล้วแต่ไม่มีคนรับครบกำหนด
              3 ครั้งจะทำการตีคืนโดยอัตโนมัติ
            </li>
            <li>
              ผู้ส่งแจ้งขอยกเลิกการจัดส่ง หรือ ผู้รับแจ้งปฏิเสธการรับพัสดุ
            </li>
            <li>พัสดุมีการห่อหุ้มไม่ตรงตามเงื่อนไขที่ทางขนส่งกำหนดไว้</li>
            <li>
              ค่าประกันความเสียหายของพัสดุ จากการส่ง Ninja Van เป็นจำนวน 2,000
              บาท
            </li>
          </ol>
        </>,
        <>
          <ol>
            <li>
              If the recipient cannot be contacted, or delivery was attempted
              but no one received it for 3 times, it will be returned
              automatically.
            </li>
            <li>
              The sender requests to cancel the delivery, or the recipient
              refuses to accept the parcel.
            </li>
            <li>The parcel packaging does not meet the conditions specified by the courier.</li>
            <li>
              The parcel damage insurance for Ninja Van shipping is 2,000 baht.
            </li>
          </ol>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง Flash Express',
        'Courier details: Flash Express'
      )]: trans(
        <>
          <p>
            บริการรับ-ส่งสินค้าถึงบ้านหน้า (Door to Door) ฟรีตั้งแต่ชิ้นแรก
            เป็นขนส่งจากประเทศจีน และประเทศไทย
            มีบริการจัดส่งพัสดุถึงมือลูกค้าครอบคลุบทั่วประเทศไทย
            โดยให้บริการขนส่งที่รวดเร็ว ปลอดภัย และมืออาชีพ
            มุ่งเน้นการทำงานบนความซื่อสัตย์สุจริต และมีความจริงใจต่อลูกค้า
          </p>
          <p>
            Flash Express ขนส่งพัสดุภายใต้นโยบายที่ว่า{' '}
            <strong>
              “สิ่งที่เราส่งอยู่ไม่ใช่สินค้า แต่เป็นความคิดถึง
              เราจะดูแลความคิดถึงของคุณให้ดีที่สุด”
            </strong>{' '}
            เพื่อให้ลูกค้าได้มั่นใจว่าพัสดุในมือเราทุกชิ้น
            พนักงานทุกคนจะดูแลพัสดุอย่างดีควบคู่กับเทคโนโลยีที่ทันสมัย
            ให้การขนส่งพัสดุปลอดภัยและน่าเชื่อถือมากที่สุด
          </p>
          <ul>
            <li>ใช้ง่ายๆเพียง “ปริ้น แปะ ส่ง”</li>
            <li>ราคาเริ่มต้นเพียง 21 บาทเท่านั้น</li>
          </ul>
        </>,
        <>
          <p>
            Door to Door delivery service, free from the first piece. A courier
            from China and Thailand, providing parcel delivery to customers
            covering all of Thailand, with fast, safe, and professional
            service, focusing on working with honesty and sincerity toward
            customers.
          </p>
          <p>
            Flash Express delivers parcels under the policy that{' '}
            <strong>
              “What we deliver is not a product, but a thought of someone. We
              will take the best care of your thoughts.”
            </strong>{' '}
            To assure customers that every parcel in our hands, all staff will
            take good care of the parcel together with modern technology, making
            parcel delivery as safe and reliable as possible.
          </p>
          <ul>
            <li>Easy to use, just “Print, Attach, Send”</li>
            <li>Starting price of only 21 baht</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Flash Express',
        'Terms of service: Flash Express'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้า และแปะลงบนกล่องพัสดุ</li>
            <li>เข้ารับสินค้าพัสดุถึงหน้าบ้าน</li>
            <li>
              <strong>
                พื้นที่ กรุงเทพ ปริมณฑลและต่างจังหวัด ต้องสร้างรายการก่อนเวลา
                12.00 น.
              </strong>{' '}
              จะเข้ารับในวันเดียวกัน แต่ไม่เกิน 18.00 น.{' '}
              <strong>
                สำหรับพื้นที่ห่างไกลจะต้องทำรายการล่วงหน้า 1 วัน
              </strong>
              ได้แก่ ภูเขา เกาะ และพื้นที่พิเศษ
            </li>
            <li>
              กรุงเทพ ปริมณฑล จัดส่งในวันถัดไป หรือ 1 - 2 วัน และต่างจังหวัด
              จัดส่งภายใน 1 - 3 วัน ไม่รวมวันเข้ารับ
            </li>
            <li>
              กรณีพัสดุมีการตีคืนทางผู้ให้บริการจะคิดค่าบริการตามจริงโดยคำนวณจากค่าขนส่งจากพื้นที่ปลายทาง
              กลับมายังพื้นที่ต้นทาง
            </li>
            <li>
              พัสดุหีบห่อไม่เหมาะสม หรือไม่เพียงพอ เช่น
              การแพ็คสินค้าแบบใส่ถุงพลาสติก ถุงกระดาษ ห่อด้วยกระดาษ
              กล่องประกอบการดัดแปลงกล่อง หรือ ซองใส่พัสดุ
              จะปฏิเสธการเคลมสินค้า
            </li>
            <li>
              ประกันค่าความเสียหายและการสูญหายที่เกิดจากขนส่ง สูงสุดไม่เกิน
              2,000 บาท (สามารถซื้อประกันเพิ่มได้ *รายละเอียดประกันเช็ค API)
            </li>
            <li>
              <strong>ขนาดและน้ำหนักสินค้าที่สามารถเข้ารับได้</strong>
              <ol>
                <li>น้ำหนักไม่เกิน 50 กิโลกรัม</li>
                <li>
                  สามารถเข้ารับสินค้าขนาดกล่อง ( กว้าง + ยาว + สูง ){' '}
                  <strong>ไม่เกิน 280 เซนติเมตร</strong> และ
                  ด้านใดด้านหนึ่งต้อง ไม่เกิน 150 เซนติเมตร
                  *เป็นไปตามมาตรฐานที่ขนส่งกำหนด
                </li>
              </ol>
            </li>
            <li>
              หากขนาดพัสดุมีน้ำหนักเกินจากที่ระบุ
              จะมีการเรียกเก็บเงินค่าขนส่งเพิ่มเติมภายหลัง
              โดยคำนวณตามค่าน้ำหนักที่แท้จริงจากขนส่ง
            </li>
            <li>
              สินค้าที่ขนส่งไม่อาจยอมรับได้ ได้แก่ สัตว์ ทอง เงินสกุล อัญมณี
              อาวุธ วัตถุระเบิด กระสุน สื่อลามกอนาจาร ชิ้นส่วนมนุษย์
              สิ่งของที่ผิดกฎหมาย เช่น ยาเสพติด หรือสินค้าจำพวกวัตถุอันตราย
              สิ่งของต้องห้าม เป็นต้น
            </li>
            <li>
              การส่งมอบพัสดุจะถูกส่งไปยังที่อยู่ปลายทางของผู้รับ
              แต่ไม่จำเป็นต้องส่งถึงตัวผู้รับที่ระบุชื่อไว้
              ในกรณีที่ไม่สามารถจัดส่งได้จะเสนอทางเลือกให้ผู้รับ เช่น
              การส่งมอบในวันอื่น ไม่ต้องมีการลงนาม หรือให้ไปรับที่จุดบริการ
            </li>
            <li>
              กรณีสำหรับพื้นที่ห่างไกล ภูเขา และเกาะ มีค่าบริการเพิ่ม จำนวน 50
              บาทในอำเภอที่ขนส่งกำหนด ได้แก่ เชียงใหม่ น่าน แม่ฮ่องสอน ตาก
              เพชรบูรณ์ ตราด กาญจนบุรี กระบี่ พังงา สุราษฏร์ธานี นราธิวาส ตรัง
              ปัตตานี ยะลา{' '}
              <MuiLink
                href="https://drive.google.com/file/d/1iEZxIJkA8uUo8DsD3h6tRBYGR97uRVem/view?usp=sharing"
                target="_blank"
              >
                ตรวจสอบพื้นที่พิเศษ คลิกที่นี่
              </MuiLink>
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the label and attach it to the parcel box</li>
            <li>Home pickup of the parcel</li>
            <li>
              <strong>
                For Bangkok, metropolitan, and provincial areas, a shipment must
                be created before 12:00
              </strong>{' '}
              to be picked up the same day, but not later than 18:00.{' '}
              <strong>
                For remote areas, a shipment must be created 1 day in advance
              </strong>
              , including mountains, islands, and special areas.
            </li>
            <li>
              Bangkok and metropolitan area: delivery on the next day or 1 - 2
              days, and provinces: delivery within 1 - 3 days, excluding the
              pickup day.
            </li>
            <li>
              In the case of a parcel being returned, the service provider will
              charge the actual fee calculated from the shipping cost from the
              destination area back to the origin area.
            </li>
            <li>
              Improper or insufficient packaging, such as packing the item in a
              plastic bag, paper bag, wrapping with paper, modifying a box, or a
              parcel envelope, will result in a claim being refused.
            </li>
            <li>
              Insurance for damage and loss caused by the courier, up to a
              maximum of 2,000 baht (additional insurance can be purchased
              *insurance details check API)
            </li>
            <li>
              <strong>Size and weight of items that can be picked up</strong>
              <ol>
                <li>Weight not exceeding 50 kilograms</li>
                <li>
                  Can pick up items with box size ( Width + Length + Height ){' '}
                  <strong>not exceeding 280 centimeters</strong> and each side
                  must not exceed 150 centimeters *in accordance with the
                  standards specified by the courier
                </li>
              </ol>
            </li>
            <li>
              If the parcel weight exceeds what is specified, additional
              shipping fees will be charged afterward, calculated based on the
              actual weight from the courier.
            </li>
            <li>
              Items that the courier cannot accept include animals, gold,
              currency, jewelry, weapons, explosives, ammunition, obscene
              material, human parts, illegal items such as drugs, or hazardous
              goods, prohibited items, etc.
            </li>
            <li>
              The parcel will be delivered to the recipient's destination
              address, but it does not necessarily have to be delivered to the
              named recipient. In cases where delivery is not possible, options
              will be offered to the recipient, such as delivery on another day,
              no signature required, or pickup at a service point.
            </li>
            <li>
              For remote areas, mountains, and islands, there is an additional
              fee of 50 baht in the districts specified by the courier,
              including Chiang Mai, Nan, Mae Hong Son, Tak, Phetchabun, Trat,
              Kanchanaburi, Krabi, Phang Nga, Surat Thani, Narathiwat, Trang,
              Pattani, Yala{' '}
              <MuiLink
                href="https://drive.google.com/file/d/1iEZxIJkA8uUo8DsD3h6tRBYGR97uRVem/view?usp=sharing"
                target="_blank"
              >
                Check special areas, click here
              </MuiLink>
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการใช้บริการเก็บเงินปลายทาง Flash express',
        'Cash on Delivery terms of service: Flash express'
      )]: trans(
        <>
          <ol>
            <li>
              ยืนยันตัวตนด้วยบัตรประชาชนและ
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=BankAccount`}
                target="_blank"
              >
                บัญชีธนาคาร
              </MuiLink>{' '}
              ที่ หน้า
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=ConfirmAccount`}
                target="_blank"
              >
                ยืนยันตัวตน
              </MuiLink>
            </li>
            <li>
              สร้างรายการเก็บของโดยกรอกข้อมูลที่ช่องเก็บเงินปลายทาง
              ซึ่งจะปรากฏขึ้นหลังจากที่ได้ยืนยันตัวตน ตามข้อที่ 1
            </li>
            <li>พิมพ์ใบปะหน้า และแปะลงบนหน้ากล่อง</li>
            <li>เข้ารับสินค้าพัสดุถึงหน้าบ้าน</li>
            <li>
              ชำระเงินก่อน 12.00 น. เข้ารับสินค้าวันเดียวกัน หากชำระหลัง 12.01
              น. จะเข้ารับสินค้าในวันถัดไป สามารถใช้บริการรับพัสดุถึงหน้าบ้าน
              โดยเข้ารับทุกวันจันทร์ - อาทิตย์
            </li>
            <li>กรณีไม่มีหีบห่อ หากเกิดความเสียหายจะปฏิเสธการเคลมสินค้า</li>
            {/* <li>
              ขนาดและน้ำหนักสินค้าที่สามารถเข้ารับได้
              <ul>
                <li>
                  ขนาดของพัสดุ (กว้าง+ยาว+สูง) ไม่เกิน 280 ซม.
                  โดยแต่ละด้านขนาดไม่เกิน 150 ซม.
                </li>
                <li>นํ้าหนักสูงสุดของพัสดุไม่เกิน 50 กิโลกรัม</li>
              </ul>
            </li> */}
            <li>
              Flash express จะคิดค่าธรรมเนียมเก็บเงินปลายทาง
              คิดจากยอดเรียกเก็บ 3 % ไม่มีขั้นต่ำ COD
            </li>
            <li>
              บริษัทจะทําการโอนเงินที่รับชําระมาแล้ว ทุกวันศุกร์
              หากเป็นวันหยุดจะทําการโอนคืน ในวันทําการถัดไป
            </li>
            <li>
              ยอดโอนคืนขั้นตํ่า 500 บาท หลังหักค่าธรรมเนียม COD (3%) แล้ว
              ส่วนค่าธรรมเนียมในการโอนขึ้นอยู่กับธนาคารของผู้ใช้งาน
            </li>
            <li>
              กำหนดการใช้บริการ COD ยอดขั้นตํ่าของสินค้า คือ 100 บาท
              สูงสุดไม่เกิน 50,000 บาท
            </li>
            <li>การรับประกันสินค้าตามราคาจริง และไม่เกิน 2,000 บาท</li>
            <li>
              หากระบุข้อมูลปลายทางผิดพลาด ทางบริษัทขอสงวนสิทธิ์ ในการแก้ไข
              ยกเลิกและคืนเงิน หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง
            </li>
          </ol>
        </>,
        <>
          <ol>
            <li>
              Verify your identity with an ID card and
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=BankAccount`}
                target="_blank"
              >
                bank account
              </MuiLink>{' '}
              on the
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=ConfirmAccount`}
                target="_blank"
              >
                Verify Identity
              </MuiLink>{' '}
              page
            </li>
            <li>
              Create a shipment by filling in the information in the Cash on
              Delivery field, which will appear after you have verified your
              identity as in item 1.
            </li>
            <li>Print the label and attach it to the front of the box</li>
            <li>Home pickup of the parcel</li>
            <li>
              Pay before 12:00 to have the item picked up the same day. If paid
              after 12:01, the item will be picked up the next day. You can use
              the home pickup service, with pickup every Monday - Sunday.
            </li>
            <li>If there is no packaging and damage occurs, the claim will be refused.</li>
            {/* <li>
              ขนาดและน้ำหนักสินค้าที่สามารถเข้ารับได้
              <ul>
                <li>
                  ขนาดของพัสดุ (กว้าง+ยาว+สูง) ไม่เกิน 280 ซม.
                  โดยแต่ละด้านขนาดไม่เกิน 150 ซม.
                </li>
                <li>นํ้าหนักสูงสุดของพัสดุไม่เกิน 50 กิโลกรัม</li>
              </ul>
            </li> */}
            <li>
              Flash express charges a Cash on Delivery fee of 3% of the
              collection amount, with no minimum COD.
            </li>
            <li>
              The company will transfer the collected payment every Friday. If
              it is a holiday, the transfer will be made on the next business
              day.
            </li>
            <li>
              The minimum refund transfer amount is 500 baht after deducting the
              COD fee (3%). The transfer fee depends on the user's bank.
            </li>
            <li>
              The COD service requires a minimum item amount of 100 baht, up to
              a maximum of 50,000 baht.
            </li>
            <li>Product insurance at the actual price, not exceeding 2,000 baht.</li>
            <li>
              If the destination information is incorrect, the company reserves
              the right to edit, cancel, and refund. If the item is returned,
              fees will be charged afterward.
            </li>
          </ol>
        </>
      ),
      [trans(
        'พื้นที่จัดส่งพิเศษ Flash Express',
        'Special delivery areas: Flash Express'
      )]: trans(
        <>
          <p>
            การจัดส่งพัสดุ ด้วย Flash Express มีพื้นที่พิเศษ ในการจัดส่ง
            ซึ่งจะใช้เวลาในการจัดส่งเพิ่มขึ้น จากปกติ 1-2 วัน และ
            คิดค่าบริการในการจัดส่งเพิ่ม จากค่าจัดส่งปกติ ชิ้นละ 50 บาท
            <br />
            <br />
            <MuiLink
              href="https://drive.google.com/file/d/1iEZxIJkA8uUo8DsD3h6tRBYGR97uRVem/view?usp=sharing"
              target="_blank"
            >
              ตรวจสอบพื้นที่พิเศษ คลิกที่นี่
            </MuiLink>
          </p>
        </>,
        <>
          <p>
            Delivery with Flash Express has special areas for delivery, which
            take an additional 1-2 days longer than normal, and an additional
            delivery fee of 50 baht per piece on top of the normal delivery fee.
            <br />
            <br />
            <MuiLink
              href="https://drive.google.com/file/d/1iEZxIJkA8uUo8DsD3h6tRBYGR97uRVem/view?usp=sharing"
              target="_blank"
            >
              Check special areas, click here
            </MuiLink>
          </p>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง Flash Bulky',
        'Courier details: Flash Bulky'
      )]: trans(
        <>
          <p>
            บริการส่งพัสดุขนาดใหญ่ (Door to Door Services) ฟรีตั้งแต่ชิ้นแรก
          </p>
          <p>
            " Flash Bulky " คือ การส่งสินค้า Bulky พร้อมกับคอนเซปต์
            “ส่งของใหญ่ ไว้ใจแฟลช” เป็นบริการส่งพัสดุขนาดใหญ่
            ที่มีน้ำหนักตั้งแต่ 5 – 100 กิโลกรัม เข้ารับบริการฟรีถึงหน้าบ้าน
          </p>
        </>,
        <>
          <p>
            Large parcel delivery service (Door to Door Services), free from the
            first piece.
          </p>
          <p>
            " Flash Bulky " is the delivery of Bulky items with the concept
            “Send big items, trust Flash”. It is a large parcel delivery service
            for items weighing from 5 – 100 kilograms, with free home pickup.
          </p>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Flash Bulky',
        'Terms of service: Flash Bulky'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้า และแปะลงบนกล่องพัสดุ</li>
            <li>เข้ารับพัสดุถึงหน้าบ้าน</li>
            <li>
              คำนวณค่าบริการขนส่งตามน้ำหนักจริงหรือน้ำหนักปริมาตร
              (กว้าง×ยาว×สูง) หารด้วย 6000 และปัดเศษทศนิยมขึ้น
              โดยจะเลือกคิดค่าบริการขนส่งตามจำนวนที่มากกว่า
            </li>
            <li>
              พัสดุจะต้องมีขนาดสูงสุดต่อพัสดุไม่เกิน 400 ซม. (กว้าง+ยาว+สูง)
              และน้ำหนักจริงต่อพัสดุจะต้องไม่เกิน 100 กก.
              โดยความยาวของพัสดุแต่ละด้านจะต้องไม่เกิน 160 ซม.{' '}
            </li>
            <li>น้ำหนักจริงเกิน 100 กก. ไม่สามารถส่งได้</li>
            <li>
              หากน้ำหนักปริมาตรเกิน 100 กก. สามารถส่งได้
              ค่าบริการขนส่งจะถูกคำนวณโดยน้ำหนัก 100 กก. + 20 บาทต่อ กก.{' '}
            </li>
            <li>
              สำหรับบริการรับพัสดุถึงหน้าบ้านให้บริการทุกวันจันทร์ - อาทิตย์
              (โดยไม่มีวันหยุด)
            </li>
            <li>
              สพื้นที่ กรุงเทพ ปริมณฑลและต่างจังหวัด ต้องสร้างรายการก่อนเวลา
              12.00 น. จะเข้ารับในวันเดียวกัน แต่ไม่เกิน 18.00 น.
              สำหรับพื้นที่ห่างไกลจะต้องทำรายการล่วงหน้า 1 วันได้แก่ ภูเขา
              เกาะ และพื้นที่พิเศษ
            </li>
            <li>
              ระยะเวลาการดำเนินการขนส่ง
              <ul>
                <li>
                  กรณีขนส่งพัสดุภายในจังหวัดเดียวกัน จะดำเนินการส่งภายใน 2-3
                  วัน
                </li>
                <li>
                  กรณีขนส่งพัสดุข้ามจังหวัด จะดำเนินการภายใน 2-4 วัน
                  (ซึ่งไม่รวมวันเข้ารับ)
                </li>
                <li>
                  กรณีขนส่งพัสดุในพื้นที่ห่างไกล จะดำเนินการภายใน 3 - 4 วัน
                  (ซึ่งไม่รวมวันเข้ารับ)
                </li>
              </ul>
            </li>
            <li>
              ประกันค่าความเสียหายและการสูญหายที่เกิดจากขนส่ง สูงสุดไม่เกิน
              2,000 บาท
            </li>
            <li>
              ค่าธรรมเนียมเก็บเงินปลายทาง คิดจากยอดเรียกเก็บ COD 3 %
              ไม่มีขั้นต่ำ
            </li>
            <li>
              ในกรณีพัสดุถูกตีคืน
              บริษัทจะคิดค่าบริการขนส่งตามจริงโดยคำนวณจากค่าบริการขนส่งจากพื้นที่ปลายทาง
              กลับมายังพื้นที่ต้นทาง
            </li>
            <li>
              พัสดุจะต้องมีการห่อหุ้มที่แข็งแรงเหมาะสมต่อการขนส่งและเป็นไปตามข้อกำหนด
              เงื่อนไขการบริการ และมาตรฐานที่ Flash Express กำหนด
            </li>
          </ul>
          <div>
            หมายเหตุ : ขนส่งอาจปฏิเสธรับพัสดุของท่าน
            หากสินค้าแพ็คไม่ถูกต้องหรือไม่ได้มาตรฐาน
          </div>
        </>,
        <>
          <ul>
            <li>Print the label and attach it to the parcel box</li>
            <li>Home pickup of the parcel</li>
            <li>
              The shipping fee is calculated based on the actual weight or the
              volumetric weight (Width × Length × Height) divided by 6000 and
              rounded up. The shipping fee is charged based on the greater
              amount.
            </li>
            <li>
              The parcel must have a maximum size per parcel of no more than 400
              cm. (Width + Length + Height), and the actual weight per parcel
              must not exceed 100 kg, with each side of the parcel not exceeding
              160 cm.{' '}
            </li>
            <li>Actual weight exceeding 100 kg cannot be shipped.</li>
            <li>
              If the volumetric weight exceeds 100 kg, it can be shipped. The
              shipping fee will be calculated as a weight of 100 kg + 20 baht per
              kg.{' '}
            </li>
            <li>
              The home pickup service is available every Monday - Sunday (with
              no days off).
            </li>
            <li>
              For Bangkok, metropolitan, and provincial areas, a shipment must
              be created before 12:00 to be picked up the same day, but not
              later than 18:00. For remote areas, a shipment must be created 1
              day in advance, including mountains, islands, and special areas.
            </li>
            <li>
              Shipping processing time
              <ul>
                <li>
                  In the case of shipping a parcel within the same province, it
                  will be delivered within 2-3 days.
                </li>
                <li>
                  In the case of shipping a parcel across provinces, it will be
                  processed within 2-4 days (excluding the pickup day).
                </li>
                <li>
                  In the case of shipping a parcel to a remote area, it will be
                  processed within 3 - 4 days (excluding the pickup day).
                </li>
              </ul>
            </li>
            <li>
              Insurance for damage and loss caused by the courier, up to a
              maximum of 2,000 baht.
            </li>
            <li>
              Cash on Delivery fee, calculated at 3% of the COD collection
              amount, with no minimum.
            </li>
            <li>
              In the case of a parcel being returned, the company will charge
              the actual shipping fee calculated from the shipping fee from the
              destination area back to the origin area.
            </li>
            <li>
              The parcel must have strong packaging suitable for shipping and in
              accordance with the requirements, service conditions, and
              standards specified by Flash Express.
            </li>
          </ul>
          <div>
            Note : The courier may refuse to accept your parcel if the item is
            packed incorrectly or is not up to standard.
          </div>
        </>
      ),
      [trans(
        'พื้นที่จัดส่งพิเศษ Flash Bulky',
        'Special delivery areas: Flash Bulky'
      )]: trans(
        <>
          <p>
            ค่าบริการเพิ่มเติมสำหรับพื้นที่ห่างไกล
            <ul>
              <li>น้ำหนัก 5-50 กก. คิดค่าบริการเพิ่มเติม 50 บาท/ชิ้น</li>
              <li>น้ำหนัก 51-70 กก. คิดค่าบริการเพิ่มเติม 100 บาท/ชิ้น</li>
              <li>น้ำหนัก 71-100 กก. คิดค่าบริการเพิ่มเติม 200 บาท/ชิ้น</li>
            </ul>
            <p>
              *น้ำหนักมากกว่า 100 กก. คิดค่าบริการบวกเพิ่ม 50 บาท ต่อ 50 กก.
            </p>
            <ul>
              <li>
                ตัวอย่างการคำนวณ
                <ul>
                  <li>
                    พัสดุมีน้ำหนักตั้งแต่ 100 – 150 กก. จะถูกคิดค่าบริการ
                    200+50 = 250 บาท
                  </li>
                  <li>
                    พัสดุมีน้ำหนักตั้งแต่ 150 – 200 กก. จะถูกคิดค่าบริการ
                    250+50 = 300 บาท
                  </li>
                </ul>
              </li>
            </ul>
            <br />
            <br />
            <MuiLink
              href="https://drive.google.com/file/d/1iEZxIJkA8uUo8DsD3h6tRBYGR97uRVem/view"
              target="_blank"
            >
              ตรวจสอบพื้นที่พิเศษ คลิกที่นี่
            </MuiLink>
          </p>
        </>,
        <>
          <p>
            Additional fees for remote areas
            <ul>
              <li>Weight 5-50 kg, additional fee of 50 baht/piece</li>
              <li>Weight 51-70 kg, additional fee of 100 baht/piece</li>
              <li>Weight 71-100 kg, additional fee of 200 baht/piece</li>
            </ul>
            <p>
              *Weight more than 100 kg, additional fee of 50 baht per 50 kg.
            </p>
            <ul>
              <li>
                Calculation example
                <ul>
                  <li>
                    A parcel weighing from 100 – 150 kg will be charged 200+50 =
                    250 baht
                  </li>
                  <li>
                    A parcel weighing from 150 – 200 kg will be charged 250+50 =
                    300 baht
                  </li>
                </ul>
              </li>
            </ul>
            <br />
            <br />
            <MuiLink
              href="https://drive.google.com/file/d/1iEZxIJkA8uUo8DsD3h6tRBYGR97uRVem/view"
              target="_blank"
            >
              Check special areas, click here
            </MuiLink>
          </p>
        </>
      ),
      // 'รายละเอียดขนส่ง True e-logistic': (
      //   <>
      //     <p>บริการรับ-ส่งสินค้าถึงบ้านหน้า (Door to Door)</p>
      //     <ul>
      //       <li>ใช้ง่ายๆเพียง “ปริ้น แปะ ส่ง”</li>
      //       <li>In Mind, In Delivery คิดถึง ส่งถึง</li>
      //       <li>ราคาเริ่มต้นเพียง 23 บาทเท่านั้น</li>
      //     </ul>
      //   </>
      // ),
      // 'เงื่อนไขการให้บริการ True e-logistics': (
      //   <>
      //     <ul>
      //       <li>
      //         พิมพ์ใบปะหน้าและแปะลงบนกล่องพัสดุ
      //         เพื่อให้ทางทีมขนส่งเข้ารับสินค้าพัสดุถึงหน้าบ้าน
      //       </li>
      //       <li>อัตราค่าบริการ คิดตามน้ำหนักกล่องและสินค้า</li>
      //       <li>
      //         บริการรับพัสดุถึงบ้านลูกค้าและจัดส่งถึงปลายทางในวันถัดไป
      //         โดยขนส่งจะทำการเข้ารับเเละจัดส่งเฉพาะวันจันทร์ ถึง วันเสาร์
      //         (สำหรับวันอาทิตย์ หากสร้างรายการส่งในระบบ
      //         ทางขนส่งจะเข้ารับพัสดุในวันจันทร์)
      //       </li>
      //       <li>
      //         บริการเข้ารับพัสดุเฉพาะในกรุงเทพเเละปริมณฑล (ได้แก่ นนทบุรี,
      //         ปทุมธานี และสมุทรปราการ) และจัดส่งทั่วประเทศ
      //       </li>
      //       <li>
      //         สร้างรายการและชำระค่าบริการจัดส่งพัสดุ​ก่อน ​14.00​ น.​
      //         และทางบริษัทขนส่งจะเข้ารับพัสดุในวันเดียวกัน
      //         หากสร้างรายการหลังจาก 14.01 น. เข้ารับพัสดุในวันถัดไป
      //       </li>
      //       <li>การเข้ารับสินค้า ต้องมียอดจัดส่งขั้นต่ำ 1 ชิ้น ขึ้นไป</li>
      //       <li>
      //         ระยะเวลาในการจัดส่ง พัสดุจะถึงมือผู้รับในพื้นที่กรุงเทพฯ
      //         และปริมณฑลภายใน 1-2 วัน สำหรับต่างจังหวัดภายใน 2-4 วัน
      //       </li>
      //       <li>ขนาดและน้ำหนักสินค้าที่สามารถเข้ารับได้</li>
      //       <ol>
      //         <li>
      //           น้ำหนัก <strong>ไม่เกิน 30 กิโลกรัม</strong>
      //         </li>
      //         <li>
      //           สามารถเข้ารับสินค้าขนาดกล่อง (กว้าง+ยาว+สูง ) ไม่เกิน 200 ซม.
      //           และ ด้านใดด้านหนึ่งต้องไม่เกิน 150 ซม.
      //           โดยในกรณีจะทำการส่งพัสดุ ขนาดกล่อง (กว้าง+ยาว+สูง)
      //           รวมกันทุกด้านเกิน 120 เซนติเมตร หรือ ด้านใดด้านหนึ่งเกินกว่า
      //           50 เซนติเมตร หรือ น้ำหนักของทุกกล่องรวมกันเกินกว่า 20 กิโลกรัม
      //           จะต้องทำการเเจ้งล่วงหน้าอย่างน้อย 1 วัน ผ่านทางอีเมล
      //           cs@shippop.com หรือ Line : @shippop
      //         </li>
      //       </ol>
      //       <li>
      //         กรณี มีการเปลี่ยนแปลงที่อยู่จัดส่ง จะมีค่าบริการเพิ่ม
      //         โดยค่าบริการราคาเดียวกับค่าขนส่ง
      //       </li>
      //       <li>
      //         กรณี มีการตีคืน/ส่งคืน จะมีค่าบริการเพิ่ม 50% จากราคาค่าส่ง
      //       </li>
      //       <li>
      //         ค่าประกันสินค้ากรณีเสียหายและสูญหาย วงเงินประกันไม่เกิน 2,000
      //         บาท/ชิ้น{' '}
      //       </li>
      //       <li>
      //         True e-logistics จะคิดค่าธรรมเนียมเก็บเงินปลายทาง
      //         คิดจากยอดเรียกเก็บ COD 3 % โดยมีขั้นต่ำค่าธรรมเนียมที่ 15 บาท
      //         หากยอดชําระเก็บเงินปลายทางตํ่ากว่า 500 บาท จะเสียค่าธรรมเนียม 15
      //         บาท ต่อรายการ
      //       </li>
      //     </ul>
      //   </>
      // ),
      [trans('รายละเอียดขนส่ง Aramex', 'Courier details: Aramex')]: trans(
        <>
          <p>
            บริการรับ-ส่งสินค้าถึงบ้านหน้า (Door to Door) เป็นแบบ Next Day
          </p>
          <ul>
            <li>ใช้ง่ายเพียง “ปริ้น แปะ ส่ง”</li>
            <li>ราคาเริมต้นเพียง 25 บาทเท่านั้น</li>
            <li>รับ-ส่งสินค้าถึงบ้านในพื้นที่ กทม. และไม่มีพื้นที่ปริมณฑล</li>
            <li>สินค้าตั้งแต่ 1 ชิ้นขึ้นไป</li>
          </ul>
        </>,
        <>
          <p>Door to Door delivery service, Next Day type</p>
          <ul>
            <li>Easy to use, just “Print, Attach, Send”</li>
            <li>Starting price of only 25 baht</li>
            <li>Home pickup and delivery in the Bangkok area, no metropolitan area</li>
            <li>From 1 piece or more</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Aramex',
        'Terms of service: Aramex'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้าพัสดุที่ได้จากระบบ และแปะลงบนหน้ากล่องพัสดุ</li>
            <li>
              บริการรับพัสดุถึงบ้านลูกค้าและจัดส่งถึงปลายทางในวันถัดไป{' '}
              <strong>
                ( โดยการเข้ารับพัสดุขนส่งทำการ วันจันทร์ถึงวันเสาร์
                หยุดวันอาทิตย์ )
              </strong>
            </li>
            <li>
              เบื้องต้น เปิดให้ใช้บริการ<strong>เฉพาะพื้นที่โซน</strong>
              <strong> กรุงเทพมหานคร</strong> เท่านั้น
            </li>
            <li>
              <strong>ชำระค่าบริการก่อน 12.00 น</strong>.
              เข้ารับพัสดุในวันเดียวกัน{' '}
              <strong>หากสร้างรายการหลังจาก 12.01 น.</strong>{' '}
              เข้ารับพัสดุในวันถัดไป
            </li>
            <li>
              ประกันค่าความเสียหายและการสูญหายที่เกิดจากขนส่ง{' '}
              <strong>สูงสุดไม่เกิน 2,000 บาท</strong>
            </li>
            <li>
              ขนาดและน้ำหนักสินค้าที่สามารถเข้ารับได้ น้ำหนัก
              <strong>ไม่เกิน 10 กิโลกรัม</strong>
              <br />
              สามารถเข้ารับสินค้าขนาดกล่อง{' '}
              <strong>
                {' '}
                ( กว้าง + ยาว + สูง ) ไม่เกิน 280 เซนติเมตร
              </strong>{' '}
              และ <strong>ด้านใดด้านหนึ่งต้อง ไม่เกิน 100 เซนติเมตร</strong>
            </li>
            <li>
              กรณี มีการเปลี่ยนแปลงที่อยู่จัดส่ง
              <strong> จะมีค่าบริการเพิ่ม</strong>
              โดยค่าบริการราคาเดียวกับค่าขนส่ง
            </li>
            <li>
              กรณี มีการตีคืน/ส่งคืน{' '}
              <strong>
                จะมีค่าบริการเพิ่ม โดยค่าบริการราคาเดียวกับค่าขนส่ง
              </strong>
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the parcel label obtained from the system and attach it to the front of the parcel box</li>
            <li>
              Home pickup service and delivery to the destination the next day{' '}
              <strong>
                ( The courier picks up the parcel Monday to Saturday, closed on
                Sunday )
              </strong>
            </li>
            <li>
              Initially, the service is available <strong>only in the zone</strong>
              <strong> of Bangkok</strong> only.
            </li>
            <li>
              <strong>Pay the service fee before 12:00</strong>.
              The parcel is picked up the same day.{' '}
              <strong>If a shipment is created after 12:01</strong>,{' '}
              the parcel is picked up the next day.
            </li>
            <li>
              Insurance for damage and loss caused by the courier,{' '}
              <strong>up to a maximum of 2,000 baht</strong>
            </li>
            <li>
              Size and weight of items that can be picked up: weight
              <strong>not exceeding 10 kilograms</strong>
              <br />
              Can pick up items with box size{' '}
              <strong>
                {' '}
                ( Width + Length + Height ) not exceeding 280 centimeters
              </strong>{' '}
              and <strong>each side must not exceed 100 centimeters</strong>
            </li>
            <li>
              In case of a change to the delivery address,
              <strong> there will be an additional fee</strong>
              at the same rate as the shipping fee.
            </li>
            <li>
              In case of a return/send back,{' '}
              <strong>
                there will be an additional fee at the same rate as the shipping
                fee.
              </strong>
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Lalamove',
        'Terms of service: Lalamove'
      )]: trans(
        <>
          <ul>
            <li>
              ประเภทการใช้งานรถมอไซต์ รับ-ส่งเอกสาร/สิ่งของ น้ำหนักไม่เกิน 20
              กิโลกรัม และมีขนาดไม่เกิน <strong>50+50+50 ซม.</strong>
            </li>
            <li>
              ผู้ใช้ ต้องส่งข้อมูล ชื่อ ที่อยู่ เบอร์โทร ของต้นทาง/ผู้ส่ง
              และของปลายทาง/ผู้รับ ทุกครั้งที่ใช้งาน
              หากข้อมูลไม่ครบถ้วนอาจส่งผลให้การเข้ารับและจัดส่ง มีปัญหา
              ซึ่งทางผู้ใช้ต้องรับผิดชอบค่าใช้งานที่เกิดขึ้น
            </li>
            <li>
              สามารถเรียกใช้บริการได้ในช่วงเวลา{' '}
              <strong>07.00 - 20.00 น.</strong> เท่านั้น
            </li>
            <li>
              การคำนวณราคาค่าขนส่งจะขึ้นอยู่กับระยะทาง
              ซึ่งจะต้องกดส่งข้อมูลต้นทาง/ปลายทาง เพื่อทำการคำนวณราคา
              ซึ่งแต่ละครั้งราคาอาจไม่เท่ากัน เนื่องจากตำแหน่งผิดพลาด ช่วงเวลา
              ปัญหาอินเตอร์เน็ต หรืออื่นๆ
            </li>
            <li>
              หากผู้เรียกใช้บริการทำการยกเลิกงานขนส่งและคนขับได้ไปถึงจุดรับสินค้าที่ระบุไว้แล้ว
              ผู้เรียกใช้
              บริการจะต้องชำระค่าธรรมเนียมการยกเลิกงานขนส่งตามเงื่อนไขที่กำหนด
              โดยไม่น้อยกว่าร้อยละ 50 ของค่าขนส่งที่จะเกิดขึ้น
            </li>
            <li>
              กรณีที่คนขับถึงจุดนัด และรอผู้ส่งหรือผู้รับเกิน 25 นาที
              จะมีการเก็บค่าบริการเพิ่มเติม
            </li>
            <li>
              ลูกค้ามีกรรมสิทธิ์ หรือ อำนาจในเอกสาร/สิ่งของที่จะเคลื่อนย้าย
              และรับประกันว่า ได้มีการบรรจุสิ่งของอย่างมิดชิด กันกระแทก
              หรือมีการแปะหรือเขียนป้ายชัดเจน
              ว่าสิ่งของนี้เป็นสิ่งของที่อาจแตกหักได้
            </li>
            <li>
              ขอสงวนสิทธิในกรณีนอกเหนือจากการควบคุมของบริษัทและหรือขนส่ง เช่น
              ภัยธรรมชาติ การประท้วง สภาพอากาศ ตรวจสอบโดยเจ้าหน้าที่รัฐ
            </li>
            <li>
              การเรียกร้องต้องมีการดำเนินการภายใน 24 ชั่วโมง
              นับจากเวลาที่คนขับรับของ โดยต้องระบุเลขที่งาน ข้อมูลการติดต่อ
              และรูปถ่ายสินค้าที่เกิดความเสียหาย
            </li>
            <li>
              กรณีความเสียหายและสูญหายที่เกิดขึ้นจากขนส่งของบริษัทที่เข้าข่ายความรับผิดชอบชดใช้ให้ตามจริง
              แต่ไม่เกิน 7,000 บาท โดยจะต้องแจ้งเรื่องเข้ามาภายใน 20 ชั่วโมง
              และส่งหลักฐานเพื่อทำเรื่องภายใน 48 ชั่วโมง
              โดยจะไม่คุ้มครองกรณีลูกค้าใช้งานผิดเงื่อนไขที่ผู้ให้บริการกำหนด
            </li>
            <li>หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง</li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              Motorcycle usage type, pickup-delivery of documents/items, weight
              not exceeding 20 kilograms and size not exceeding{' '}
              <strong>50+50+50 cm.</strong>
            </li>
            <li>
              The user must send the name, address, and phone number of the
              origin/sender and destination/recipient every time. If the
              information is incomplete, it may cause problems with pickup and
              delivery, and the user must be responsible for the costs incurred.
            </li>
            <li>
              The service can only be requested during{' '}
              <strong>07:00 - 20:00</strong> only.
            </li>
            <li>
              The shipping fee calculation depends on the distance, which
              requires submitting the origin/destination information to
              calculate the price. Each time the price may not be the same, due
              to location errors, time period, internet problems, or others.
            </li>
            <li>
              If the requester cancels the shipping job and the driver has
              already arrived at the specified pickup point, the requester must
              pay a cancellation fee according to the specified conditions, no
              less than 50 percent of the shipping fee that would have occurred.
            </li>
            <li>
              In the case where the driver arrives at the meeting point and
              waits for the sender or recipient for more than 25 minutes, an
              additional fee will be charged.
            </li>
            <li>
              The customer has ownership of or authority over the
              documents/items to be moved, and guarantees that the items have
              been packed securely, shockproof, or clearly labeled or written
              that this item may be breakable.
            </li>
            <li>
              We reserve the right in cases beyond the control of the company
              and/or courier, such as natural disasters, protests, weather,
              inspection by government officials.
            </li>
            <li>
              A claim must be made within 24 hours from the time the driver
              picks up the item, and must specify the job number, contact
              information, and photos of the damaged item.
            </li>
            <li>
              In the case of damage and loss caused by the company's courier
              that falls within the scope of responsibility, compensation is
              made at the actual value but not exceeding 7,000 baht. The matter
              must be reported within 20 hours and evidence submitted to file
              the matter within 48 hours. It does not cover cases where the
              customer uses the service in violation of the conditions specified
              by the service provider.
            </li>
            <li>If the item is returned, fees will be charged afterward.</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Best Express',
        'Terms of service: Best Express'
      )]: trans(
        <>
          <ul>
            <li>
              คำนวณปริมาตรค่าขนส่ง : (กว้างxยาวxสูง)/6,000 = น้ำหนักปริมาตร
              กรณีที่พัสดุมีน้ำหนักหรือปริมาณกล่องอย่างใดอย่างหนึ่งมากกว่า
              ระบบจะยึดคิดราคาค่าขนส่งตามขนาดปริมาตรหรือน้ำหนักที่มากกว่าเป็นหลัก
              โดย
              <MuiLink
                href="https://drive.google.com/file/d/1E1RzYCQrIna-WQS3YShEBpRzS5KW2lTd/view?usp=sharing"
                target="_blank"
              >
                การคิดน้ำหนักตามขนาดกล่อง คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              สามารถเข้ารับสินค้าหนักพัสดุสูงสุด 100 กิโลกรัม
              และขนาดกล่องไม่เกิน 600 เซนติเมตร (กว้าง+ยาว+สูง)
              (ด้านใดด้านหนึ่งต้องไม่เกิน 200 เซนติเมตร)
            </li>
            <li>
              ผู้ใช้ ต้องส่งข้อมูล ชื่อ ที่อยู่ เบอร์โทร ของต้นทาง/ผู้ส่ง
              และของปลายทาง/ผู้รับ ทุกครั้งที่ใช้งาน
              หากข้อมูลไม่ครบถ้วนอาจส่งผลให้การเข้ารับและจัดส่ง มีปัญหา
              ซึ่งทางผู้ใช้ต้องรับผิดชอบค่าใช้งานที่เกิดขึ้น
            </li>
            <li>
              วันทำการ จันทร์ - เสาร์ เวลาทำการ 8.00 - 18.00 น. (วันอาทิตย์
              เปิดทำการบางสาขา)
            </li>
            <li>
              ผู้ขอใช้บริการจะต้องสร้างรายการล่วงหน้า 1 วัน
              และทีมขนส่งจะเข้ารับพัสดุในวันถัดไป
              ทั้งนี้ทีมขนส่งอาจเข้ารับภายในวันเดียวกับที่สร้างรายการได้
              โดยขึ้นอยู่สาขาที่ให้บริการ
            </li>
            <li>
              ในกรณีที่ทีมขนส่งไม่ได้เข้ารับพัสดุเลยจนเลยกำหนดเวลา
              ลูกค้าสามารถกำหนดวันเวลานัดรับใหม่ได้ที่เบอร์โทรที่เจ้าหน้าที่โทรหาหรือลูกค้าสามารถส่งพัสดุได้ที่หน้าสาขา
            </li>
            <li>
              หากไม่สามารถกำหนดวันนัดรับพัสดุได้กรุณาติดต่อ Best Express
              Customer Service (02-108-8000)
            </li>
            <li>
              การประกันคุ้มครองสินค้า ตามเงื่อนไขของบริษัท
              กรณีความเสียหายและสูญหายที่เกิดขึ้นจากบริษัทที่เข้าข่ายความรับผิดชอบชดใช้ให้ตามจริง
              แต่ไม่เกิน 2,000 บาท
            </li>
            <li>
              Best Express
              จะพยายามส่งพัสดุไปยังที่อยู่ผู้รับปลายทางตามที่ระบุไว้ 3 ครั้ง
              ภายใน 5 วันทำการ
            </li>
            <li>
              พื้นที่ห่างไกลที่มีค่าบริการเพิ่ม 50 บาท หรือ 80 บาท
              โดยตรวจสอบพื้นที่ห่างไกลได้
              <MuiLink
                href="https://docs.google.com/spreadsheets/d/1VI4BM2L4IU48sVpTQA0anVZ_jeDwl7gDy0_FsJCelf4/edit?usp=sharing"
                target="_blank"
              >
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              ผู้ให้บริการจะคิดค่าธรรมเนียมเก็บเงินปลายทางอยู่ที่ 3 %
              โดยยอดโอนคืนขั้นต่ำ 500 บาท หลังหักค่าธรรมเนียม COD (3%) แล้ว
              ค่าธรรมเนียมในการโอนขึ้นอยู่กับธนาคารของผู้ใช้งาน
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              Calculate the shipping volume : (Width x Length x Height)/6,000 =
              volumetric weight. In the case where the parcel has either the
              weight or box volume greater, the system will base the shipping
              price on the greater volumetric size or weight, by
              <MuiLink
                href="https://drive.google.com/file/d/1E1RzYCQrIna-WQS3YShEBpRzS5KW2lTd/view?usp=sharing"
                target="_blank"
              >
                calculating the weight by box size, click here
              </MuiLink>
            </li>
            <li>
              Can pick up parcels weighing up to 100 kilograms and box size not
              exceeding 600 centimeters (Width + Length + Height) (each side
              must not exceed 200 centimeters)
            </li>
            <li>
              The user must send the name, address, and phone number of the
              origin/sender and destination/recipient every time. If the
              information is incomplete, it may cause problems with pickup and
              delivery, and the user must be responsible for the costs incurred.
            </li>
            <li>
              Business days Monday - Saturday, business hours 8:00 - 18:00
              (Sunday, some branches are open)
            </li>
            <li>
              The requester must create a shipment 1 day in advance, and the
              courier team will pick up the parcel the next day. However, the
              courier team may pick up on the same day the shipment is created,
              depending on the servicing branch.
            </li>
            <li>
              In the case where the courier team does not pick up the parcel
              past the deadline, the customer can set a new pickup date and time
              at the phone number the staff called from, or the customer can
              send the parcel at the branch.
            </li>
            <li>
              If a pickup date cannot be set, please contact Best Express
              Customer Service (02-108-8000)
            </li>
            <li>
              Product insurance coverage, according to the company's conditions.
              In the case of damage and loss caused by the company that falls
              within the scope of responsibility, compensation is made at the
              actual value but not exceeding 2,000 baht.
            </li>
            <li>
              Best Express will attempt to deliver the parcel to the specified
              recipient's destination address 3 times within 5 business days.
            </li>
            <li>
              Remote areas have an additional fee of 50 baht or 80 baht. You can
              check the remote areas
              <MuiLink
                href="https://docs.google.com/spreadsheets/d/1VI4BM2L4IU48sVpTQA0anVZ_jeDwl7gDy0_FsJCelf4/edit?usp=sharing"
                target="_blank"
              >
                click here
              </MuiLink>
            </li>
            <li>
              The service provider charges a Cash on Delivery fee of 3%, with a
              minimum refund transfer amount of 500 baht after deducting the COD
              fee (3%). The transfer fee depends on the user's bank.
            </li>
          </ul>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง JWD Express',
        'Courier details: JWD Express'
      )]: trans(
        <>
          <p>
            บริการขนส่งพัสดุแช่เย็น/แช่แข็ง ถึงบ้าน (Door to Door Parcel
            Delivery) มีบริการรับพัสดุถึงบ้านลูกค้า โดยมี 2 บริการให้เลือก
          </p>
          <ul>
            <li>
              <strong>JWD Express Chilled</strong> จัดส่ง
              <strong>สินค้าแช่เย็น</strong>ที่อุณหภูมิ{' '}
              <strong>0 - 8 องศาเซลเซียส</strong>
            </li>
            <li>
              <strong>JWD Express Frozen</strong> จัดส่ง
              <strong>สินค้าแช่แข็ง</strong>ที่อุณหภูมิต่ำกว่า{' '}
              <strong>-15 องศาเซลเซียส</strong>
            </li>
          </ul>
        </>,
        <>
          <p>
            Chilled/frozen parcel delivery service to your home (Door to Door
            Parcel Delivery), with a service to pick up the parcel at the
            customer's home, with 2 services to choose from
          </p>
          <ul>
            <li>
              <strong>JWD Express Chilled</strong> delivers
              <strong>chilled products</strong> at a temperature of{' '}
              <strong>0 - 8 degrees Celsius</strong>
            </li>
            <li>
              <strong>JWD Express Frozen</strong> delivers
              <strong>frozen products</strong> at a temperature below{' '}
              <strong>-15 degrees Celsius</strong>
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ JWD Express',
        'Terms of service: JWD Express'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้า และแปะลงบนกล่องพัสดุ</li>
            <li>
              สินค้าควรอยู่ในอุณหภูมิตามที่บริษัทกำหนด โดยพัสดุประเภท Chilled
              จะต้องมีอุณหภูมิ 0 ถึง 5 °C และพัสดุประเภท Frozen
              จะต้องมีอุณหภูมิ -1 ถึง -25 °C ก่อนนำส่ง
            </li>
            <li>
              ขั้นต่ำในการเข้ารับจำนวน 5 ชิ้น
              หากต่ำกว่าที่กำหนดจะมีค่าบริการเข้ารับสินค้า 50 บาท/กล่อง
            </li>
            <li>
              รับพัสดุต้นทางเฉพาะพื้นที่กรุงเทพฯ และปริมณฑล ได้แก่ นนทบุรี
              สมุทรปราการ และปทุมธานีเท่านั้น
              ซึ่งจะเข้ารับและจัดส่งพัสดุทุกวัน
            </li>
            <li>
              หากลูกค้าสร้างรายการไม่เกิน 12.00 น.
              ทางขนส่งจะเข้ารับภายในวันเดียวกัน หากลูกค้าสร้างรายการหลังจาก
              12.00 น. ทางขนส่งจะทำการเข้ารับในวันถัดไป
            </li>
            <li>
              ระยะเวลาจัดส่งกรุงเทพฯ และปริมณฑล
              พัสดุจะจัดส่งถึงปลายทางภายในวันถัดไป
              หากเป็นพื้นที่ต่างจังหวัดพัสดุจะจัดส่งถึงปลายทางภายใน 1-3 วัน
            </li>
            <li>
              สำหรับการจัดส่งไปยังพื้นที่กรุงเทพฯ และปริมณฑลขนาดของพัสดุรวม
              (กว้าง+ยาว+สูง) ไม่เกิน 180 ซม. ด้านหนึ่งใดด้านหนึ่งไม่เกิน 100
              ซม. และน้ำหนักไม่เกิน 25 กิโลกรัม
            </li>
            <li>
              สำหรับการจัดส่งไปยังพื้นที่ต่างจังหวัด ขนาดรวม (กว้าง+ยาว+สูง)
              ของพัสดุไม่เกิน 120 ซม. และน้ำหนักไม่เกิน 30 กิโลกรัม
            </li>
            <li>
              หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง
              โดยทางผู้ให้บริการจะคิดค่าบริการ 50% ของค่าขนส่ง
              <strong>
                {' '}
                (โดยทางขนส่งอาจมีการ unpack พัสดุเพื่อให้บรรจุลงในกล่อง cool
                box){' '}
              </strong>
            </li>
            <li>
              วงเงินรับประกันสินค้าไม่เกิน 2,000 บาท
              ในกรณีสินค้าได้รับความเสียหายอันเกิดจากการขนส่งเท่านั้น
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the label and attach it to the parcel box</li>
            <li>
              The product should be at the temperature specified by the company.
              Chilled type parcels must be at a temperature of 0 to 5 °C and
              Frozen type parcels must be at a temperature of -1 to -25 °C before
              delivery.
            </li>
            <li>
              The minimum pickup quantity is 5 pieces. If lower than specified,
              there is a pickup fee of 50 baht/box.
            </li>
            <li>
              Origin pickup only in the Bangkok and metropolitan area, including
              Nonthaburi, Samut Prakan, and Pathum Thani only, with pickup and
              delivery every day.
            </li>
            <li>
              If the customer creates a shipment no later than 12:00, the
              courier will pick up on the same day. If the customer creates a
              shipment after 12:00, the courier will pick up the next day.
            </li>
            <li>
              Delivery time for Bangkok and metropolitan area: the parcel will
              be delivered to the destination the next day. For provincial
              areas, the parcel will be delivered to the destination within 1-3
              days.
            </li>
            <li>
              For delivery to the Bangkok and metropolitan area, the total
              parcel size (Width + Length + Height) not exceeding 180 cm, each
              side not exceeding 100 cm, and weight not exceeding 25 kilograms.
            </li>
            <li>
              For delivery to provincial areas, the total size (Width + Length +
              Height) of the parcel not exceeding 120 cm and weight not
              exceeding 30 kilograms.
            </li>
            <li>
              If the item is returned, fees will be charged afterward, and the
              service provider will charge 50% of the shipping fee.
              <strong>
                {' '}
                (The courier may unpack the parcel to fit it into a cool box){' '}
              </strong>
            </li>
            <li>
              The product insurance limit is not more than 2,000 baht, only in
              the case where the product is damaged due to shipping.
            </li>
          </ul>
        </>
      ),
      [trans(
        'พื้นที่เข้ารับและพื้นที่จัดส่งของ JWD express',
        'Pickup and delivery areas: JWD express'
      )]: trans(
        <>
          <ul>
            <li>
              เข้ารับ<strong>เฉพาะในพื้นที่ กทม.และปริมณฑล</strong>(นนทบุรี,
              ปทุมธานี, สมุทรปราการ) และ<strong>จัดส่งทั่วประเทศ</strong>{' '}
              ยกเว้น
            </li>
          </ul>
          <br />
          <p>
            พื้นที่ที่ยังไม่เปิดให้บริการ ได้แก่ แม่ฮ่องสอน, นราธิวาส.
            ปัตตานี, ยะลา, อำเภออุ้มผาง, อำเภอท่าสองยาง, เกาะลันตา,
            เกาะศรีบอยา, เกาะสีชัง, เกาะเสม็ด, เกาะลิบง, เกาะสุกร, เกาะกูด,
            เกาะช้าง, เกาะปันหยี, เกาะพระทอง, เกาะยาว, เกาะคอเขา, เกาะนางคำ,
            เกาะพยาม, เกาะยอ, เกาะสาหร่าย, เกาะสมุย และเกาะพงัน
            เช็คพื้นที่ที่ยังไม่เปิดให้บริการเพิ่มเติม
            <MuiLink
              href="https://drive.google.com/file/d/1ooPVXJUrFpAZy5hEqL42KOSm0HyR_Cvk/view?usp=sharing"
              target="_blank"
            >
              คลิกที่นี่
            </MuiLink>
          </p>
        </>,
        <>
          <ul>
            <li>
              Pickup <strong>only in the Bangkok and metropolitan area</strong>{' '}
              (Nonthaburi, Pathum Thani, Samut Prakan) and{' '}
              <strong>delivery throughout the country</strong> except
            </li>
          </ul>
          <br />
          <p>
            Areas not yet open for service include Mae Hong Son, Narathiwat,
            Pattani, Yala, Umphang district, Tha Song Yang district, Koh Lanta,
            Koh Sri Boya, Koh Sichang, Koh Samet, Koh Libong, Koh Sukorn, Koh
            Kood, Koh Chang, Koh Panyi, Koh Phra Thong, Koh Yao, Koh Kho Khao,
            Koh Nang Kham, Koh Phayam, Koh Yo, Koh Sarai, Koh Samui, and Koh
            Phangan. Check more areas not yet open for service
            <MuiLink
              href="https://drive.google.com/file/d/1ooPVXJUrFpAZy5hEqL42KOSm0HyR_Cvk/view?usp=sharing"
              target="_blank"
            >
              click here
            </MuiLink>
          </p>
        </>
      ),
      [trans(
        'สินค้าที่ไม่สามารถจัดส่งด้วยขนส่ง JWD express ได้',
        'Items that cannot be shipped with JWD express'
      )]: trans(
        <>
          <ul>
            <li>
              สัตว์เลี้ยง หรือสิ่งมีชีวิตต่างๆ เช่น สุนัข, แมว
              หรือแม้กระทั่งปลาสวยงาม
            </li>
            <li>ไอศครีมทุกรูปแบบ</li>
            <li>เค้กแต่งหน้าที่มีหน้าเป็นครีม</li>
            <li>ต้นไม้ หรือพืชหลากหลายชนิด</li>
            <li>สินค้าอันตราย เช่นแก๊สหรือสารเคมีต่างๆ</li>
            <li>
              อาวุธอันตราย เช่น มีด ปืน
              หรืออาวุธที่ทำให้เกิดความเสียหายร้ายแรง
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              Pets or living creatures such as dogs, cats, or even ornamental
              fish
            </li>
            <li>All forms of ice cream</li>
            <li>Decorated cakes with cream topping</li>
            <li>Trees or various plants</li>
            <li>Hazardous goods such as gas or various chemicals</li>
            <li>
              Dangerous weapons such as knives, guns, or weapons that cause
              serious damage
            </li>
          </ul>
        </>
      ),
      [trans(
        'รายละเอียดขนส่ง Kerry Express',
        'Courier details: Kerry Express'
      )]: trans(
        <>
          <p>
            Kerry Express ผู้นำด้านการจัดส่งพัสดุด่วนทั่วไทย
            บริการส่งพัสดุด้วยมาตรฐาน Next Day
          </p>
          <ul>
            <li>ใช้ง่ายๆเพียง “ปริ้น แปะ ส่ง”</li>
            <li>ราคาเริมต้นเพียง 32 บาทเท่านั้น</li>
          </ul>
        </>,
        <>
          <p>
            Kerry Express, a leader in express parcel delivery throughout
            Thailand, with Next Day standard parcel delivery service.
          </p>
          <ul>
            <li>Easy to use, just “Print, Attach, Send”</li>
            <li>Starting price of only 32 baht</li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการให้บริการ Kerry Express Dropoff',
        'Terms of service: Kerry Express Dropoff'
      )]: trans(
        <>
          <ul>
            <li>พิมพ์ใบปะหน้าและแปะลงบนกล่องพัสดุ</li>
            <li>
              ผู้ใช้บริการจะต้องนำสินค้าไปส่งที่สาขา Kerry Express (Parcel
              Shop) เท่านั้น ตรวจสอบสาขา Kerry Express ที่สามารถจัดส่ง{' '}
              <MuiLink href="/nearby-dropoff" target="_blank">
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              ขนาดพัสดุที่จัดส่ง (กว้าง+ยาว+สูง) ต้องไม่เกิน 180 เซนติเมตร
              ด้านใดด้านหนึ่งไม่เกิน 100 เซนติเมตร และน้ำหนักไม่เกิน 20
              กิโลกรัม
            </li>
            <li>
              การเลือกน้ำหนักพัสดุที่ไม่ตรงกับความเป็นจริง ทางบริษัทฯ
              จะดำเนินการเรียกเก็บค่าขนส่งเพิ่มเติม
            </li>
            <li>
              มาตรฐานการนำส่ง กรุงเทพฯ และปริมณฑล
              หรือภายในภูมิภาคเดียวกันจัดส่งภายในวันถัดไป
              หากเป็นการจัดส่งต่างภูมิภาคจัดส่งภายใน 1-2 วัน
              (เมื่อผู้ใช้บริการนำพัสดุไปส่งภายในเวลา Cut Off Time
              ของแต่ละสาขา)
              <ul>
                <li>
                  <u>ภูมิภาค : กรุงเทพฯและปริมณฑล</u> ได้แก่ กรุงเทพฯ,
                  นนทบุรี, ปทุมธานี, สมุทรปราการ
                </li>
                <li>
                  <u>ภูมิภาค : ภาคกลาง</u> ได้แก่ เพชรบุรี, กาญจนบุรี,
                  นครนายก, นครปฐม, ประจวบคีรีขันธ์, พระนครศรีอยุธยา, ราชบุรี,
                  ลพบุรี, สมุทรสงคราม, สมุทรสาคร, สระบุรี,
                  สิงห์บุรี,สุพรรณบุรี, อ่างทอง
                </li>
                <li>
                  <u>ภูมิภาค : ภาคตะวันออก</u> ได้แก่ จันทบุรี, ฉะเชิงเทรา,
                  ชลบุรี, ตราด, ปราจีนบุรี, ระยอง, สระเเก้ว
                </li>
                <li>
                  <u>ภูมิภาค : ภาคเหนือ</u> ได้แก่ เชียงใหม่, เชียงราย,
                  เพชรบูรณ์, แพร่, แม่ฮ่องสอน, กำแพงเพชร, ชัยนาท, ตาก,
                  นครสวรรค์, น่าน, พะเยา, พิจิตร, พิษณุโลก, ลำปาง, ลำพูน,
                  สุโขทัย, อุตรดิตถ์, อุทัยธานี
                </li>
                <li>
                  <u>ภูมิภาค : ภาคตะวันออกเฉียงเหนือ</u> ได้เเก่ เลย,
                  กาฬสินธุ์, ขอนเเก่น, ชัยภูมิ, นครพนม, นครราชสีมา, บึงกาฬ,
                  บุรีรัมย์, มหาสารคาม, มุกดาหาร, ยโสธร,ร้อยเอ็ด, ศรีสะเกษ,
                  สกลนคร, สุรินทร์, หนองคาย, หนองบัวลำภู, อำนาจเจริญ,
                  อุดรธานี, อุบลราชธานี
                </li>
                <li>
                  <u>ภูมิภาค : ภาคใต้</u> ได้เเก่ กระบี่, ชุมพร, ตรัง,
                  นครศรีธรรมราช, นราธิวาส, ปัตตานี, พังงา, พัทลุง, ภูเก็ต,
                  ยะลา, ระนอง, สงขลา, สุราษฎร์ธานี, สตูล
                </li>
              </ul>
              ทั้งนี้หากเป็นพื้นที่พิเศษ จะมีค่าบริการเพิ่มเติม 50 บาท
              และระยะเวลาในการจัดส่งจะเพิ่มจากมาตรฐานการนำส่งทั่วไป 1-2 วัน
              ตรวจสอบรหัสไปรษณีย์ของพื้นที่พิเศษ{' '}
              <MuiLink
                href="https://drive.google.com/file/d/15Af8tnRnrY9mt_SIrhoSt8LMSbdn6zLf/view?usp=sharing"
                target="_blank"
              >
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              กรณีพัสดุมีการตีคืนทางผู้ให้บริการจะคิดค่าบริการตามค่าขนส่ง
            </li>
            <li>
              ประกันคุ้มครองสินค้า
              กรณีความเสียหายและสูญหายที่เกิดขึ้นจากบริษัทที่เข้าข่ายความรับผิดชอบชดใช้ให้ตามจริง
              สูงสุดไม่เกิน 2,000 บาท
            </li>
            <li>
              หากไม่สามารถติดต่อเพื่อคืนสินค้าได้ภายใน 3 วัน
              จะดำเนินการตามมาตรการที่ทางขนส่งกำหนด
            </li>
            <li>
              รายการที่ชำระค่าขนส่งแล้ว จะไม่สามารถยกเลิก แก้ไข
              หรือขอคืนเงินได้ ไม่ว่าจะกรณีใดๆ
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>Print the label and attach it to the parcel box</li>
            <li>
              The user must bring the item to a Kerry Express (Parcel Shop)
              branch only. Check Kerry Express branches that can deliver{' '}
              <MuiLink href="/nearby-dropoff" target="_blank">
                click here
              </MuiLink>
            </li>
            <li>
              The parcel size to be shipped (Width + Length + Height) must not
              exceed 180 centimeters, each side not exceeding 100 centimeters,
              and weight not exceeding 20 kilograms.
            </li>
            <li>
              Selecting a parcel weight that does not match reality, the company
              will charge additional shipping fees.
            </li>
            <li>
              Delivery standards: Bangkok and metropolitan area or within the
              same region, delivery within the next day. For cross-region
              delivery, delivery within 1-2 days (when the user brings the
              parcel within the Cut Off Time of each branch)
              <ul>
                <li>
                  <u>Region : Bangkok and metropolitan area</u> including
                  Bangkok, Nonthaburi, Pathum Thani, Samut Prakan
                </li>
                <li>
                  <u>Region : Central</u> including Phetchaburi, Kanchanaburi,
                  Nakhon Nayok, Nakhon Pathom, Prachuap Khiri Khan, Phra Nakhon
                  Si Ayutthaya, Ratchaburi, Lopburi, Samut Songkhram, Samut
                  Sakhon, Saraburi, Sing Buri, Suphan Buri, Ang Thong
                </li>
                <li>
                  <u>Region : East</u> including Chanthaburi, Chachoengsao,
                  Chonburi, Trat, Prachinburi, Rayong, Sa Kaeo
                </li>
                <li>
                  <u>Region : North</u> including Chiang Mai, Chiang Rai,
                  Phetchabun, Phrae, Mae Hong Son, Kamphaeng Phet, Chai Nat, Tak,
                  Nakhon Sawan, Nan, Phayao, Phichit, Phitsanulok, Lampang,
                  Lamphun, Sukhothai, Uttaradit, Uthai Thani
                </li>
                <li>
                  <u>Region : Northeast</u> including Loei, Kalasin, Khon Kaen,
                  Chaiyaphum, Nakhon Phanom, Nakhon Ratchasima, Bueng Kan,
                  Buriram, Maha Sarakham, Mukdahan, Yasothon, Roi Et, Si Sa Ket,
                  Sakon Nakhon, Surin, Nong Khai, Nong Bua Lamphu, Amnat Charoen,
                  Udon Thani, Ubon Ratchathani
                </li>
                <li>
                  <u>Region : South</u> including Krabi, Chumphon, Trang, Nakhon
                  Si Thammarat, Narathiwat, Pattani, Phang Nga, Phatthalung,
                  Phuket, Yala, Ranong, Songkhla, Surat Thani, Satun
                </li>
              </ul>
              However, for special areas, there is an additional fee of 50 baht
              and the delivery time will increase by 1-2 days from the general
              delivery standard. Check the postal codes of special areas{' '}
              <MuiLink
                href="https://drive.google.com/file/d/15Af8tnRnrY9mt_SIrhoSt8LMSbdn6zLf/view?usp=sharing"
                target="_blank"
              >
                click here
              </MuiLink>
            </li>
            <li>
              In the case of a parcel being returned, the service provider will
              charge a fee according to the shipping fee.
            </li>
            <li>
              Product insurance coverage. In the case of damage and loss caused
              by the company that falls within the scope of responsibility,
              compensation is made at the actual value, up to a maximum of 2,000
              baht.
            </li>
            <li>
              If the item cannot be contacted for return within 3 days, action
              will be taken according to the measures specified by the courier.
            </li>
            <li>
              Items for which the shipping fee has been paid cannot be canceled,
              edited, or refunded in any case.
            </li>
          </ul>
        </>
      ),
      [trans(
        'เงื่อนไขการใช้บริการเก็บเงินปลายทาง Kerry Express',
        'Cash on Delivery terms of service: Kerry Express'
      )]: trans(
        <>
          <ol>
            <li>
              ยืนยันตัวตนด้วยบัตรประชาชนและบัญชีธนาคาร ที่{' '}
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=ConfirmAccount`}
                target="_blank"
              >
                หน้ายืนยันตัวตน
              </MuiLink>{' '}
            </li>
            <li>
              สร้างรายการเก็บของโดยกรอกข้อมูลที่ช่องเก็บเงินปลายทาง
              ซึ่งจะปรากฏขึ้นหลังจากที่ได้ยืนยันตัวตน ตามข้อที่ 1
            </li>
            <li>พิมพ์ใบปะหน้า และแปะลงบนหน้ากล่อง</li>
            <li>
              <u>
                ผู้ใช้บริการจะต้องนำสินค้าไปส่งที่สาขา Kerry Express (Parcel
                Shop) เท่านั้น
              </u>{' '}
              ตรวจสอบสาขา Kerry Express ที่สามารถจัดส่ง{' '}
              <MuiLink href="/nearby-dropoff" target="_blank">
                คลิกที่นี่
              </MuiLink>
            </li>
            <li>
              ขนาดพัสดุที่จัดส่ง (กว้าง+ยาว+สูง) ต้องไม่เกิน 180 เซนติเมตร
              ด้านใดด้านหนึ่งไม่เกิน 100 เซนติเมตร และน้ำหนักไม่เกิน 20
              กิโลกรัม
              <p style={{ margin: 0, color: 'red' }}>
                (กรณีพัสดุน้ำหนักมากกว่า 20 กิโลกรัมขึ้นไป
                ทางขนส่งจะขอคิดค่าบริการเพิ่ม โดยคิดเป็น 25 บาทต่อกิโลกรัม)
              </p>
            </li>
            <li>
              Kerry Express จะคิดค่าบริการเก็บเงินปลายทาง (COD) 2.5%
              จากยอดเรียกเก็บโดยยอดเรียกเก็บขั้นต่ำของสินค้าอยู่ที่ 100 บาท
              แต่สูงสุดไม่เกิน 50,000 บาท
            </li>
            <li>
              บริษัทจะทำการโอนเงินที่รับชำระมาแล้ว ทุกวันศุกร์
              หากเป็นวันหยุดจะทำการโอนคืนในวันทำการถัดไป
            </li>
            <li>
              ประกันคุ้มครองสินค้า
              กรณีความเสียหายและสูญหายที่เกิดขึ้นจากบริษัทที่เข้าข่ายความรับผิดชอบชดใช้ให้ตามจริง
              สูงสุดไม่เกิน 2,000 บาท
            </li>
            <li>
              หากระบุข้อมูลปลายทางผิดพลาด ทางบริษัทขอสงวนสิทธิ์ ในการแก้ไข
              ยกเลิกและคืนเงิน หากสินค้ามีการตีคืนจะมีการเรียกเก็บเงินภายหลัง
            </li>
            <li>
              <MuiLink href="#การประกัน & เคลม">การประกัน & เคลม</MuiLink>
            </li>
          </ol>
        </>,
        <>
          <ol>
            <li>
              Verify your identity with an ID card and bank account at the{' '}
              <MuiLink
                href={`${publicRuntimeConfig.appShippop}/edit-profile/?tab=ConfirmAccount`}
                target="_blank"
              >
                Verify Identity page
              </MuiLink>{' '}
            </li>
            <li>
              Create a shipment by filling in the information in the Cash on
              Delivery field, which will appear after you have verified your
              identity as in item 1.
            </li>
            <li>Print the label and attach it to the front of the box</li>
            <li>
              <u>
                The user must bring the item to a Kerry Express (Parcel Shop)
                branch only.
              </u>{' '}
              Check Kerry Express branches that can deliver{' '}
              <MuiLink href="/nearby-dropoff" target="_blank">
                click here
              </MuiLink>
            </li>
            <li>
              The parcel size to be shipped (Width + Length + Height) must not
              exceed 180 centimeters, each side not exceeding 100 centimeters,
              and weight not exceeding 20 kilograms.
              <p style={{ margin: 0, color: 'red' }}>
                (In the case of a parcel weighing more than 20 kilograms, the
                courier will charge an additional fee of 25 baht per kilogram)
              </p>
            </li>
            <li>
              Kerry Express charges a Cash on Delivery (COD) fee of 2.5% of the
              collection amount, with a minimum item collection amount of 100
              baht, up to a maximum of 50,000 baht.
            </li>
            <li>
              The company will transfer the collected payment every Friday. If
              it is a holiday, the transfer will be made on the next business
              day.
            </li>
            <li>
              Product insurance coverage. In the case of damage and loss caused
              by the company that falls within the scope of responsibility,
              compensation is made at the actual value, up to a maximum of 2,000
              baht.
            </li>
            <li>
              If the destination information is incorrect, the company reserves
              the right to edit, cancel, and refund. If the item is returned,
              fees will be charged afterward.
            </li>
            <li>
              <MuiLink href="#Insurance & Claims">Insurance & Claims</MuiLink>
            </li>
          </ol>
        </>
      ),
      [trans(
        'เงื่อนไขการตีคืนสินค้า Kerry Express',
        'Return conditions: Kerry Express'
      )]: trans(
        <>
          <ol>
            <li>
              ติดต่อผู้รับปลายทางไม่ได้ หรือไปจัดส่งแล้วแต่ไม่มีคนรับครบกำหนด
              5 วัน จะทำการตีคืนโดยอัตโนมัติ
            </li>
            <li>
              หากผู้รับปลายทางขอเลื่อนวันจัดส่ง ควรอยู่ในระยะเวลาไม่เกิน 5
              วันนับจากวันที่รับสินค้ามา
              โดยที่หากถึงวันนัดแล้วติดต่อผู้รับไม่ได้
              พัสดุจะถูกตีคืนโดยอัตโนมัติ
            </li>
            <li>หากรหัสไปรษณีย์ปลายทางผิด จะทำการตีคืนโดยอัตโนมัติ</li>
            <li>
              ผู้ส่งแจ้งขอยกเลิกการจัดส่ง หรือ ผู้รับแจ้งปฏิเสธการรับพัสดุ
            </li>
            <li>พัสดุมีการห่อหุ้มไม่ตรงตามเงื่อนไขที่ทางขนส่งกำหนดไว้</li>
          </ol>
        </>,
        <>
          <ol>
            <li>
              If the recipient cannot be contacted, or delivery was attempted
              but no one received it for 5 days, it will be returned
              automatically.
            </li>
            <li>
              If the recipient requests to postpone the delivery date, it should
              be within a period of no more than 5 days from the date the item
              was picked up. If the recipient cannot be contacted on the
              appointment date, the parcel will be returned automatically.
            </li>
            <li>If the destination postal code is incorrect, it will be returned automatically.</li>
            <li>
              The sender requests to cancel the delivery, or the recipient
              refuses to accept the parcel.
            </li>
            <li>The parcel packaging does not meet the conditions specified by the courier.</li>
          </ol>
        </>
      ),
      [trans('Makesend ', 'Makesend ')]: trans(
        <>
          <ul>
            <li>
              พิมพ์ใบปะหน้าและแปะลงบนกล่องพัสดุ
              เพื่อให้ทางทีมขนส่งเข้ารับสินค้าพัสดุถึงหน้าบ้าน
            </li>
            <li>
              เวลาทำการตั้งแต่ 9.00 - 20.00 น. ทุกวันไม่เว้นวันหยุดราชการ
            </li>
            <li>
              เวลาสร้างรายการ เข้ารับพัสดุ และรอบจัดส่งพัสดุตามต้นทาง{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1elnz1LtdjqS7caHa4z03hL4L0j9V_xCpeKLIWVELeA8/edit?usp=sharing"
                target="_blank"
              >
                ตรวจสอบเวลาตัดรอบและเข้ารับที่นี่
              </MuiLink>
            </li>
            <li>
              พัสดุต้องพร้อมส่งก่อนเวลาเข้ารับพัสดุ
              หากเป็นพัสดุส่งเย็นจะต้องถูกปรับอุณหภูมิให้อยู่ในอุณหภูมิอย่างน้อย
              0-8 องศา ก่อนจัดส่ง และแพ็คอย่างมิดชิดและเหมาะสม
              ไม่ควรให้มีน้ำหยด ส่งกลิ่น ไอระเหย หรืออื่นๆ
              ที่ส่งผลต่อสินค้าอื่นๆ และยากแก่การจัดส่ง
            </li>
            <li>หากสร้างรายการหลังจาก 12.00 น. จะเข้ารับในวันถัดไป</li>
            <li>
              เข้ารับพัสดุฟรี หากส่งมากกว่า 3 กล่อง (ต่ำกว่า 3
              กล่องคิดค่าเข้ารับ 90 บาทต่อครั้ง)
            </li>
            <li>
              สินค้าน้ำหนักพัสดุสูงสุด 25 กิโลกรัม และขนาดกล่องไม่เกิน 200
              เซนติเมตร (กว้าง+ยาว+สูง)
            </li>
            <li>
              บริการเก็บเงินปลายทาง (COD) ไม่เกิน 50,000 บาท ค่าบริการ 3%
              ของยอดชำระ ขั้นต่ำค่าธรรมเนียม 25 บาท
            </li>
            <li>
              กรณีพัสดุมีการตีคืน กรณีติดต่อผู้รับและผู้ส่งไม่ได้
              กรณีเปลี่ยนแปลงปลายทาง กรณีสินค้าตีกลับ คิดค่าขนส่งเต็มจำนวน
            </li>
            <li>
              ค่าประกันสินค้ากรณีเสียหายและสูญหาย วงเงินประกันไม่เกิน 3,000
              บาท/รายการ ชำระตามราคาจริงของสินค้าที่เกิดความเสียหาย
              โดยแจ้งเรื่องเข้ามาหลังจากรับสินค้าภายใน 24 ชั่วโมง เคลมให้ภายใน
              3 วัน
            </li>
            <li>
              ประกันเวลาการนำส่ง
              หากนำส่งเกินเวลาคืนเงินเต็มจำนวนของค่าบริการการขนส่ง
              และนำส่งให้ใหม่อีกครั้งโดยไม่คิดค่าบริการ
            </li>
            <li>
              ตรวจสอบพื้นที่ให้บริการ{' '}
              <MuiLink
                href="https://drive.google.com/file/d/190W4uoGZ5RblmczkPTwV33E7SUT_61XX/view?usp=sharing"
                target="_blank"
              >
                ที่นี่
              </MuiLink>
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              Print the label and attach it to the parcel box so the courier
              team can pick up the parcel at your home.
            </li>
            <li>
              Business hours from 9:00 - 20:00 every day, including public
              holidays.
            </li>
            <li>
              Shipment creation time, parcel pickup, and parcel delivery rounds
              by origin{' '}
              <MuiLink
                href="https://docs.google.com/document/d/1elnz1LtdjqS7caHa4z03hL4L0j9V_xCpeKLIWVELeA8/edit?usp=sharing"
                target="_blank"
              >
                check the cut-off and pickup times here
              </MuiLink>
            </li>
            <li>
              The parcel must be ready to ship before the pickup time. For cold
              parcels, the temperature must be adjusted to at least 0-8 degrees
              before delivery, and packed securely and appropriately. There
              should be no dripping water, odor, vapor, or others that affect
              other items and make delivery difficult.
            </li>
            <li>If a shipment is created after 12:00, it will be picked up the next day.</li>
            <li>
              Free parcel pickup if sending more than 3 boxes (below 3 boxes, a
              pickup fee of 90 baht per time is charged)
            </li>
            <li>
              Item parcel weight up to 25 kilograms and box size not exceeding
              200 centimeters (Width + Length + Height)
            </li>
            <li>
              Cash on Delivery (COD) service not exceeding 50,000 baht, fee of
              3% of the payment amount, minimum fee of 25 baht.
            </li>
            <li>
              In the case of a parcel being returned, being unable to contact
              the recipient and sender, changing the destination, or the item
              being returned, the full shipping fee is charged.
            </li>
            <li>
              Product insurance for damage and loss, insurance limit not
              exceeding 3,000 baht/item, paid at the actual price of the damaged
              item, by reporting the matter within 24 hours after receiving the
              item, with claims made within 3 days.
            </li>
            <li>
              Delivery time guarantee: if delivery exceeds the time, a full
              refund of the shipping fee is given and the item is re-delivered
              at no charge.
            </li>
            <li>
              Check the service area{' '}
              <MuiLink
                href="https://drive.google.com/file/d/190W4uoGZ5RblmczkPTwV33E7SUT_61XX/view?usp=sharing"
                target="_blank"
              >
                here
              </MuiLink>
            </li>
          </ul>
        </>
      ),
      [trans('ZTO', 'ZTO')]: trans(
        <>
          <ul>
            <li>
              ทางขนส่งจะเข้ารับเฉพาะกรุงเทพฯ มีขั้นต่ำในการเข้ารับ 20
              ชิ้นต่อจุด โดยให้บริการวันจันทร์ - วันเสาร์ หยุดวันอาทิตย์
            </li>
            <li>
              ราคาค่าขนส่งข้างต้นคิดตามปลายทาง
              <ul>
                <li>
                  กรุงเทพ/ปริมณฑล เฉพาะปลายทางพื้นที่ กรุงเทพฯ นนทบุรี
                  สมุทรปราการ และสมุทรสาคร เท่านั้น
                </li>
                <li>
                  ต่างจังหวัด
                  ปลายทางพื้นที่จังหวัดอื่นที่ไม่ได้อยู่ในกรุงเทพและปริมณฑล
                </li>
              </ul>
            </li>
            <li>
              ขนาดพัสดุที่รับ กว้าง+ยาว+สูง ไม่เกิน 250 ซม.
              ด้านที่ยาวที่สุดไม่เกิน 150 ซม. และน้ำหนักไม่เกิน 30 กก.
            </li>
            <li>
              พื้นที่ห่างไกลและหมู่เกาะ เก็บค่าบริการเพิ่ม 50 บาทต่อกล่อง
              รายละเอียดพื้นที่ห่างไกลตามเอกสารแนบท้าย
            </li>
            <li>
              ผู้ขอใช้บริการต้องทำรายการให้เรียบร้อยแล้วก่อนเวลา 11.30 น.
              จะเข้ารับในวันเดียวกัน หากทำรายการเสร็จเรียบร้อย หลัง 11.30 น.
              ขนส่งจะติดต่อเข้ารับในวันถัดไป
            </li>
            <li>
              พัสดุจะจัดส่งถึงปลายทางกรุงเทพฯ และปริมณฑล ภายใน 1-2 วันทำการ
              พื้นที่ต่างจังหวัด 1-3 วันทำการและพื้นที่ห่างไกล 3-4 วันทำการ
              (ไม่นับวันเข้ารับ) ยกเว้นกรณีเกิดปัญหาในการจัดส่ง
            </li>
            <li>
              ชดใช้ค่าเสียหายหรือชำรุด ตามมูลค่าจริงแต่ไม่เกิน 300 - 2,000 บาท
              โดยเงื่อนไขเป็นไปตามที่ขนส่งกำหนด
            </li>
            <li>
              กรณีพัสดุมีการตีคืน ทางผู้ให้บริการจะคิดค่าบริการตีคืน 50%
              ของราคาค่าขนส่ง{' '}
            </li>
            <li>
              บริษัท ชิปป๊อป จำกัด
              ขอสงวนสิทธิ์ในการเปลี่ยนแปลงอัตราค่าขนส่งโดยแจ้งล่วงหน้าไม่น้อยกว่า
              7 วัน{' '}
            </li>
            <li>ราคาดังกล่าวข้างต้น ยังไม่รวมภาษีมูลค่าเพิ่ม (ถ้ามี)</li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              The courier picks up only in Bangkok, with a minimum pickup of 20
              pieces per point, providing service Monday - Saturday, closed on
              Sunday.
            </li>
            <li>
              The above shipping prices are calculated by destination
              <ul>
                <li>
                  Bangkok/metropolitan, only destinations in the areas of
                  Bangkok, Nonthaburi, Samut Prakan, and Samut Sakhon only.
                </li>
                <li>
                  Provinces, destinations in other provincial areas not in
                  Bangkok and the metropolitan area.
                </li>
              </ul>
            </li>
            <li>
              Accepted parcel size, Width + Length + Height not exceeding 250
              cm, longest side not exceeding 150 cm, and weight not exceeding 30
              kg.
            </li>
            <li>
              Remote areas and islands, an additional fee of 50 baht per box is
              charged. Details of remote areas are per the attached document.
            </li>
            <li>
              The requester must complete the shipment before 11:30 to be picked
              up the same day. If the shipment is completed after 11:30, the
              courier will contact for pickup the next day.
            </li>
            <li>
              The parcel will be delivered to Bangkok and metropolitan
              destinations within 1-2 business days, provincial areas 1-3
              business days, and remote areas 3-4 business days (not counting
              the pickup day), except in cases of delivery problems.
            </li>
            <li>
              Compensation for damage or defects at the actual value but not
              exceeding 300 - 2,000 baht, with conditions per the courier's
              specification.
            </li>
            <li>
              In the case of a parcel being returned, the service provider will
              charge a return fee of 50% of the shipping price.{' '}
            </li>
            <li>
              Shippop Company Limited reserves the right to change the shipping
              rate with advance notice of no less than 7 days.{' '}
            </li>
            <li>The above prices do not yet include value-added tax (if any).</li>
          </ul>
        </>
      ),
      [trans(
        'ZTO เงื่อนไขการใช้การบริการเก็บเงินปลายทาง ',
        'ZTO Cash on Delivery terms of service '
      )]: trans(
        <>
          <ul>
            <li>
              กำหนดการใช้บริการ COD ยอดขั้นต่ำของสินค้า คือ 100 บาท
              สูงสุดไม่เกิน 30,000 บาท
            </li>
            <li>ผู้ให้บริการจะคิดค่าธรรมเนียมเก็บเงินปลายทางอยู่ที่ 3 % </li>
            <li>
              ผู้ให้บริการจะทำการโอนเงินที่จัดส่งสำเร็จและชำระมาเรียบร้อยแล้วในระยะเวลาประมาณ
              3-5 วันทำการ โดยจะทำการโอนเงินที่รับชำระมาแล้ว มี 2 แบบ
              คือโอนคืนทุกวันจันทร์-ศุกร์ หรือ ทุกวันศุกร์{' '}
            </li>
            <li>
              บัญชีธนาคารสำหรับการโอนเงินคืนจำเป็นต้องใช้บัญชีของผู้ขอใช้บริการหรือนามบริษัทที่เปิดใช้งานเท่านั้น
              (หากมีการเปลี่ยนแปลงต้องแจ้งก่อนวันโอนเงินคืนล่วงหน้าอย่างน้อย 7
              วันทำการ)
            </li>
            <li>
              หากผู้ขอใช้บริการยังไม่มีการยืนยันบัญชีธนาคารทางบริษัทขอสวนสิทธิ์ในการโอนเงินเข้าบัญชีอื่นๆ
            </li>
            <li>
              ยอดโอนคืนขั้นต่ำ 500 บาท หลังหักค่าธรรมเนียม COD (3%) แล้ว
              ค่าธรรมเนียมในการโอนขึ้นอยู่กับธนาคารของผู้ใช้งาน
            </li>
          </ul>
        </>,
        <>
          <ul>
            <li>
              The COD service requires a minimum item amount of 100 baht, up to
              a maximum of 30,000 baht.
            </li>
            <li>The service provider charges a Cash on Delivery fee of 3%. </li>
            <li>
              The service provider will transfer the successfully delivered and
              paid amount within approximately 3-5 business days. The collected
              payment is transferred in 2 ways: refunded every Monday-Friday or
              every Friday.{' '}
            </li>
            <li>
              The bank account for the refund transfer must use the account of
              the requester or the activated company name only (if there is a
              change, it must be notified at least 7 business days in advance of
              the refund transfer date).
            </li>
            <li>
              If the requester has not yet verified the bank account, the
              company reserves the right to transfer the money to other
              accounts.
            </li>
            <li>
              The minimum refund transfer amount is 500 baht after deducting the
              COD fee (3%). The transfer fee depends on the user's bank.
            </li>
          </ul>
        </>
      ),
    },
    [trans('การประกัน & เคลม', 'Insurance & Claims')]: {
      subtitle: trans(
        'รายละเอียดเกี่ยวกับประกันสินค้า รวมถึงการเคลมสินค้า',
        'Details about product insurance, including product claims'
      ),
      [trans(
        'การประกันหรือเคลมสินค้า เนื่องจากสินค้าเสียหาย',
        'Product insurance or claim due to damaged product'
      )]: trans(
        <>
          <p>กรณีสินค้าเสียหาย</p>
          <img
            src="/static/img/faq/claim-sla-by-courier.png"
            alt="ระยะเวลาการคุ้มครองพัสดุของแต่ละขนส่ง"
            style={{ maxWidth: '100%', width: 640 }}
          />
          <br />
          <p>
            <strong>ขั้นตอนดำเนินการเพื่อขอเคลมสินค้ากับทางชิปป๊อป</strong>
          </p>
          <ol>
            <li>
              หลักฐานการขอเคลมสินค้า ดังนี้
              <ol>
                <li>
                  ภาพความเสียหายของสินค้า และภาพกล่องของพัสดุที่เสียหาย
                  (กรณีสินค้าเสียหาย)
                </li>
                <li>หมายเลขติดตามพัสดุของสินค้า (หมายเลข Tracking)</li>
                <li>
                  ใบเสร็จค่าสินค้าที่ต้องการเคลม (ตัวอย่างตามรูปด้านล่าง)
                  <br />
                  <img
                    src="/static/img/faq/claim-receipt-example.jpeg"
                    alt="ใบเสร็จค่าสินค้า"
                    style={{ maxWidth: 350 }}
                  />
                </li>
                <li>กรณีขอเคลมของขนส่งไปรษณีย์ไทย จะต้องมีใบนำฝาก</li>
              </ol>
            </li>
            <li>
              กรอกเอกสารขอเคลมสินค้า (ข้อ1) และแนบเอกสารหลักฐาน (ข้อ2)
              ส่งมาที่ฝ่ายบริการลูกค้า ได้ที่เมล cs@shippop.com หรือ Line :
              @SHIPPOP
            </li>
            <li>
              ทีมงานชิปป๊อปจะพิจารณาถึงความเหมาะสมในการขอเคลมสินค้า
              และประกันความเสียหาย หากเหมาะสมจะดำเนินการประสานงานกับทางขนส่ง
              และดำเนินการคืนเงินให้ลูกค้าทันทีหลังจากได้รับการตอบรับจากทางขนส่ง
            </li>
          </ol>
          <p>
            * ถ้าหากใช้ไปรษณีย์ไทย จะต้องมีใบนำฝาก และใบเสร็จ
            แต่ถ้าหากเป็นขนส่งอื่นๆ สามารถใช้เฉพาะ ใบเสร็จ อย่างเดียวได้
          </p>
        </>,
        <>
          <p>In case the product is damaged</p>
          <img
            src="/static/img/faq/claim-sla-by-courier.png"
            alt="Parcel protection period by courier"
            style={{ maxWidth: '100%', width: 640 }}
          />
          <br />
          <p>
            <strong>Procedure to request a product claim with SHIPPOP</strong>
          </p>
          <ol>
            <li>
              Evidence for the product claim, as follows
              <ol>
                <li>
                  Photos of the product damage and photos of the damaged parcel
                  box (in case the product is damaged)
                </li>
                <li>The product's parcel tracking number (Tracking number)</li>
                <li>
                  Receipt for the product to be claimed (example as in the image
                  below)
                  <br />
                  <img
                    src="/static/img/faq/claim-receipt-example.jpeg"
                    alt="ใบเสร็จค่าสินค้า"
                    style={{ maxWidth: 350 }}
                  />
                </li>
                <li>In the case of a Thailand Post courier claim, a deposit slip is required.</li>
              </ol>
            </li>
            <li>
              Fill in the product claim document (item 1) and attach the
              evidence documents (item 2), and send them to customer service at
              email cs@shippop.com or Line : @SHIPPOP
            </li>
            <li>
              The SHIPPOP team will consider the appropriateness of the product
              claim and damage insurance. If appropriate, they will coordinate
              with the courier and process the refund to the customer
              immediately after receiving a response from the courier.
            </li>
          </ol>
          <p>
            * If using Thailand Post, a deposit slip and receipt are required,
            but if it is another courier, only the receipt can be used.
          </p>
        </>
      ),
      [trans(
        'การประกันหรือเคลมสินค้า เนื่องจากสินค้า',
        'Product insurance or claim due to product loss'
      )]: trans(
        <>
          <p>
            กรุณาดำเนินการส่งเอกสารและหลักฐานการขอเคลมสินค้า ภายใน 10 วัน
            นับจากวันที่ได้รับแจ้งสินค้าสูญหายจากทางชิปป๊อป
            เนื่องจากบางขนส่งจะไม่สามารถทำเรื่องขอเคลมได้
            หากระยะเวลาเกินวันที่กำหนด
          </p>
        </>,
        <>
          <p>
            Please submit the documents and evidence for the claim within 10
            days from the date you are notified of the product loss by SHIPPOP,
            because some couriers cannot process a claim if the time exceeds the
            specified date.
          </p>
        </>
      ),
    },
  }
}

export default getFaqLocal
